var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCer2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 5003.3467,
    height: 3333.3333,
    viewBox: "0 0 5003.3467 3333.3333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(286.482,729.87,-730.155,286.371,12744.1,16577.7)",
    spreadMethod: "pad",
    id: "linearGradient22"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5982af"
    },
    offset: 0,
    id: "stop21"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#7dadd3"
    },
    offset: 1,
    id: "stop22"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13219.9,17228.5 c -68.4,-170 -239.5,-330.1 -359.8,-469.1 -132.3,-152.8 -278.5,-361.7 -449,-468.8 66.2,149.9 177.4,279.7 273.9,410.9 l 366.4,499.8 c 63.6,82.5 80.6,84.3 181.5,97.7 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path22"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1280.59,101.843,-101.883,-1280.09,14666.7,17172.2)",
    spreadMethod: "pad",
    id: "linearGradient32"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d6194"
    },
    offset: 0,
    id: "stop31"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#7386ad"
    },
    offset: 1,
    id: "stop32"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13392.4,17278.1 -32,75.4 -43.4,-25.3 -69.3,19.7 -5.3,23.4 c -5.7,24.6 -14.4,42.9 -27.5,64.6 l 28.8,38.7 119.1,6.9 13.6,-60.6 1056.6,-299 c 139.1,-44.4 298.4,-87.6 423.3,-164 -186.8,-6.3 -364.4,43.4 -544.6,87.3 l -898.7,217.2 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path32"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(118.278,-1692.71,1693.37,118.232,19124.4,23914.8)",
    spreadMethod: "pad",
    id: "linearGradient65"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3dab9e"
    },
    offset: 0,
    id: "stop64"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#44aece"
    },
    offset: 1,
    id: "stop65"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17328.7,22921.4 c 57.8,159.3 105.7,293.9 268.7,369.5 85.1,39.4 165.7,45.8 257,25.1 l 96.5,-24 c 4,-1 8.5,-5.5 12,-3.2 27.9,18.7 91.1,185.1 117.4,225.7 236.1,364.5 693.2,490.6 1094.4,339.9 222.8,-83.6 403.7,-267.3 515.9,-475.3 11.2,-20.8 51.3,-122.7 65,-132 7.7,-5.1 18.3,-2.9 27.5,-4.3 l 20.8,11.4 c 103,55.8 195.4,77.7 311,46.2 126.5,-34.5 235.4,-143 293.7,-257.5 55.9,-109.8 70.6,-235.9 80.1,-357 106,62.1 206.5,120.7 334,88.8 92.6,-23.1 179.2,-97.3 226,-180 32.3,-57.1 57.3,-156.1 36.5,-222 -9.1,-29.1 -29.9,-50.5 -51.8,-70.5 -226.6,34.8 -488.6,9.2 -719.2,9.2 -17.6,171.1 -29.6,309.3 -153.2,440.4 -126.1,133.7 -257.3,137.8 -430.6,140.1 l -20.6,0.1 -112.8,166.6 c -145.2,205.1 -359.4,343.6 -608.3,381.6 -293.5,44.9 -563.7,-14.8 -805.2,-189.3 -140.4,-101.4 -242.1,-225.5 -326.8,-374.9 -49.8,32.9 -101.2,68.7 -157.5,89.3 -131.7,48.2 -249.7,12.1 -370.5,-43.9 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path65"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2269.83,1028.99,-1029.4,2268.94,19958.5,15920.1)",
    spreadMethod: "pad",
    id: "linearGradient89"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5f87a3"
    },
    offset: 0,
    id: "stop88"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#93a4b4"
    },
    offset: 1,
    id: "stop89"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20792.2,19197.9 c 80.5,6.5 115.5,19.1 176.9,73.1 192.3,-217 323.5,-457.9 469.2,-706.4 l 527.3,-930.8 c -66.1,-84.5 -131.9,-155.3 -214.3,-224 -185.9,278.6 -341.1,580.5 -504.4,872.8 -57.2,102.4 -127.5,274.5 -211.3,353.5 l 40.1,-1692.5 c 5.9,-239.8 -17.1,-512.8 19.4,-747.9 303.5,-167.8 502,-390.2 704,-667.5 l -160.7,-1060.4 c -48.1,-281.1 -84.3,-568.6 -184.7,-836.5 l -313.9,269.3 c -42.3,-87.4 -23.7,-232.3 -23.6,-329.1 0,-2.7 0.7,-45.2 0,-45.9 -7.8,-8.8 -21.7,-9.3 -32.5,-14 l -61.2,51 -88,104.4 c -82.3,84.9 -174.6,205.8 -285.1,251 l -95.9,24.8 c 1,147.7 11.4,304.1 -4.4,450.7 l 56,2000.6 101.5,2831.8 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path89"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-319.848,-9.12696,9.13052,-319.723,10408.8,16932.4)",
    spreadMethod: "pad",
    id: "linearGradient154"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#96c9e2"
    },
    offset: 0,
    id: "stop153"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c3ecfb"
    },
    offset: 1,
    id: "stop154"
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10220.1,20227.3 11.5,-221.2 18.2,355.3 36.6,10.8 c 38.2,-83.1 -1.2,-168.7 35.8,-253.2 l 26.6,-76 8.9,-171.8 20.5,-419 c 5.4,-126.8 -3.4,-278.2 25.6,-401.1 -28.1,-67.1 -19.6,-141.4 -19.3,-212.9 l 3.2,-410.6 0.2,-4736 -74.2,-73.9 -141.7,-135.3 c -33.4,130.5 -15.3,297.3 -15.6,432.2 l -0.8,821.9 9.3,3690.2 -0.2,617.9 c -2.7,211.2 16.1,422.6 24.4,633.7 7.3,182.3 3.3,368.5 31,549 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path154"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(346.729,-336.193,336.324,346.594,21920,12936.6)",
    spreadMethod: "pad",
    id: "linearGradient200"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#324f93"
    },
    offset: 0,
    id: "stop199"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#436bad"
    },
    offset: 1,
    id: "stop200"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22167.8,13225.9 c 102.4,1.3 538.8,35.6 594.3,-18.4 l -93.8,-84.8 c -0.3,-81.5 -70.5,-130.3 -110.2,-201.5 -28.7,-51.3 -78.6,-93.4 -109.9,-146.5 -47.8,-80.9 -119.3,-152.5 -174,-228.8 -61.9,-86.4 -111.6,-174.2 -194,-244.6 -182.4,-40.4 -424.1,-7.3 -613.6,-12.4 l 134.8,234.2 20.7,-32.7 c 83.8,72.5 134.6,212.1 202.3,300 40.6,52.8 97.5,91.1 139.3,142.9 73.4,90.9 137.5,196.5 204.1,292.6 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path200"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(395.519,-345.635,345.77,395.365,22657.9,14035.7)",
    spreadMethod: "pad",
    id: "linearGradient202"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2a4079"
    },
    offset: 0,
    id: "stop201"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c5c9e"
    },
    offset: 1,
    id: "stop202"
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22788.3,14314 c 138.8,2.7 711.4,43.2 805.8,-12.2 -23.8,-52.9 -47,-81.6 -88.5,-121.8 -33.3,-32.2 -69.9,-93.2 -95.7,-132.3 -55.1,-83.4 -136.7,-147.8 -183.2,-238.1 -49.6,-96.3 -160.7,-181.6 -214.6,-279.3 -19.3,-34.9 -62.1,-56.3 -73.8,-91.7 -9.7,-29.1 -45.8,-53.5 -68.6,-73.9 l -78.1,-30.4 -39.8,15.6 -536.5,-11.6 170.6,233 c 49.4,63.9 108.3,115.1 126.6,197 4.9,21.5 8.6,31.7 21.3,50.4 57.4,84.2 232.6,274.1 239.5,364.9 l 0.2,10.4 41.2,27.4 -18.3,27.7 c 1,23.4 -2.7,42.1 -8.1,64.9 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path202"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-383.612,292.505,-292.619,-383.462,24980.9,12619.3)",
    spreadMethod: "pad",
    id: "linearGradient205"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#304a85"
    },
    offset: 0,
    id: "stop204"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#466aa5"
    },
    offset: 1,
    id: "stop205"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24802.6,13221.9 c 90.4,22.3 186.2,11.4 278.7,10.3 l 389.6,5.1 21.7,-27.2 -43.2,-62.1 1.7,-43.6 c -35.4,-34.5 -58.6,-57.1 -81.3,-100.6 -75.3,-144.4 -243.8,-261.6 -324.4,-407.6 -39.1,-70.6 -113.6,-124.2 -151.7,-196.8 l -79.3,-98.3 c -115.1,-26.7 -257.7,-11 -375.9,-10.6 -110,0.2 -248.3,-15.6 -353.1,19.8 l 48.3,70.7 540.2,695.8 c 30.8,59.1 79.7,98.3 128.7,145.1 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path205"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-392.408,314.628,-314.751,-392.255,25829.2,13693.5)",
    spreadMethod: "pad",
    id: "linearGradient207"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#29417d"
    },
    offset: 0,
    id: "stop206"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#40609f"
    },
    offset: 1,
    id: "stop207"
  })), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 25605.2,14308.5 c 103.8,30.1 219.6,19.7 326.8,19.3 140.9,-0.5 285.7,5.3 425.9,-6.6 l 20.1,-15.4 c -22.3,-75.5 -85.3,-159.2 -138.5,-213.7 -25.7,-26.4 -73.3,-59.7 -91.1,-90.3 -30.1,-51 -82.6,-81.5 -109.9,-128.2 -66.5,-113.1 -174.4,-209.8 -247.2,-320.4 -31.3,-47.3 -113.3,-106 -129.2,-160.9 l -59.8,-30.7 c -88.4,-28.5 -214.2,-10.3 -307.5,-8.4 l -209.1,-0.6 c -49.6,-4.5 -96.7,-1.5 -146.3,2.1 -1.5,37.1 24.7,58.5 46.4,87.5 62.5,83.1 187.8,207.3 196.1,307.7 86.5,134.1 206.9,268.2 307.3,393.8 40,50.1 98.9,102.9 116,164.8 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path207"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-381.745,303.888,-304.007,-381.596,24173.9,11519.3)",
    spreadMethod: "pad",
    id: "linearGradient210"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2b4275"
    },
    offset: 0,
    id: "stop209"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#40609c"
    },
    offset: 1,
    id: "stop210"
  })), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 23989.5,12127.1 c 94.5,64.8 280.6,37.1 397.9,37.7 l 166.6,2.8 194.2,-5 c -41.8,-40.3 -73.8,-69.7 -101.9,-120.5 -30.5,-54.9 -99.1,-95.8 -128.2,-146.5 -80.1,-139 -200.7,-256.1 -283.9,-393.7 -31.4,-52 -81.4,-90.1 -109.9,-146.5 -20.9,-41.4 -63,-72 -86.1,-113.8 -18.9,-34.2 -48.4,-61.2 -75.3,-89 l -11.3,-6.2 c -104.9,-42.7 -357.8,-3 -477.5,-4 -75.7,-0.7 -151.1,-18 -222.9,11 0,29.5 4.7,40.2 21.4,64.4 l 18.3,-18 53.4,54.8 -34.9,18.3 18.2,18.1 18.3,-17.9 53.2,54.7 -34.7,18.3 36.4,36.5 18.4,-18 18.1,18.2 -36.3,18.3 c 37.4,34.9 51.7,71.6 86.7,105.8 16.7,16.2 33.2,29.9 45.6,49.9 75.5,121.3 171.9,233.6 261.5,345.6 28.8,36 84.6,87.1 98.5,128.7 10.5,31.4 69.7,72 96.2,96 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path210"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-448.25,511.722,-511.922,-448.075,22814.6,11407)",
    spreadMethod: "pad",
    id: "linearGradient213"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3a5c9d"
    },
    offset: 0,
    id: "stop212"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4a76b2"
    },
    offset: 1,
    id: "stop213"
  })), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath213"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22577.6,12161.3 750,5.3 13.6,-23.8 -11,-34.4 c -21.9,-19.2 -69.5,-51.9 -78,-77.3 -14,-41.8 -63.3,-80.5 -89.5,-117.4 l -366.2,-485.1 c -54.9,-76.3 -140.2,-166 -172.9,-253.4 -86.1,-56.4 -174.5,-37.1 -276.3,-37.4 l -466.8,-1 -21.3,15.7 57.7,74.6 -17.9,27.5 586,787.3 c 27.1,46.9 56.2,79.5 92.6,119.4 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path213"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(426.754,-555.804,556.02,426.587,24006.4,14124.8)",
    spreadMethod: "pad",
    id: "linearGradient215"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#395598"
    },
    offset: 0,
    id: "stop214"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#476ead"
    },
    offset: 1,
    id: "stop215"
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24219,14316.6 c 128.4,9.4 706.2,39.7 781,-12.7 -20.5,-56.4 -40.6,-82.7 -83.8,-123.9 -47.4,-45.3 -95.7,-131.7 -132.4,-187.2 -16.1,-24.2 -48.3,-40.1 -64.2,-64.2 -87.7,-132.7 -230.3,-255 -302.2,-393.7 l -165.4,-182.7 c -153.1,-14.9 -312,-7.9 -465.8,-8.8 -102.7,-0.6 -218.7,-12.4 -319.1,10.6 26.3,74.3 89.9,135.9 135.4,199.1 l 320.5,421.2 27.4,0.1 82.3,91.6 c 26.6,50.9 98.5,111.4 114.6,160.1 10.5,31.6 48.7,65.3 71.7,90.5 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path215"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1189.46,-1078.61,1079.03,-1189,20959.8,11065)",
    spreadMethod: "pad",
    id: "linearGradient217"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b5e9e"
    },
    offset: 0,
    id: "stop216"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4f89ba"
    },
    offset: 1,
    id: "stop217"
  })), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20333.5,11008.4 554.1,1.6 c 91,0.3 161.8,14.1 242.3,-29.5 l -567.1,-729.5 c -57.3,-69.6 -109,-150.3 -172.5,-213.9 -125.5,-34.6 -660.4,-40.6 -779.1,2.6 100.1,197.9 253.7,367.9 383.6,546.4 l 173.1,219.7 c 37.2,72.4 105.8,143.7 165.6,202.6 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path217"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(420.779,-639.398,639.648,420.615,20983,11980.2)",
    spreadMethod: "pad",
    id: "linearGradient219"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#365a9c"
    },
    offset: 0,
    id: "stop218"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4a77b5"
    },
    offset: 1,
    id: "stop219"
  })), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath219"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21202.4,12154.8 c 99.3,28.4 228.7,14.2 332.2,14.9 139,0.8 309.4,21.1 444.5,-10.8 -48,-46.7 -95.9,-85.8 -126,-144.3 l -145.9,-183.2 25.3,-27.4 -11.4,-11 c -59.7,-58.5 -118.7,-147.3 -161.3,-217.8 -46.5,-77.1 -123.3,-137.8 -164.8,-219.8 -20.6,-40.7 -62.1,-73.4 -86.3,-113.7 -15.2,-25.2 -30.1,-36.9 -52.6,-55.4 -115.1,-70.1 -243.2,-47 -375.9,-47.3 -153,-0.2 -311.2,-9.1 -463.3,8.9 l 447,591.9 c 22.3,42.1 46.5,66.7 75.6,104.8 52.4,68.4 122.7,116.1 173.3,186.7 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path219"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-266.401,484.531,-484.72,-266.297,21970.4,10372.3)",
    spreadMethod: "pad",
    id: "linearGradient223"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#314a82"
    },
    offset: 0,
    id: "stop222"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#456da9"
    },
    offset: 1,
    id: "stop223"
  })), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21788.5,11006.3 696.5,9.5 18.3,-23.2 c -12,-21.3 -28.8,-44.9 -36.9,-67.8 l 91.8,83.8 c 54.8,3.5 121.5,15.4 174.1,-1.3 l 3.6,-18.6 -496,-660.7 c -69.9,-92.5 -143.8,-218.2 -230.2,-291.4 l -228.2,0.2 c 49,63.7 103.5,127.4 141,198.6 -59.6,-55.9 -115.3,-141.6 -175.1,-189.6 -16.3,-13.1 -101.2,-13.2 -124.6,-14.2 l -123,7.6 -310.9,-8.3 c -56.4,-1.6 -98.6,-3.3 -152.1,18.7 75.1,68.8 128.5,163.1 195.9,239.5 31.8,36 48.1,67.9 66,112.4 -11.6,79.9 301.1,413.6 356.3,508 19.8,34 45.1,63.7 69.8,94.3 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path223"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(435.233,-276.004,276.111,435.063,24949.1,12237.4)",
    spreadMethod: "pad",
    id: "linearGradient233"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3e2f29"
    },
    offset: 0,
    id: "stop232"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2b2e42"
    },
    offset: 1,
    id: "stop233"
  })), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 26912.4,14358 4.6,-35.1 -12,-53.9 45,-47.4 -10.8,-630.5 c 0.8,-80.5 -8.8,-177.6 9.5,-254.7 l -25.8,-2.6 -732.3,2.9 c -33.7,-91.4 -145.5,-234.6 -220.5,-296.9 -31,-65.8 -86.7,-136.2 -144.4,-181.4 -53.2,-115.9 -198.3,-303.6 -295.5,-386.7 -59.6,-112.3 -160.9,-243.7 -253.7,-330.3 -41.8,-64.8 -87,-119.6 -139.3,-176.1 l -14.4,-21.8 -17.5,-21.5 -318,-451 -267.7,-366.9 -406.2,-562.2 -563.8,-782.5 c -75,45.4 -77.5,67.6 -112.6,145.3 l 762.9,1053.3 1506.7,1990.3 c 79.8,106.5 604.2,716.9 610.1,804.6 77.6,47.6 136.2,148.3 192.2,220.4 l 233.5,297.7 c 14.4,16.7 54.4,66.5 73.7,74.9 20.5,8.9 72.3,9.1 96.3,12.1 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path233"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1928.2,593.349,-593.581,1927.45,29575,10451.9)",
    spreadMethod: "pad",
    id: "linearGradient248"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#267335"
    },
    offset: 0,
    id: "stop247"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#225945"
    },
    offset: 1,
    id: "stop248"
  })), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 29802.9,12545.5 c 108.2,-35.2 206.4,-126.7 293.8,-197.3 238.6,-192.3 465.8,-401.5 673.4,-626.8 53.7,-58.3 147,-142.7 180.2,-213.6 l 6.4,-22.6 c 39.3,-36.3 63.7,-63.1 82.8,-113.5 82.3,-58 268.1,-287.3 295.2,-383.7 l 3.2,-18.7 36.6,-59.1 c 18.4,-19.6 45,-41.4 55,-66.2 l 37.9,-63 c 77.1,-72.7 222.7,-227.6 254.4,-327.6 l 9.6,-41.3 c -166.8,-201.7 -279.9,-419.6 -331.5,-677.4 -15.6,-78.7 -10.2,-159.8 -51,-230.8 48.8,-81.5 30,-204.3 27.8,-296.7 -233.9,-54.2 -444,-151.8 -577.1,-363.7 l -9.8,-16.1 c -14.6,-21.9 -31.2,-30 -54.2,-41.7 -68.4,64.1 -159.7,118.9 -240.1,168.1 l -654.3,438 c 9.1,16.5 28.1,41.4 32.5,58.8 10.3,37.9 -1.9,114.9 -2.7,158.1 l -7.5,436.9 -33,1595.4 c -5.9,297.1 6.3,609.7 -27.6,904.5 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path248"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1619.54,756.994,-757.289,1618.91,24173.2,10064.2)",
    spreadMethod: "pad",
    id: "linearGradient263"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#459bc7"
    },
    offset: 0,
    id: "stop262"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#478fd3"
    },
    offset: 1,
    id: "stop263"
  })), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24519.6,11104.1 267.7,366.9 10.9,-612.6 998,1.9 c 49.6,-67.5 45.2,-129.8 45.2,-210.1 l -32.7,-42.3 -659,-3.3 c -115,-0.4 -242,9.7 -355.6,-4.1 l 8.3,-1212.4 -237.6,-168.9 -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path263"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-297.585,-386.794,386.945,-297.469,12488.8,9295.7)",
    spreadMethod: "pad",
    id: "linearGradient305"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4bb0be"
    },
    offset: 0,
    id: "stop304"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4babda"
    },
    offset: 1,
    id: "stop305"
  })), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath305"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11992.9,9058.5 0.9,154 c 38.2,30.7 113.2,18 162.8,17.9 l 502.9,-0.4 c 0.4,-68 -14.5,-195.9 14.4,-253.8 l -676.8,-1.2 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path305"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1639.67,25.8133,-25.8234,-1639.03,23471.8,8244.7)",
    spreadMethod: "pad",
    id: "linearGradient364"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a3b4aa"
    },
    offset: 0,
    id: "stop363"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c7eadc"
    },
    offset: 1,
    id: "stop364"
  })), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24113.4,10541.9 3.2,-1131.2 c -0.3,-142.1 -27.1,-353 11.8,-487.2 l -635.8,-450.7 -81.8,-75.4 c 23.2,-29.6 38.2,-36.3 71.9,-49.8 l 4.8,-88.7 9.9,0.6 c 176.2,-51.9 445.6,-16 632.7,-14.9 l 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c 57.3,-111.4 73.8,-169.8 50.9,-296.2 l -38.1,-51.6 c -80.6,1 -172.4,-6.3 -251.3,7.1 l -2566.8,15 -529.5,4.3 2.7,226.7 3.8,206.2 26.4,18.4 13.2,5.3 c 91.8,34.3 304.3,70 393.3,28.9 l -1.6,3274.1 42.7,16.4 253.5,-11.6 637.3,4.6 1245.8,13 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path364"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-29.7767,-466.19,466.372,-29.765,22643.6,6406.2)",
    spreadMethod: "pad",
    id: "linearGradient383"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#789393"
    },
    offset: 0,
    id: "stop382"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#758ca5"
    },
    offset: 1,
    id: "stop383"
  })), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath383"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 23487.5,8258.9 9.9,0.6 c 176.2,-51.9 445.6,-16 632.7,-14.9 l 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c 57.3,-111.4 73.8,-169.8 50.9,-296.2 l -38.1,-51.6 c -80.6,1 -172.4,-6.3 -251.3,7.1 l -2566.8,15 -529.5,4.3 2.7,226.7 3.8,206.2 26.4,18.4 13.2,5.3 c 91.8,34.3 304.3,70 393.3,28.9 9.3,-19.7 17.5,-43.7 31.7,-60.1 l 400.2,3 499.4,5.5 636.4,2.4 558.7,-2.7 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path383"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(399.349,-78.3488,78.3794,399.193,23946.9,7022.6)",
    spreadMethod: "pad",
    id: "linearGradient388"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#73756c"
    },
    offset: 0,
    id: "stop387"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6d6e7b"
    },
    offset: 1,
    id: "stop388"
  })), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24136.3,7757.1 c 1.7,108.1 -8.8,234.1 20.3,338.1 45,4.6 73.7,-17.4 113.3,-36.9 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c -64.5,57.9 -116.6,93.9 -205,95 l -1715.5,0.8 c -305.2,-1.5 -641.4,-32 -943.2,8.2 l 400.2,3 499.4,5.5 636.4,2.4 558.7,-2.7 634.1,0.6 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path388"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(113.53,-1234.57,1235.05,113.486,20489.1,9804.3)",
    spreadMethod: "pad",
    id: "linearGradient439"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2e8487"
    },
    offset: 0,
    id: "stop438"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4ab2a5"
    },
    offset: 1,
    id: "stop439"
  })), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20707.6,9909.1 41.6,-2.9 32.2,-62.4 111.1,-16.5 c -58.5,-210.8 -114.5,-423.6 -202.2,-624.6 -121.7,-278.9 -293.6,-528.3 -480.8,-766.4 l -107,1323.8 c 253.8,-0.3 402.7,-21.1 605.1,149 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path439"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(785.565,49.5195,-49.5389,785.258,19812.5,8256.7)",
    spreadMethod: "pad",
    id: "linearGradient441"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#343334"
    },
    offset: 0,
    id: "stop440"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2d2b42"
    },
    offset: 1,
    id: "stop441"
  })), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath441"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19749.4,9761.1 353.1,-1 107,-1323.8 c 39.1,-430.6 39.5,-932.6 177.6,-1340.1 l 20,-1.4 c 87.2,-6.7 218.7,-24.1 276.4,-97.4 11.5,-14.5 16.4,-29.6 22.3,-47 -182.8,-194.9 -484,-175.3 -734.4,-183.4 l -56.6,-1.7 -93.1,5.2 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 l 4,13.1 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path441"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(17.1967,-1355.33,1355.86,17.19,19729.7,8643.1)",
    spreadMethod: "pad",
    id: "linearGradient444"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#63656d"
    },
    offset: 0,
    id: "stop443"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a1a09e"
    },
    offset: 1,
    id: "stop444"
  })), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19860.1,9564.5 c 7.5,57.9 14.7,113.7 31.6,169.9 l 19.8,-2460.5 -66.2,-23.8 -22.5,-226.7 -1.1,-252.9 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 3.9,-71.5 -1,-175.5 23.4,-241.7 25.7,-70.1 15.7,-167.4 16.1,-242.8 l 18.3,-9.2 4.6,311.5 c 27.9,-108.3 17.6,-244.7 21.6,-357.2 z",
    transform: "translate(0,-2.5000001e-4)",
    id: "path444"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 0,25000 h 37482.6 c 14.9,-22.1 29.1,-46.4 32,-73.3 23.2,-205.9 0.8,-444.5 1,-653.4 l 1,-1452 1.7,-4770.6 -0.5,-12571.7 -1.5,-3770.8 -0.9,-1142.798 c 0,-159.199 18.3,-344.902 -0.8,-501.2028 C 37511.7,40 37497.1,18.6016 37482.6,0 H 0 v 25000",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 10253.8,20961.4 c -97.1,-2.8 -219.7,-22.8 -301.85,31.7 -6.76,43.9 -11.87,70.1 7.87,110.9 73.38,38.4 221.08,19.3 305.38,19.6 13.4,-60.5 20.5,-108.6 63,-156.4 l -1.4,-8.8 c -14,-28.8 -17.6,-57.2 -22.3,-88.4 h -10 l -4.5,55 -23.2,-55 -13,91.4",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 10265.2,21123.6 c 106.2,-0.8 324.6,22.5 410.5,-27.1 16.5,-50.4 16.5,-54.5 -0.3,-104.8 -81.7,-47.2 -250.6,-18.1 -347.2,-24.5 -42.5,47.8 -49.6,95.9 -63,156.4",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 20624.2,19284.3 c -12.7,15 -25.8,29.7 -35,47.2 -30.7,58.5 -37.1,149.6 -10,210.4 25.9,57.9 85.4,119.2 145.6,138.7 66.6,21.7 124.3,20.2 187.8,-10.4 9.2,-44 20.1,-84.9 35.8,-127.1 -28.1,5.7 -43.4,16.6 -66.2,33.3 -73.5,-26.7 -114.6,-31.2 -151.3,-107.5 -36,-75 -45.3,-122.6 -106.7,-184.6",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 10253.8,20961.4 13,-91.4 23.2,55 4.5,-55 h 10 c 4.7,31.2 8.3,59.6 22.3,88.4 4.8,-163.8 -18.3,-423.2 35.6,-576.3 l 0.8,-11 c -26.7,-103 -15.1,-222.1 -14.4,-328.1 l -26.6,76 c -37,84.5 2.4,170.1 -35.8,253.2 l -36.6,-10.8 -18.2,-355.3 -11.5,221.2 33.7,734.1",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 29273.1,17526 c -27.6,87.2 -24.1,168.4 -16.8,257.9 54.7,67.5 117.5,115.6 205.4,131.7 62.3,11.4 141.4,5.5 193.7,-33.1 39,-28.8 40,-34.2 48.3,-82 -75,2.5 -198.1,15.4 -257.4,-37.2 -56.4,-50 -62.8,-116.2 -62.3,-186.3 0.3,-23.8 5.9,-41 14.7,-62.8 l -16.1,-24.8 c -45.7,33.3 -52.8,34.4 -109.5,36.6",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 16462,21392.9 c 81.4,0.8 189.6,13.7 267.7,-6 40,-10 60.1,-31.9 76.8,-69.7 22.6,-51.5 6.3,-102.3 -10.9,-152.3 -103.2,-34.7 -241.4,-16 -350,-14.1 l 16.4,242.1",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 16408.8,22570.1 20.9,-4.5 c 57.2,-14.4 95.7,-58.4 121.9,-108.5 10.5,-20.1 -4.1,-45.7 -10.5,-67 -71.9,-83.2 -168,-125.3 -264.4,-174.1 l -47,-11.6 c -43.4,36.7 -64.8,121.3 -85.8,174 l 264.9,191.7",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 13979.5,23461.7 c 40.2,-2.3 80.5,-14.7 119.7,-24.2 65.9,-66.8 84.9,-232.1 96.1,-323.9 -31,-38.3 -95.4,-47.2 -141.5,-60.2 -34.4,-11.8 -50,-18.3 -86.6,-8.9 l -94.5,298 c 19.6,54.7 63.7,81.3 106.8,119.2",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 12432.5,21429.1 353.4,-17.2 -13.2,-224.1 -39.2,-13 c -100.4,-7.9 -205.8,-23.8 -304.9,-1.8 -34.8,36.4 -57.4,49.4 -62.6,100.8 -6.6,65.5 28.1,107 66.5,155.3",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 15307.9,19522.3 c 8.2,-7.6 12,-10.4 18.7,-20.9 59,-92 138.4,-255.6 117.4,-362.2 -57.1,-62 -91.5,-65.7 -170.6,-90.4 -87.1,106.8 -129.4,270.5 -179,398.1 l 213.5,75.4",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 16195.6,20282.5 c 88,-54.1 259.2,-136.6 307.6,-227 14.2,-26.5 11.9,-54.5 1.8,-83 -18.7,-52.4 -68.3,-78.8 -114.4,-103 -66,34.7 -314.6,161.9 -335,216.6 l 140,196.4",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 13924.2,19518.4 239.2,-78.7 c -51.7,-117.5 -82.7,-240.8 -146.2,-352.7 -21.8,-6.9 -45.2,-14.1 -68.3,-14.8 -60.8,-2.1 -99.2,35.6 -138.5,76.1 -33.5,116.2 63.4,263.5 113.8,370.1",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 12854.9,22699.4 c 112.9,-1.9 247.6,-146.8 334.5,-216.1 l -132.9,-191 c -56.2,-2.7 -138.1,61.3 -184.3,92.5 -69.4,46.8 -114.1,84 -130.8,170.2 21.5,77.3 53.8,92.7 113.5,144.4",
    style: {
      fill: "#f9cb11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 13223.4,17072.2 61.7,-1498.5 -114.8,-47 27,1078.1 c 7.2,156.1 0.8,312.9 26.1,467.4",
    style: {
      fill: "#acdff3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 12981.7,20275.8 37.3,-4.4 127.3,-172.2 -332.4,-219.4 c -48.7,14 -95.5,35.4 -124.9,79.2 -34.5,51.4 -27,77 -14.4,132.6 52.1,83 218.9,140.5 307.1,184.2",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 20912.6,19670.2 c 78.9,-49.4 98.6,-81.4 121,-172.7 16.8,-68.6 -1.6,-136 -40.7,-193.4 l -23.8,-33.1 c -61.4,-54 -96.4,-66.6 -176.9,-73.1 l -85.6,28 -82.4,58.4 c 61.4,62 70.7,109.6 106.7,184.6 36.7,76.3 77.8,80.8 151.3,107.5 22.8,-16.7 38.1,-27.6 66.2,-33.3 -15.7,42.2 -26.6,83.1 -35.8,127.1",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 15297.2,23427.9 65.7,2.3 c 68.9,-1.1 102,-31.8 147.6,-79.8 27.6,-116.5 -60.4,-283 -107.1,-391.3 -87.7,23.1 -154.9,54.5 -230.9,103.7 27.8,132.5 44.9,252.7 124.7,365.1",
    style: {
      fill: "#f9cb11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 24358.8,16182.2 c 300.5,-127.2 454.1,-327.9 598.7,-608.4 -172,117.9 -286.7,216.4 -503.4,247.5 l -28.8,-29.5 c -37.9,116.8 -58.2,267.6 -66.5,390.4",
    style: {
      fill: "#ccd4d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 13219.9,17228.5 c -68.4,-170 -239.5,-330.1 -359.8,-469.1 -132.3,-152.8 -278.5,-361.7 -449,-468.8 66.2,149.9 177.4,279.7 273.9,410.9 l 366.4,499.8 c 63.6,82.5 80.6,84.3 181.5,97.7 l -13,-70.5",
    style: {
      fill: "url(#linearGradient22)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 12798,18764.5 49.9,-21.3 497.9,-1248.4 c -50,3.9 -99.3,6 -147.9,19.6 -121.3,416 -312.5,826.9 -399.9,1250.1",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m 26573.6,14594.1 c 45.7,92.2 37.9,236.6 44.9,339.7 l 355.4,-6.5 c 15.4,-97 24.2,-270.6 -32.7,-348.9 l -367.6,15.7",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 23043.1,17249.4 73.6,11.5 16.8,-8.2 2.1,-348.8 c -139.1,30.8 -315.9,16.6 -459.9,22.9 50,83 33.6,230.6 34.9,325.5 l 332.5,-2.9",
    style: {
      fill: "#f9cb11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 29382.6,17489.4 16.1,24.8 c -8.8,21.8 -14.4,39 -14.7,62.8 -0.5,70.1 5.9,136.3 62.3,186.3 59.3,52.6 182.4,39.7 257.4,37.2 49.8,-45.5 71.3,-64.9 80.9,-135.7 5.1,-39 -17.9,-57.5 -40.8,-84.4 7.8,-45.9 15.1,-49.9 -13,-89.7 -23.9,-33.5 -39.8,-48.1 -75.9,-66.8 l -51.3,-24.9 -173.4,-3.4 -107,39.7 c -6.6,37 -28.6,60.6 -50.1,90.7 56.7,-2.2 63.8,-3.3 109.5,-36.6",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 29382.6,17489.4 c 30.7,-17.1 62.7,-33.8 98.9,-31.1 75.4,5.6 141.4,34.8 191.4,91 l 57.7,64.9 8.1,10 5.1,-43.8 c 7.8,-45.9 15.1,-49.9 -13,-89.7 -23.9,-33.5 -39.8,-48.1 -75.9,-66.8 l -51.3,-24.9 -173.4,-3.4 -107,39.7 c -6.6,37 -28.6,60.6 -50.1,90.7 56.7,-2.2 63.8,-3.3 109.5,-36.6",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 31171.1,16632.6 11,179.5 c 52.7,33.1 125.5,19.6 187.6,19.6 l 558,-0.1 31.8,-27.6 1.2,-155.7 c -16.1,-11.9 -32.2,-25.7 -49.8,-35.3 -24.7,12.3 -69.1,10 -97.2,12.5 -202,30.4 -438.7,17.1 -642.6,7.1",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 28223.9,14941.4 c 8.3,14.7 30.3,43.4 33.5,58.6 21.2,105.7 -0.3,256.8 -0.5,368.9 l -1,1090.1 c -0.2,95.5 -22.7,271.7 26.6,348.9 l 30.3,-17.3 3.7,-1411.9 -0.3,-285.9 c 0,-31.8 -7.8,-91 0,-120.3 3.2,-12.2 14.2,-20.9 21.3,-31.4 l 86.7,-10.5 -45,-23.3 c -3.6,-112 18.6,-247 -37.3,-342.9 l -85,-5.6 -18.3,7.6 c 25.6,89.7 30.5,293.2 -14.7,375",
    style: {
      fill: "#c6751c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 30507,16351.1 668.7,2.7 c 3.2,-88.8 25.4,-218.3 -27.6,-293.5 l -569,-5.8 c 22.7,86.7 -31.3,218.6 -72.1,296.6",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 13392.4,17278.1 -32,75.4 -43.4,-25.3 -69.3,19.7 -5.3,23.4 c -5.7,24.6 -14.4,42.9 -27.5,64.6 l 28.8,38.7 119.1,6.9 13.6,-60.6 1056.6,-299 c 139.1,-44.4 298.4,-87.6 423.3,-164 -186.8,-6.3 -364.4,43.4 -544.6,87.3 l -898.7,217.2 -20.6,15.7",
    style: {
      fill: "url(#linearGradient32)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 17787.8,19737.5 c 121.7,51.3 390.6,-34.2 526.3,-59.3 l 1454,-283.2 c 64.8,-12.8 323.4,-83.3 372.2,-56.7 25.2,13.8 71.8,74.4 89.1,96.6 -14.9,-84.4 -33.3,-141.7 -99.5,-199.6 -105.5,-20.6 -2192,437.2 -2342.1,502.2",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 27067.7,14945.1 5.1,12 c 47.2,126.8 16.4,346.3 15.2,483.2 l -6.9,1148.6 c 1,36.1 -2.7,30.5 27.6,50.3 49.4,-60.4 23.2,-312.9 23.2,-404.9 l -0.5,-1305.3 271.6,-2.4 -4.6,-362.3 c -110.9,-13.6 -236.4,3.1 -347.6,14.2 -32.2,-5.8 -76.2,-0.5 -109.6,-0.1 56.9,78.3 48.1,251.9 32.7,348.9 32.5,2.3 62.5,10 93.8,17.8",
    style: {
      fill: "#b84520",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 26973.9,14927.3 c 32.5,2.3 62.5,10 93.8,17.8 29,-91 23.9,-281.2 -16.9,-366.6 -32.2,-5.8 -76.2,-0.5 -109.6,-0.1 56.9,78.3 48.1,251.9 32.7,348.9",
    style: {
      fill: "#d47b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 28424.2,14930.6 c 57.9,-0.2 150.9,16.3 193.4,-22.2 3.4,-95.8 30.5,-261.6 -16.6,-344.9 l 170.7,-9.6 c 41.5,-52.7 25.4,-171.2 26.2,-240.7 l -41.6,-50.2 -517,5.3 c 27.1,80.2 14.9,204.5 17.6,290.5 l 85,5.6 c 55.9,95.9 33.7,230.9 37.3,342.9 l 45,23.3",
    style: {
      fill: "#a1461e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 13232.9,17299 c 52.3,-8.9 106.4,-21.5 159.5,-20.9 l 20.6,-15.7 -33.5,-28 54.1,-1190.9 c 10,-128.1 6.5,-280.5 44.4,-402.6 l -192.9,-67.2 -61.7,1498.5 -3.5,156.3 13,70.5",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 23133.5,17252.7 442,1.1 2.7,-312.4 c 20.3,-19.9 38.4,-38.2 62.7,-53.4 13.6,-10.1 25.8,-12.8 28.4,-30.2 l 21.7,-208.7 -518.3,1.6 c -0.4,84.2 -2.9,162.8 -18.8,245.7 l -18.3,7.5 -2.1,348.8",
    style: {
      fill: "#c6751c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 28223.9,14941.4 c 45.2,-81.8 40.3,-285.3 14.7,-375 l 18.3,-7.6 c -2.7,-86 9.5,-210.3 -17.6,-290.5 -76.5,-4.6 -130.4,-2.4 -203.5,22.5 -86.7,-24.6 -299.4,-23.6 -382.9,10.5 1.7,96.1 21.2,178.5 -33.5,259.8 l 236.4,3.5 1.7,369.8 366.4,7",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 28238.6,14566.4 18.3,-7.6 c -2.7,-86 9.5,-210.3 -17.6,-290.5 -76.5,-4.6 -130.4,-2.4 -203.5,22.5 64,84.1 -7,202.2 54.3,270 l 148.5,5.6",
    style: {
      fill: "#ac601e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 22696.4,22127.9 55,-12.5 c -5.8,-37.6 -1405,-2201.4 -1445.6,-2230.2 -28.7,-20.3 -75.1,-25.8 -109.9,-20.1 l -35.7,9.2 1269.9,1934.9 150.2,223.8 c 12.2,18.6 36.2,67 51.2,78.3 10.2,7.6 50.6,12.9 64.9,16.6",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 23691,16649.1 642.1,-11.9 1.4,-279.7 -1147.1,-4.4 -11.5,4.2 c 16.3,89 -0.4,202.1 -3.2,293.4 l 518.3,-1.6",
    style: {
      fill: "#666770",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 23043.1,17249.4 v 4994.2 l 28,25 36.7,-12.9 c 23,-140.1 7.2,-302.7 6.9,-445 l -2.4,-916.4 2.1,-2239.5 2.3,-1393.9 -73.6,-11.5",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m 21160.2,19874.3 c -28.4,56.1 -117,127.8 -161.8,176.2 152.6,256.7 362,490.7 542.8,729.3 l 1013.9,1357 c 52.3,9 89.7,2.4 141.3,-8.9 -14.3,-3.7 -54.7,-9 -64.9,-16.6 -15,-11.3 -39,-59.7 -51.2,-78.3 l -150.2,-223.8 -1269.9,-1934.9",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 17787.8,19737.5 8.1,88.5 c 90.7,36.4 289,-6.9 389,-16.8 l 922,-90 c 351,-33.2 710.4,-44.3 1059,-94.7 62.8,-60.4 61.3,-102.8 63.5,-189.6 -17.3,-22.2 -63.9,-82.8 -89.1,-96.6 -48.8,-26.6 -307.4,43.9 -372.2,56.7 l -1454,283.2 c -135.7,25.1 -404.6,110.6 -526.3,59.3",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 10362.4,20382.1 903.5,2.9 -0.4,-513.2 -704.9,-0.5 -202.9,-0.1 -8.9,171.8 c -0.7,106 -12.3,225.1 14.4,328.1 l -0.8,11",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 10363.2,20371.1 178.6,-7.1 c 49.6,-63.7 19,-394.6 18.8,-492.7 l -202.9,-0.1 -8.9,171.8 c -0.7,106 -12.3,225.1 14.4,328.1",
    style: {
      fill: "#992c1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 22675.7,16926.8 c 144,-6.3 320.8,7.9 459.9,-22.9 l 18.3,-7.5 c 15.9,-82.9 18.4,-161.5 18.8,-245.7 2.8,-91.3 19.5,-204.4 3.2,-293.4 l -1285.2,5 20.6,287 733.3,-0.3 -15.3,236.1 46.4,41.7",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 22675.7,16926.8 c 144,-6.3 320.8,7.9 459.9,-22.9 l 18.3,-7.5 c 15.9,-82.9 18.4,-161.5 18.8,-245.7 l -528.1,-1.7 -15.3,236.1 46.4,41.7",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 13478,15640.9 c -37.9,122.1 -34.4,274.5 -44.4,402.6 l -54.1,1190.9 33.5,28 898.7,-217.2 c -382.3,-279.5 -718.9,-599.4 -799,-1090.6 -16.4,-100.6 -14.4,-202.2 -13,-303.8 l -21.7,-9.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 6097.76,12251.6 c -64.96,53.5 -165.22,93.1 -240.44,133.7 -246.76,132.9 -541.77,312.3 -642.69,588.7 -43.06,118 -65.26,862 -15.78,971 81.43,-151.1 131.31,-314.3 207.92,-467.7 159.54,-319.6 366.33,-610.1 594.3,-883.6 64.58,-77.5 126.81,-172 207.85,-232.4 l -8.38,-64.2 -75.59,-19 -13.88,-34.5 -13.31,8",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 6236.25,16082.2 -6.58,-1302.2 c -1.12,-192.5 19.79,-419 -16.94,-607.5 -135.65,1.7 -297.85,14.3 -423.58,67.4 -34.88,14.7 -65.78,24.6 -77.77,64.1 -21.42,70.7 -7.93,166.9 -2.76,240.4 35.69,506.8 278.63,1098.7 527.63,1537.8",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 5198.85,13945 c 342.82,-104.4 756.67,-191.4 1006.97,-465.5 l 3.1,-1118.2 c -81.04,60.4 -143.27,154.9 -207.85,232.4 -227.97,273.5 -434.76,564 -594.3,883.6 -76.61,153.4 -126.49,316.6 -207.92,467.7",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 31319.6,20210.7 c 41.3,4.1 57.6,11 94.8,-9.2 -11.8,-141.4 -355.9,-535.9 -452.9,-672.8 l -662.3,-954.7 c -138,-208.4 -269.2,-466.4 -440.4,-646.4 -59.6,-31.2 -109.9,-27.3 -174.9,-24.7 -32.9,31.6 -48.1,70.1 -57.8,114.3 -16.4,74.1 -23.7,358.9 19,419.7 129.7,184 299.9,337.6 455.5,499.5 l 892,917.8 c 97.4,100.5 265.9,234.2 327,356.5",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 31171.1,16632.6 c 203.9,10 440.6,23.3 642.6,-7.1 28.1,-2.5 72.5,-0.2 97.2,-12.5 27.1,-63.7 37.8,-132.1 8.3,-197.8 l -10,-20.6 c 80.3,-45.5 151.2,-31.3 243,-31.3 l 556.8,-0.1 c 3.2,-91.7 26.4,-226 -26.1,-304.6 -116.2,-96.4 -442.5,-59.2 -597.4,-63.7 -31.7,-0.9 -105,5.9 -130.2,-4.1 -36.1,-14.3 -42,-80 -55.7,-112.5 l 3.7,83.3 -30.5,9.9 -71.6,-39.3 -11,34.2 c -148.9,-3.4 -336.3,12.6 -479.7,-23.2 l 13.5,-19.9 c 17.1,-25.5 29.3,-52.1 41.5,-80.1 l -20.8,-37.8 c -21.2,30.4 -47.8,40.2 -79.8,57.4 31.5,-84.2 8,-171.2 3.4,-258.4 -3.9,-74.5 7.3,-149.6 -19.5,-220.4 -17.4,79.1 -7.1,181.7 -8.1,263.8 l -63.7,-8.9 c 32.7,87.1 46.6,221.9 18.8,311.7 l 6.1,58.5 -53.8,51.2 c 53,75.2 30.8,204.7 27.6,293.5 l 13.5,4.7 c 3.4,93.8 10.7,183.5 -18.1,274.1",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 31294.2,16602.6 c 56.2,-9 123.3,-65.2 156.5,-109.9 l -66.1,-40.9 c -20.8,-30.9 -24.7,-27.9 -61.3,-37.8 l -27.4,20 -1.7,168.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 31813.7,16625.5 c 28.1,-2.5 72.5,-0.2 97.2,-12.5 27.1,-63.7 37.8,-132.1 8.3,-197.8 l -10,-20.6 -36.4,-8 c -56.4,64 -7.1,157.1 -59.1,238.9",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 31175.7,16353.8 13.5,4.7 70.1,-17.9 c 17.5,-98.2 36.6,-297.6 -1.5,-388 5.9,-31.2 10.3,-57.8 7.1,-89.8 31.5,-84.2 8,-171.2 3.4,-258.4 -3.9,-74.5 7.3,-149.6 -19.5,-220.4 -17.4,79.1 -7.1,181.7 -8.1,263.8 l -63.7,-8.9 c 32.7,87.1 46.6,221.9 18.8,311.7 l 6.1,58.5 -53.8,51.2 c 53,75.2 30.8,204.7 27.6,293.5",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 26389,18544.2 c 117.4,7.8 242.5,-36.9 356.5,-61.7 l 598.2,-124.3 1276.6,-252.4 c 133.1,-29.2 293.1,-44.1 414.9,-104.4 67.7,-33.5 139.3,-156.2 163.2,-226.7 -50.6,-58.9 -85.5,-86 -158.8,-113.5 -60.8,-65.6 -247.1,-103.8 -335.5,-127.6 -227.2,41.2 -446.2,158 -658.7,246.9 l -1023.4,430.7 c -191.5,80.1 -405.9,140.7 -589.6,232.5 -21.2,10.7 -38.6,27.6 -54.2,45.3 l 10.8,55.2",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m 8289.39,18607.9 3.15,438.9 1872.16,-2.2 0.2,-617.9 -14.4,2.3 c -216.79,-8 -1378.2,-38.1 -1516.69,16.4 l -10.94,22.6 c -72.64,42.6 -165.2,6 -242.58,31.6 -39.59,13.1 -70.43,74.3 -90.9,108.3",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 8289.39,18607.9 c 196.27,0.5 1787.21,29.4 1861.31,-18.1 l -0.2,-160.8 c -216.79,-8 -1378.2,-38.1 -1516.69,16.4 l -10.94,22.6 c -72.64,42.6 -165.2,6 -242.58,31.6 -39.59,13.1 -70.43,74.3 -90.9,108.3",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m 10428.3,19048.5 1780.4,-3.1 c 11.6,-13.8 37.7,-37.3 44.2,-52.7 22.1,-51.8 9.3,-271.4 3.1,-335.3 -2.5,-26.2 -9.4,-50 -19.9,-74 -13.9,-14.6 -47.9,-59.2 -64,-67.1 -62.6,-31.2 -99.2,27.9 -122.1,-72.8 -126.1,-40.1 -335.5,-14.7 -473.2,-15.2 l -1189.1,-0.7 -3.2,410.6 c -0.3,71.5 -8.8,145.8 19.3,212.9 l 24.5,-2.6",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 10403.8,19051.1 24.5,-2.6 -5.9,-453.9 1326.8,0.6 c 145.2,-0.3 351.8,28.4 486.9,-11.8 -13.9,-14.6 -47.9,-59.2 -64,-67.1 -62.6,-31.2 -99.2,27.9 -122.1,-72.8 -126.1,-40.1 -335.5,-14.7 -473.2,-15.2 l -1189.1,-0.7 -3.2,410.6 c -0.3,71.5 -8.8,145.8 19.3,212.9",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m 17328.7,22921.4 c 57.8,159.3 105.7,293.9 268.7,369.5 85.1,39.4 165.7,45.8 257,25.1 l 96.5,-24 c 4,-1 8.5,-5.5 12,-3.2 27.9,18.7 91.1,185.1 117.4,225.7 236.1,364.5 693.2,490.6 1094.4,339.9 222.8,-83.6 403.7,-267.3 515.9,-475.3 11.2,-20.8 51.3,-122.7 65,-132 7.7,-5.1 18.3,-2.9 27.5,-4.3 l 20.8,11.4 c 103,55.8 195.4,77.7 311,46.2 126.5,-34.5 235.4,-143 293.7,-257.5 55.9,-109.8 70.6,-235.9 80.1,-357 106,62.1 206.5,120.7 334,88.8 92.6,-23.1 179.2,-97.3 226,-180 32.3,-57.1 57.3,-156.1 36.5,-222 -9.1,-29.1 -29.9,-50.5 -51.8,-70.5 -226.6,34.8 -488.6,9.2 -719.2,9.2 -17.6,171.1 -29.6,309.3 -153.2,440.4 -126.1,133.7 -257.3,137.8 -430.6,140.1 l -20.6,0.1 -112.8,166.6 c -145.2,205.1 -359.4,343.6 -608.3,381.6 -293.5,44.9 -563.7,-14.8 -805.2,-189.3 -140.4,-101.4 -242.1,-225.5 -326.8,-374.9 -49.8,32.9 -101.2,68.7 -157.5,89.3 -131.7,48.2 -249.7,12.1 -370.5,-43.9",
    style: {
      fill: "url(#linearGradient65)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m 4966.88,12493.9 6.57,42.7 c 285.22,-26.6 594.71,-155.6 874.83,-228.4 81.89,-21.2 165.03,-50.3 249.48,-56.6 l 13.31,-8 88.76,-84.8 c 18.69,-136.7 10.33,-281 10.77,-419 l 0.98,-679.9 c -0.08,-87.9 25.23,-308.4 -21.79,-378.3 l -130.42,6 c -155.89,66.1 -304.83,150.7 -467.61,200 -147.08,60.7 -318.46,154.4 -428.1,270.8 -323.02,342.9 -213.07,903 -196.78,1335.5",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "m 4966.88,12493.9 9.42,-14.3 c 68.34,-107.7 88.47,-256.2 128.21,-377.4 41.91,-128 97.42,-248.6 158.06,-368.7 139.71,-276.8 349.43,-493.7 578.33,-697.5 121.58,-108.3 249.85,-206.2 359.54,-327.2 l -4.49,966.8 c -0.05,157.3 -12.8,327.7 3.88,483.2 18.69,-136.7 10.33,-281 10.77,-419 l 0.98,-679.9 c -0.08,-87.9 25.23,-308.4 -21.79,-378.3 l -130.42,6 c -155.89,66.1 -304.83,150.7 -467.61,200 -147.08,60.7 -318.46,154.4 -428.1,270.8 -323.02,342.9 -213.07,903 -196.78,1335.5",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m 25283.8,20676.9 8.8,14.4 c 46.6,76.8 55.9,159 94,239.2 135.3,285.1 382.5,498.8 690,578.2 316,81.6 619.6,31.2 898.5,-134.4 262.6,-155.7 449.4,-416.2 523.4,-711.5 35.7,-142 40.1,-282 45.4,-427.4 l 391.1,1.9 c 184.9,0 344.1,19.6 484.5,-122.4 65,-65.7 102.9,-149.4 100.7,-243.1 -2.2,-95.2 -48.4,-180.1 -118.5,-242.4 -64,-56.7 -118.9,-67.1 -201.3,-68 7.6,56.4 -35.4,116.6 -63.2,163.9 -148,251.8 -333.6,332.8 -606.9,401.6 -67.4,-170.2 -128.3,-309.5 -235.5,-459.8 -14.4,212.9 -24.2,396.5 -118.2,592.1 -130.2,270.5 -367.6,536 -657,634.2 -313.8,106.6 -715.3,83.5 -980.3,-132.7 -62.3,-50.8 -131.7,-159.8 -196.9,-192.7 -7.8,42.7 -34.4,74.2 -58.6,108.9",
    style: {
      fill: "#46a6dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 24501.5,15371.5 c 346.1,217 733.9,264.4 1129.8,175.9 258.4,-57.8 555.2,-210.4 696.8,-442.9 72.8,-119.4 116.8,-323.1 81.4,-460.1 -6.1,-23.4 -22.3,-41.4 -37.2,-59.6 -19,-40.7 -41.5,-81.3 -47.6,-126.2 l -29.8,38.1 c -87.4,-5.3 -169.2,-12.2 -245.2,-59.3 -131.4,-20.7 -284.3,-7.3 -417.6,-8.6 l -948.2,0.6 -182.4,942.1",
    style: {
      fill: "#acdff3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m 23187.4,16353.1 1147.1,4.4 17.9,-164.3 6.4,-11 c 8.3,-122.8 28.6,-273.6 66.5,-390.4 l 76.2,-420.3 182.4,-942.1 -1510.9,-0.5 -7.1,1724.1 15.8,5.7 5.7,194.4",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 23187.4,16353.1 1147.1,4.4 17.9,-164.3 -17.4,-40.5 -743.2,0.2 c -135.3,0.5 -276,-8 -410.1,5.8 l 5.7,194.4",
    style: {
      fill: "#473f4f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m 17328.7,22921.4 c 120.8,56 238.8,92.1 370.5,43.9 56.3,-20.6 107.7,-56.4 157.5,-89.3 84.7,149.4 186.4,273.5 326.8,374.9 241.5,174.5 511.7,234.2 805.2,189.3 248.9,-38 463.1,-176.5 608.3,-381.6 l 112.8,-166.6 20.6,-0.1 c 173.3,-2.3 304.5,-6.4 430.6,-140.1 123.6,-131.1 135.6,-269.3 153.2,-440.4 230.6,0 492.6,25.6 719.2,-9.2 -118.4,-22.9 -259.6,-9.3 -380.8,-9 l -876,10.2 -2091.6,-0.5 -548.5,-3 c -75.5,-0.2 -182.6,-13.5 -254.9,6.7 -51.7,14.4 -98.7,64.9 -120.3,112.7 -39.3,86.8 -20.8,216.1 13.7,300.6 36.2,88.7 114.9,167.1 203.1,203.5 106.8,44 207.8,29.7 312,-13.3 l 22,-9.2 16.6,20.5",
    style: {
      fill: "#5dc9d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 10137.5,3885 c 334.5,-375.8 672.8,-748.2 1146.8,-948 227,-95.7 487.3,-173.2 697.5,-299.7 -511.7,-171.4 -1026.2,-225 -1563.1,-150.9 -891.47,123.2 -1779.95,641.8 -2322.08,1360.1 251.02,36 533.92,14.3 788.88,16.6 l 1252,21.9",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 21890.7,16362.3 1285.2,-5 11.5,-4.2 -5.7,-194.4 -15.8,-5.7 7.1,-1724.1 -635.9,2.6 -767.5,-1075.1 c -113.7,79.6 -213.9,181.1 -315.9,274.9 100.4,267.9 136.6,555.4 184.7,836.5 l 160.7,1060.4 74.6,627.1 17,207",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m 21890.7,16362.3 1285.2,-5 11.5,-4.2 -5.7,-194.4 -15.8,-5.7 -1292.2,2.3 17,207",
    style: {
      fill: "#464346",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m 26941.2,14578.4 c 33.4,-0.4 77.4,-5.7 109.6,0.1 111.2,-11.1 236.7,-27.8 347.6,-14.2 l 91.6,-2.7 c 42.2,0.5 87.6,4.7 129.4,-0.5 54.7,-81.3 35.2,-163.7 33.5,-259.8 83.5,-34.1 296.2,-35.1 382.9,-10.5 73.1,-24.9 127,-27.1 203.5,-22.5 l 517,-5.3 2.2,-743.5 c 0.3,-69.5 -16.8,-213.6 18.6,-271.5 97.7,-22 281.4,-98 349,-171.5 l 32,-27 -5.4,-46.3 c 13,-48.9 32.3,-80 1.7,-126 l -14.6,-19.2 -367.8,1.8 c -214.5,-21.8 -460.4,-12.6 -676.1,-0.5 l -19.8,-6.2 -403.4,-0.1 -750.8,-11.5 c -72.8,39.8 -943,16.2 -1096.2,16.9 57.7,45.2 113.4,115.6 144.4,181.4 75,62.3 186.8,205.5 220.5,296.9 l 732.3,-2.9 25.8,2.6 c -18.3,77.1 -8.7,174.2 -9.5,254.7 l 10.8,630.5 -45,47.4 12,53.9 -4.6,35.1 15.8,36.9 c 25.4,66.1 20.5,115.4 13,183.5",
    style: {
      fill: "#c6751c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 28094.9,12998 c 211.3,15.8 441.9,-21 648.2,8.6 28.1,-62.7 34,-78.8 28.9,-146.8 -214.5,-21.8 -460.4,-12.6 -676.1,-0.5 l -1,138.7",
    style: {
      fill: "#ac601e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m 28777.1,13248 c 97.7,-22 281.4,-98 349,-171.5 l 32,-27 -5.4,-46.3 c 13,-48.9 32.3,-80 1.7,-126 l -14.6,-19.2 -367.8,1.8 c 5.1,68 -0.8,84.1 -28.9,146.8 l 34,61.2 -21,61 c 14.6,39 17.1,78.1 21,119.2",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m 28777.1,13248 c 97.7,-22 281.4,-98 349,-171.5 l 32,-27 -5.4,-46.3 c -118.7,56.2 -269.6,92 -396.6,125.6 14.6,39 17.1,78.1 21,119.2",
    style: {
      fill: "#364652",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "m 25825.7,12858.4 c 57.7,45.2 113.4,115.6 144.4,181.4 16.6,-9.5 41.8,-28.7 59.3,-33.6 50.4,-13.9 161.2,3.3 219.4,4.4 l 441.3,3.9 c 68.4,0.1 156.8,-10.1 221.5,6.1 l 525.4,-4.3 c 73.7,-0.6 166.1,9.7 236.9,-8.6 l -538.8,-5 c -34.4,0.2 -134.1,12.1 -162.2,0.6 -12.2,-4.9 -18.8,-18.1 -28.3,-27.1 l 5.1,-99.2 c 50.8,-32.8 126,-20.5 184.9,-20.6 170.5,-0.4 371,22.4 538.1,-3.4 l -750.8,-11.5 c -72.8,39.8 -943,16.2 -1096.2,16.9",
    style: {
      fill: "#d47b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 26190.6,13336.7 732.3,-2.9 c 39.5,-68.3 25.8,-169.8 24.6,-247.7 l -35.9,-65.5 c -64.7,-16.2 -153.1,-6 -221.5,-6.1 l -441.3,-3.9 c -58.2,-1.1 -169,-18.3 -219.4,-4.4 -17.5,4.9 -42.7,24.1 -59.3,33.6 75,62.3 186.8,205.5 220.5,296.9",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m 26922.9,13333.8 25.8,2.6 701.7,-2.5 c 120.9,-0.2 249.9,-9.9 369.3,2.1 l 85.7,-16.2 c 20.8,-80 5.4,-188.5 3.2,-272.1 l -33,-40.5 -401.7,0.5 c -70.8,18.3 -163.2,8 -236.9,8.6 l -525.4,4.3 35.9,65.5 c 1.2,77.9 14.9,179.4 -24.6,247.7",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 26941.2,14578.4 c 33.4,-0.4 77.4,-5.7 109.6,0.1 111.2,-11.1 236.7,-27.8 347.6,-14.2 l 91.6,-2.7 c 42.2,0.5 87.6,4.7 129.4,-0.5 54.7,-81.3 35.2,-163.7 33.5,-259.8 l -14.4,-14.3 0.2,-19.2 5.9,-23.4 c 22.7,-96.5 1.7,-231.6 -0.5,-331.4 l -6.4,-562.4 c 89.9,-1.4 306.3,18.2 382,-14.6 -119.4,-12 -248.4,-2.3 -369.3,-2.1 l -701.7,2.5 c -18.3,77.1 -8.7,174.2 -9.5,254.7 l 10.8,630.5 -45,47.4 12,53.9 -4.6,35.1 15.8,36.9 c 25.4,66.1 20.5,115.4 13,183.5",
    style: {
      fill: "#d47b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "m 26941.2,14578.4 c 33.4,-0.4 77.4,-5.7 109.6,0.1 1.7,-66.2 -14.4,-244.9 16.9,-294.3 l 419.8,2.3 151,0.5 0.2,-19.2 -505.8,3.5 c -41.5,0.7 -122.6,-8.8 -160,2.7 -12.4,3.8 -44.4,38.7 -55.9,48.9 l -4.6,35.1 15.8,36.9 c 25.4,66.1 20.5,115.4 13,183.5",
    style: {
      fill: "#b84520",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m 27050.8,14578.5 c 111.2,-11.1 236.7,-27.8 347.6,-14.2 l 91.6,-2.7 c 42.2,0.5 87.6,4.7 129.4,-0.5 54.7,-81.3 35.2,-163.7 33.5,-259.8 l -14.4,-14.3 -151,-0.5 -419.8,-2.3 c -31.3,49.4 -15.2,228.1 -16.9,294.3",
    style: {
      fill: "#a1461e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "m 27490,14561.6 c 42.2,0.5 87.6,4.7 129.4,-0.5 54.7,-81.3 35.2,-163.7 33.5,-259.8 l -14.4,-14.3 -151,-0.5 c 20.5,76.8 21,197.2 2.5,275.1",
    style: {
      fill: "#992c1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 25283.8,20676.9 c 24.2,-34.7 50.8,-66.2 58.6,-108.9 65.2,32.9 134.6,141.9 196.9,192.7 265,216.2 666.5,239.3 980.3,132.7 289.4,-98.2 526.8,-363.7 657,-634.2 94,-195.6 103.8,-379.2 118.2,-592.1 107.2,150.3 168.1,289.6 235.5,459.8 273.3,-68.8 458.9,-149.8 606.9,-401.6 27.8,-47.3 70.8,-107.5 63.2,-163.9 h -4063.3 c -77,47.5 -145.3,91.6 -188.7,173.5 -49.3,93.2 -53.6,180.1 -19.2,279.1 32,92 105.3,162.2 192.5,203 l 11.9,5.4 c 119.3,56.3 273.9,38.4 403.6,37.6 7.8,76.1 11.7,165 39.8,236.3 41.7,105.7 141.1,201.1 247.6,240.9 168.5,63.1 303.1,8.5 459.2,-60.3",
    style: {
      fill: "#5dc9d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "m 20792.2,19197.9 c 80.5,6.5 115.5,19.1 176.9,73.1 192.3,-217 323.5,-457.9 469.2,-706.4 l 527.3,-930.8 c -66.1,-84.5 -131.9,-155.3 -214.3,-224 -185.9,278.6 -341.1,580.5 -504.4,872.8 -57.2,102.4 -127.5,274.5 -211.3,353.5 l 40.1,-1692.5 c 5.9,-239.8 -17.1,-512.8 19.4,-747.9 303.5,-167.8 502,-390.2 704,-667.5 l -160.7,-1060.4 c -48.1,-281.1 -84.3,-568.6 -184.7,-836.5 l -313.9,269.3 c -42.3,-87.4 -23.7,-232.3 -23.6,-329.1 0,-2.7 0.7,-45.2 0,-45.9 -7.8,-8.8 -21.7,-9.3 -32.5,-14 l -61.2,51 -88,104.4 c -82.3,84.9 -174.6,205.8 -285.1,251 l -95.9,24.8 c 1,147.7 11.4,304.1 -4.4,450.7 l 56,2000.6 101.5,2831.8 85.6,-28",
    style: {
      fill: "url(#linearGradient89)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "m 21095.1,16195.7 c 303.5,-167.8 502,-390.2 704,-667.5 l -160.7,-1060.4 c -48.1,-281.1 -84.3,-568.6 -184.7,-836.5 l -313.9,269.3 c -14.8,67.6 -5.5,154.2 -5.7,223.9 l -3.6,461.4 -35.4,1609.8",
    style: {
      fill: "#acdff3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "m 20706.6,19225.9 85.6,-28 102.9,-6.5 c 19.7,-241.7 8.8,-491.2 10.8,-734.2 l 12.9,-1129.8 31.7,-3612.6 c 0.4,-19 -6.3,-32.2 -16,-47.8 -82.3,84.9 -174.6,205.8 -285.1,251 l -95.9,24.8 c 1,147.7 11.4,304.1 -4.4,450.7 l 56,2000.6 101.5,2831.8",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "m 3247.19,10425.4 28.99,105.7 c 88.05,278.1 254.81,540.8 521.61,676.9 222.55,113.6 511.46,141.6 748.73,64.8 176.44,-50.1 413.81,-144.6 563.26,-251.7 l 12.6,-14.9 c 89.22,-103.7 198.79,-185.5 295.53,-281.7 151.11,-150.1 279.8,-332.8 356.73,-532 -145.42,-108.4 -293.59,-210.8 -462.51,-279.9 -339.85,-139.1 -694.07,-171.3 -1002.59,-394 -314.09,-226.8 -405.14,-630.7 -698.05,-856 -81.48,-62.7 -170.64,-91.4 -268.24,-119.7 -127.52,-22.9 -253.57,-40.1 -383.09,-45.6 -149.37,-6.4 -342.05,8.1 -478.11,-54.3 l -76.98,-34.8 c -15.17,303.2 -2.23,534.1 152.18,804.8 l 21.66,28.1 c 183.84,216.3 416.4,275.3 686.96,302.6 -57.34,298.7 -70.53,580.5 -18.68,881.7",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m 2944.97,9268.5 34.07,1.7 c 62.01,2.4 123.98,2.2 170.63,-46 32.6,-33.6 52.51,-82.3 47.13,-129.3 -9.79,-85.6 -64.89,-138.3 -125.71,-191.9 l -62.18,-4.4 c -65.45,-2.8 -118.3,13.6 -165.37,61.6 -31.14,31.8 -30.94,77.2 -26.82,119 8.85,89.7 64.92,133.8 128.25,189.3",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "m 2557.25,9213 7.42,-7.8 c 53.64,-60.5 60.31,-145.9 103.02,-214.5 153.31,-246.1 418.67,-349.3 675.56,-447.8 -127.52,-22.9 -253.57,-40.1 -383.09,-45.6 -149.37,-6.4 -342.05,8.1 -478.11,-54.3 l -76.98,-34.8 c -15.17,303.2 -2.23,534.1 152.18,804.8",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "m 3247.19,10425.4 28.99,105.7 c 88.05,278.1 254.81,540.8 521.61,676.9 222.55,113.6 511.46,141.6 748.73,64.8 l -8.18,-36.5 108.49,-136.6 c 40.49,-53.9 34.2,-204.3 22.01,-269.7 -35.64,-191.4 -195.25,-378.5 -354.02,-480.6 -196.93,-126.6 -420.67,-186 -651.87,-133.8 -158.38,35.8 -285.41,117.8 -415.76,209.8",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "m 4044.13,11115.4 c 61.82,2.4 137.9,10.3 195.22,-16.1 50.26,-23.1 95.13,-69.2 115.57,-120.5 29.72,-74.8 21.52,-131.3 -13.87,-203.5 -79.36,-161.9 -237.2,-247.9 -401.11,-301.7 -60.47,-15.2 -158.68,-27.5 -217.37,-5.8 l -13.24,5.5 c -51.09,20.8 -69.75,48.4 -98.57,94.5 -7.84,101.2 -0.93,180.1 48.8,272.2 81.11,150.2 228.65,226.3 384.57,275.4",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "m 31801.2,15932.2 71.6,39.3 30.5,-9.9 -3.7,-83.3 c 38.4,-68.2 36.2,-144.1 41.8,-220.4 l 25.9,-445.1 c 2.9,-67.6 16.4,-154.5 2.4,-220.9 l -17.5,-43.2 c 44.9,-79.4 35.9,-177.1 38.8,-265.8 l 20,-443 c 5.9,-97.6 36.7,-241.1 16.1,-335.3 -2.9,-13.5 -9.2,-27.7 -15.1,-40.3 47.6,-109.5 37.4,-257.2 44.2,-375.3 l 38.8,-627.8 c 4.9,-86 35.2,-249.8 10,-329.3 -4.1,-12.9 -12.6,-26.6 -20.2,-37.9 60.8,-129.6 117.9,-1700.5 87.9,-1782.6 l -13.4,-29.6 -58.9,-20.7 -81.1,-22 c -23.7,-43.5 -202,-158 -256.7,-176.6 l -40.8,-9.1 c -31.7,100 -177.3,254.9 -254.4,327.6 l -37.9,63 c -10,24.8 -36.6,46.6 -55,66.2 l -36.6,59.1 -3.2,18.7 c -27.1,96.4 -212.9,325.7 -295.2,383.7 -19.1,50.4 -43.5,77.2 -82.8,113.5 l 36.3,44.1 c -2.6,343 25.7,684.5 43.8,1026.7 l 140.4,2611.9 c 3.4,139.8 40.5,338.1 -0.2,471 l 63.7,8.9 c 1,-82.1 -9.3,-184.7 8.1,-263.8 26.8,70.8 15.6,145.9 19.5,220.4 4.6,87.2 28.1,174.2 -3.4,258.4 32,-17.2 58.6,-27 79.8,-57.4 l 20.8,37.8 c -12.2,28 -24.4,54.6 -41.5,80.1 l -13.5,19.9 c 143.4,35.8 330.8,19.8 479.7,23.2 l 11,-34.2",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "m 31374.5,10910.2 11.5,5.8 c 78.7,42.4 142.4,117.5 204.7,180.6 l 234.5,-251.1 -395.7,-1.5 c -10,24.8 -36.6,46.6 -55,66.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "m 31832.2,15862.3 c 15.2,-17 27.1,-33.9 32.8,-56.5 17.3,-70.4 33.4,-360.9 3.6,-413.9 l -112.6,75.2 c -17.5,51.5 -88.9,98.9 -129.9,136.3 69.1,76.8 151.4,155.2 200,246.6 l 6.1,12.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "m 31813.9,14833.4 -4.1,14.8 c -24,56.4 -119.7,127.3 -166.1,171.1 l 252.8,239.7 c 7.1,-127.7 50.8,-366 -23.7,-466 l -58.9,40.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m 31264.9,15862.8 c 32,-17.2 58.6,-27 79.8,-57.4 l 196.2,-215.9 -240.4,-236.1 -51.7,30.6 c 26.8,70.8 15.6,145.9 19.5,220.4 4.6,87.2 28.1,174.2 -3.4,258.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m 31365.5,15843.2 c -12.2,28 -24.4,54.6 -41.5,80.1 l -13.5,19.9 c 143.4,35.8 330.8,19.8 479.7,23.2 l 11,-34.2 c -26.6,-102.3 -150.4,-208.6 -220.8,-287.1 -60.8,62.7 -135.8,162.5 -214.9,198.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m 31237.5,15320.2 c 126.5,-65.5 222.5,-197.9 317.5,-301.8 -54.2,-57.8 -103,-106.7 -171.7,-147.4 -17.1,-51.4 -101.6,-109.4 -143.8,-147 8,173.7 47.9,414.2 2.9,580.1 l -4.9,16.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "m 31686.7,14082.9 c 54.4,-2.9 160.7,5.8 198.5,-30 -33.4,-35.3 -62,-68.2 -106.4,-89.9 -36.9,-61.5 -137.5,-125.3 -194.7,-172.3 -100.9,44.9 -235,197.1 -321.7,273.8 24.2,21.7 363.5,14.9 424.3,18.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m 31834.2,13940.3 c 38.6,18.4 71.1,45.6 107.7,67.3 l 1.2,-59.1 c 45.5,-154.7 36.9,-372.8 40.8,-535.8 l -351.7,317.3 c 45.4,42.7 192.2,154.8 202,210.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "m 31467.4,10781 408.8,5.3 c 42,-38.7 121.1,-96.7 143.1,-147.2 -23.7,-43.5 -202,-158 -256.7,-176.6 l -40.8,-9.1 c -31.7,100 -177.3,254.9 -254.4,327.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "m 31477.1,14324.5 c -71.3,-94.8 -181.4,-174.4 -270.6,-252.8 l 30.3,580.3 28.8,13 c 101.9,-73.6 187.6,-171 275.5,-260.2 l -7.3,-40.7 -56.7,-39.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "m 31170.1,14025.5 c 143.4,-55.7 255,-184.9 366.1,-288.3 -70.6,-66.7 -139.9,-139.4 -225.2,-187.5 -8,-47 -114,-130.3 -151.4,-166.2 l 22.5,343.6 c 8,102.3 32.5,201 -12,298.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "m 31039.5,11371.7 5.8,11.3 c 31.8,66.7 28.6,139 30.3,211.3 120.4,-98.6 229.1,-207.7 338.5,-318.1 39.3,-39.9 98.2,-85.2 120.2,-136 -55.5,-57.9 -120.7,-144.4 -196.4,-170.9 l -3.2,18.7 c -27.1,96.4 -212.9,325.7 -295.2,383.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "m 31566,15550.5 c 96,-37.2 213.7,-174.5 291.9,-245.8 -86.2,-86.8 -169.5,-177.2 -273.3,-243.6 -24.9,80.2 -172.9,197.8 -235,261.2 69.6,65.3 163.7,136.3 211.5,218.9 l 4.9,9.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m 31945.3,13269.3 50.1,-9.4 38.3,-699.2 c -53.9,55 -105.2,110.6 -170.9,151.9 l -11.8,7.2 c -9.2,61.3 -167.5,190.4 -216.4,239.2 99,93.9 224,193 304.6,301.6 l 6.1,8.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m 31140.6,13309.3 c 130.6,-54.3 286.7,-250.8 391.2,-352.8 -68.9,-67.3 -136.7,-143.1 -221.5,-189.8 -10.7,-52.7 -145.6,-151.4 -190,-191.1 -1.7,142.8 9,283.3 20.5,425.4 7.8,96.7 24.2,197.3 3.7,292.9 l -3.9,15.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 31948,11650.5 -796,-3.2 428.4,389 c 52.8,-51.2 108.2,-101.1 152.4,-159.9 l 6.9,-9 c 66.2,-52.8 198.5,-134.9 208.3,-216.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m 31954.6,11597.1 28.3,-5 -1.4,-38.1 c -98.7,-129.2 -264.3,-245.3 -387.6,-353.7 -39.8,12.2 -86.7,73.1 -117,103.3 l -288,288.4 765.7,5.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    d: "m 31083.9,12477 c 70.6,-27.5 123.1,-88.6 177.6,-139.7 l 269.8,-255.3 c -75.4,-69.3 -149.9,-145.7 -239.3,-196.7 -23,-68.3 -156.3,-158.4 -214.5,-209.3 -11.9,159.4 5.7,326.3 16.4,485.6 6.6,99.5 21.3,200.3 -5.1,298.1 l -4.9,17.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m 32027.9,11517.6 46.6,-24.9 26.4,-532.4 c 3.7,-86.5 17.8,-183.4 -4.2,-267.4 -33.7,21.6 -63.2,57.2 -91.8,85.5 l 52.3,64.1 -10.5,22 c -29.3,-14.8 -47.2,-20.9 -80.6,-21.7 -59.4,-1.4 -275.5,239.8 -331.9,294.8 l 276.7,248.8 c 35.2,32 86.7,69.3 107.7,111.3 l 9.3,19.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "m 31572.1,13687.4 c 41.8,-11.4 76.7,-52.5 108.5,-81.3 L 31947,13356 c -114.5,-113.9 -245.7,-275 -388.1,-349.4 -15.1,79.8 -279.1,277.9 -351.2,341.9 l 352.2,325.3 12.2,13.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 31566.5,12910.8 c 49.6,-19.8 94.3,-74.7 132.4,-112.2 l 291.4,-288.3 c -130,-123.2 -276,-294.9 -432.8,-378.8 -8.1,44.1 -70.6,85.8 -103.8,116.5 l -289.9,279 c 125,118.6 295.5,235.8 395.6,373.9 l 7.1,9.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "m 32030.8,12308.6 c 13.9,24.4 23.9,41.9 27.6,69.9 5.4,39.5 16.1,77.1 26.4,115.5 60.8,-129.6 117.9,-1700.5 87.9,-1782.6 l -13.4,-29.6 -58.9,-20.7 -3.7,31.8 c 22,84 7.9,180.9 4.2,267.4 l -26.4,532.4 -46.6,24.9 c -5.9,33.2 -23.5,50.2 -45,74.5 l -28.3,5 -6.6,53.4 c -9.8,82 -142.1,164.1 -208.3,216.9 l 19.5,57.8 c -8.3,59.3 -83,110.3 -125.8,152.7 l 395.2,359 c 13.9,-48.8 11.5,-78.6 2.2,-128.3",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "m 31759.2,11925.2 c -8.3,59.3 -83,110.3 -125.8,152.7 l 395.2,359 c 13.9,-48.8 11.5,-78.6 2.2,-128.3 51,-130.5 33.7,-318.1 38.4,-458.1 1.7,-53 14.1,-134.3 -3,-183.6 -79.1,78.3 -198.3,233.5 -307,258.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "m 31872.8,14793 39.3,-3.1 c 15.6,67.1 2.2,97.7 40.1,158.8 44.9,-79.4 35.9,-177.1 38.8,-265.8 l 20,-443 c 5.9,-97.6 36.7,-241.1 16.1,-335.3 -2.9,-13.5 -9.2,-27.7 -15.1,-40.3 l -20,64.3 -48.9,19.9 -1.2,59.1 c -36.6,-21.7 -69.1,-48.9 -107.7,-67.3 l -55.4,22.7 c 44.4,21.7 73,54.6 106.4,89.9 -37.8,35.8 -144.1,27.1 -198.5,30 l -5.4,32.6 -161.7,15.2 c -45.4,-0.5 -79.4,-1.5 -121.1,17.6 27.6,25.8 75.9,62 85,99.7 l 3.4,18.1 -9.8,58.4 56.7,39.6 7.3,40.7 c -87.9,89.2 -173.6,186.6 -275.5,260.2 l 41.8,19.2 7.1,22.7 c 105,61.2 201,173.6 289.9,257.3 l 173.4,-166.6 36.1,35.8 58.9,-40.4",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 31486.9,14266.1 120.2,70.1 218.5,-204.6 -306,-0.9 c -45.4,-0.5 -79.4,-1.5 -121.1,17.6 27.6,25.8 75.9,62 85,99.7 l 3.4,18.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "m 31863.3,14624.7 53.9,-8 c 20.3,-41 14.2,-106.5 15.9,-152.4 l 12.7,-358 c -53,44.5 -81.1,85.6 -143.8,120.9 l -14.2,7.7 c -7.8,43.8 -103.1,118.7 -137.3,151.7 58.7,58.5 171.7,145.7 204.9,219.2 l 7.9,18.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "m 31314.5,14706.9 c 105,61.2 201,173.6 289.9,257.3 l 173.4,-166.6 100.8,-81.5 c -73,-103.2 -184.4,-192.7 -275.7,-280.8 -92.8,89.9 -185.1,194.4 -288.4,271.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m 29654.9,17423.9 c 215.1,-44.5 382,-236.1 533.9,-383.1 60.5,-58.6 144.6,-126.3 190.5,-196.5 54.9,-83.8 146.5,-398.4 127.7,-493.2 40.8,-78 94.8,-209.9 72.1,-296.6 l 569,5.8 53.8,-51.2 -6.1,-58.5 c 27.8,-89.8 13.9,-224.6 -18.8,-311.7 40.7,-132.9 3.6,-331.2 0.2,-471 L 31036.8,12556 c -18.1,-342.2 -46.4,-683.7 -43.8,-1026.7 l -36.3,-44.1 -6.4,22.6 c -33.2,70.9 -126.5,155.3 -180.2,213.6 -207.6,225.3 -434.8,434.5 -673.4,626.8 -87.4,70.6 -185.6,162.1 -293.8,197.3 13.9,124.6 4.4,257.8 3.4,383.5 l -5.4,661.2 -85.7,2832 c -12.2,196.8 11,463.1 -54,646.8 15.9,87.6 -54.9,227.3 -57.6,330 l 51.3,24.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m 29654.9,17423.9 c 215.1,-44.5 382,-236.1 533.9,-383.1 60.5,-58.6 144.6,-126.3 190.5,-196.5 54.9,-83.8 146.5,-398.4 127.7,-493.2 40.8,-78 94.8,-209.9 72.1,-296.6 46.9,-66 398.6,-1378.5 391.7,-1455.8 l -32.2,-13.6 c -62.3,41.9 -104.1,180.3 -136.8,250.7 l -293.8,618.5 -600.1,1174.6 c -66.2,126.8 -140.2,346.4 -246.7,440.1 15.9,87.6 -54.9,227.3 -57.6,330 l 51.3,24.9",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m 10387.7,18427.6 1189.1,0.7 c 137.7,0.5 347.1,-24.9 473.2,15.2 v -3470 c -599.7,-366 -1149.9,-801.7 -1662.1,-1281.9 l -0.2,4736",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 10770,14963.4 407.1,0.9 -0.9,-509.2 -404.6,-2.5 -1.6,510.8",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 10751.2,16937.3 421.7,0.7 0.6,-503.5 -421.6,1.5 -0.7,501.3",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m 10753.4,15946.5 421.5,2.3 -0.1,-510.7 -421.1,-0.8 -0.3,509.2",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m 10780.2,17940.1 395,-0.9 -1.4,-507.2 -423,-0.1 -0.7,480.2 30.1,28",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m 13685.1,22774.4 c 240.3,188.7 614.3,234.8 909.7,248.7 535.1,-17 977.9,-178.7 1353.6,-573 108.3,-113.7 190.2,-254 240.1,-402.6 l 5.2,-10.1 c 179.9,-411.8 190.1,-980.9 37.2,-1401.9 -158.3,-435.8 -476,-803.7 -899.4,-1000.7 -387.4,-180.4 -884.1,-191.4 -1280.9,-47.8 -452.8,163.8 -828.1,512.3 -1030,950.3 -182,394.9 -194.9,976 -39.3,1383.2 119.9,313.9 387.6,712.2 703.8,853.9",
    style: {
      fill: "#f4e628",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 14466.4,22638.5 c 146.9,4.7 282.2,7.7 428.8,-6.4 -12.7,-79 60.3,-211 80.6,-296.3 134.9,-567 13.8,-1144.8 -476.1,-1504.8 -349.8,-257.2 -702.1,-232.4 -1109.2,-269.7 l -11.7,15.6 c -216.9,322.9 -176.3,771.2 -94.6,1126 64.4,156.5 138.7,321.7 252.5,449.1 239.3,267.9 563.8,464.6 929.7,486.5",
    style: {
      fill: "#f9cb11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "m 13390.5,20561.3 c 407.1,37.3 759.4,12.5 1109.2,269.7 489.9,360 611,937.8 476.1,1504.8 -20.3,85.3 -93.3,217.3 -80.6,296.3 339.8,-88.5 709.8,-296 891.3,-608.3 211,-363.1 282.9,-760.5 172.5,-1168 -48.4,-178.3 -145.4,-340.4 -254.3,-487.7 -138.2,-120.7 -230.7,-241.1 -396.3,-337.1 -305.7,-177.3 -678,-245 -1022.7,-151.1 -385.4,105 -693.6,336.5 -895.2,681.4",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 6236.25,16082.2 19.24,22.2 c 100.09,-143.2 173.41,-324.7 239.26,-486.6 124.02,-305 229.02,-613 284.19,-938.3 15.63,-92.3 41.93,-215.7 27.77,-307.6 -8.43,-54.7 -24.47,-74.5 -69.1,-104.5 -95.51,-64.4 -264.19,-82.7 -376.93,-96.7 l 0.61,-723.9 c 300.63,259.3 633.7,357.6 1002.42,484 l 27.48,-18.5 -8.45,-119.4 c 0.9,-378.8 83.01,-785.7 -206.14,-1077.8 -119.6,-120.8 -258.47,-215.8 -401.84,-306.1 85.9,-37.3 253.83,46.6 348.36,77 199.39,111.4 366.81,258.7 539.66,406.1 317.92,271.1 628.51,572.1 959.77,825.1 l 3.35,-2178.2 c -48.75,-89.9 -113.72,-222.4 -185.55,-295.5 -26.06,-26.6 -86.21,-43.7 -120.46,-57.3 -101.62,-40.5 -206.3,-75.8 -304.31,-124.6 -122.64,-61 -233.42,-138.2 -338.03,-226.2 -49.65,-61.9 -87.85,-90.6 -95.1,-170.7 17.49,-262.9 68.07,-642.3 -8.26,-893.6 -26.47,-87.1 -55.51,-151.1 -110.07,-224.3 15.53,-70.7 42.59,-114.3 102.79,-156.3 l 11.51,-6.9 -152.09,-295.8 -5.73,-27.3 -0.3,-67.8 c -46.13,-28.1 -159.34,-7.2 -216.61,-5.4 l -604.53,10.4 c -41.6,1.8 -147.57,24.4 -178.81,14.3 -10.62,-3.5 -18.24,-12.9 -27.35,-19.3 l -7.01,-92.6 -9.97,-1.3 c -68.55,26.7 -111.1,62.1 -161.66,113.3 -110.88,85.9 -248.24,140.7 -376.22,196.3 58.72,358.3 44.38,637.9 -63.5,984.1 -76.93,199.2 -205.62,381.9 -356.73,532 -96.74,96.2 -206.31,178 -295.53,281.7 l -12.6,14.9 c 118.56,-40.2 366.96,-159.1 481.98,-133.5 162.78,-49.3 311.72,-133.9 467.61,-200 l 130.42,-6 c 47.02,69.9 21.71,290.4 21.79,378.3 l -0.98,679.9 c -0.44,138 7.92,282.3 -10.77,419 l -88.76,84.8 13.88,34.5 75.59,19 8.38,64.2 -3.1,1118.2 6.91,693 c 36.73,188.5 15.82,415 16.94,607.5 l 6.58,1302.2",
    style: {
      fill: "#34702f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "m 7464.12,9546.8 c 15.53,-70.7 42.59,-114.3 102.79,-156.3 l 11.51,-6.9 -152.09,-295.8 -5.73,-27.3 c -169.65,60.9 -350.95,87.9 -526.72,125.8 241.98,79.1 386.64,191.1 570.24,360.5",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m 6893.88,9186.3 c 175.77,-37.9 357.07,-64.9 526.72,-125.8 l -0.3,-67.8 c -46.13,-28.1 -159.34,-7.2 -216.61,-5.4 l -604.53,10.4 c -41.6,1.8 -147.57,24.4 -178.81,14.3 -10.62,-3.5 -18.24,-12.9 -27.35,-19.3 l -7.01,-92.6 -9.97,-1.3 0.42,148.8 c 43.16,69.8 419.08,113.3 517.44,138.7",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m 6361.29,13446.8 c 300.63,259.3 633.7,357.6 1002.42,484 l 27.48,-18.5 -8.45,-119.4 -9.84,-13.7 c -78.35,-111.9 -125.86,-249.3 -196.13,-368.6 -219.46,-372.8 -490.98,-715.3 -820.02,-996.8 l 4.54,1033",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "m 5109.78,11021.1 c 118.56,-40.2 366.96,-159.1 481.98,-133.5 162.78,-49.3 311.72,-133.9 467.61,-200 39.83,-38 146.81,-121.1 148.11,-173.5 l 6.88,-1502 c -110.88,85.9 -248.24,140.7 -376.22,196.3 58.72,358.3 44.38,637.9 -63.5,984.1 -76.93,199.2 -205.62,381.9 -356.73,532 -96.74,96.2 -206.31,178 -295.53,281.7 l -12.6,14.9",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m 6362.93,10383.6 46.87,56 c 26.82,32 53.05,63.6 84.82,90.9 289.62,248.5 816.07,331.8 1182.93,304.9 -49.65,-61.9 -87.85,-90.6 -95.1,-170.7 l -6.01,-8.6 c -68.87,-103.6 -100.01,-238 -165.57,-348.9 -255.07,-431.3 -629.37,-770.3 -1045.03,-1042 l -2.91,1118.4",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "m 6774.76,12409 c 85.9,-37.3 253.83,46.6 348.36,77 111.59,-10.9 399.08,18.5 476.33,-41 l 0.56,-49.9 c -78.15,-125 -128.42,-273.7 -201.15,-403.6 -250.66,-447.8 -616.7,-839.4 -1040.03,-1127.7 l 7.57,1329.5 c 105.97,88.9 282.85,154.4 408.36,215.7",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m 7123.12,12486 c 199.39,111.4 366.81,258.7 539.66,406.1 317.92,271.1 628.51,572.1 959.77,825.1 l 3.35,-2178.2 c -48.75,-89.9 -113.72,-222.4 -185.55,-295.5 -26.06,-26.6 -86.21,-43.7 -120.46,-57.3 -101.62,-40.5 -206.3,-75.8 -304.31,-124.6 -122.64,-61 -233.42,-138.2 -338.03,-226.2 -366.86,26.9 -893.31,-56.4 -1182.93,-304.9 -31.77,-27.3 -58,-58.9 -84.82,-90.9 l -46.87,-56 -0.59,336.8 c 322.81,81.7 748.95,212.1 987.43,453.2 98.25,99.3 187.74,225.4 227.62,360.9 34.2,116.1 27.63,244.2 27.06,364.2 l -4.44,496.4 -0.56,49.9 c -77.25,59.5 -364.74,30.1 -476.33,41",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    d: "m 2328.61,7070.3 c 29.32,-52.6 56.91,-107.2 92.28,-156 330.62,-358.2 823.91,-535.1 1278.55,-676 L 6717.32,5664.1 9444.84,5310 c 73.03,-548.5 382.72,-985.4 692.66,-1425 l -1252,-21.9 c -254.96,-2.3 -537.86,19.4 -788.88,-16.6 l -207.43,-0.5 c -1761.26,4.2 -3594.35,660.3 -4846.18,1923 -341.47,344.4 -717.4,790.6 -714.4,1301.3",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 7775.3,5148.8 c 129.81,-42.2 235.1,-90 301.82,-217.5 49.46,-94.5 65.19,-224.2 28.46,-326 -42.06,-116.6 -140.66,-217.2 -252.3,-269.1 -95.17,-44.4 -223.06,-46.9 -320.65,-8.3 -60.62,23.9 -124.73,68.1 -171.99,113 -38.57,58.3 -74.99,122.5 -85.24,192.8 -19.11,131 22.66,254 107.05,354.6 109.46,130.5 236.1,142.6 392.85,160.5",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path145",
    d: "m 3699.44,6238.3 3017.88,-574.2 c 349.5,-181.5 732.34,-277.2 1057.98,-515.3 -156.75,-17.9 -283.39,-30 -392.85,-160.5 -84.39,-100.6 -126.16,-223.6 -107.05,-354.6 10.25,-70.3 46.67,-134.5 85.24,-192.8 -890.02,-125.4 -1847.11,243.1 -2569.66,744 -344.03,238.5 -634.18,517.3 -916.62,824.3 -54.8,59.6 -160.43,149.3 -174.92,229.1",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "m 10220.1,20227.3 11.5,-221.2 18.2,355.3 36.6,10.8 c 38.2,-83.1 -1.2,-168.7 35.8,-253.2 l 26.6,-76 8.9,-171.8 20.5,-419 c 5.4,-126.8 -3.4,-278.2 25.6,-401.1 -28.1,-67.1 -19.6,-141.4 -19.3,-212.9 l 3.2,-410.6 0.2,-4736 -74.2,-73.9 -141.7,-135.3 -447.82,-476.2 -297.72,-352.4 c -41.77,-50.4 -90.59,-129.4 -147.6,-160.1 l -16.8,-20.8 -636.16,-933.9 -3.35,2178.2 c 15.02,126 4.23,265.2 4.89,392.5 l 1.61,805.8 -0.78,2253.9 c -0.61,423.4 -17.71,853.8 5.54,1276 138.49,-54.5 1299.9,-24.4 1516.69,-16.4 l 14.4,-2.3 -0.2,617.9 c -2.7,211.2 16.1,422.6 24.4,633.7 7.3,182.3 3.3,368.5 31,549",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "m 9262.06,12472.9 -302.92,-0.9 c 0.41,68.8 -12.09,152 22.54,211.2 l 158.85,5 c 46.28,-37 31.38,-114.6 40.22,-173.7 l 98.11,-20.8 -16.8,-20.8",
    style: {
      fill: "#364652",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 9405.57,13929.4 393.13,-3.4 -3.21,-460.3 -390.67,-2.5 0.75,466.2",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    d: "m 9394.39,14963.8 h 423.82 l 0.51,-494.1 -423.63,-0.3 -0.7,494.4",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "m 9392.51,16940.5 425.63,0.5 -0.3,-494.5 -424.9,-0.3 -0.43,494.3",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    d: "m 9510.13,15943.3 310.72,-2 c 1.02,-144.8 28.65,-356.9 -11.02,-492.6 l -78.55,-6.6 -334.43,-1 c -0.1,114.8 -34.14,409 18.44,497.1 l 94.84,5.1",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "m 9382,17926.1 439.09,0.2 0.46,-494.5 -433.41,-1.4 -6.14,495.7",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "m 10220.1,20227.3 11.5,-221.2 18.2,355.3 36.6,10.8 c 38.2,-83.1 -1.2,-168.7 35.8,-253.2 l 26.6,-76 8.9,-171.8 20.5,-419 c 5.4,-126.8 -3.4,-278.2 25.6,-401.1 -28.1,-67.1 -19.6,-141.4 -19.3,-212.9 l 3.2,-410.6 0.2,-4736 -74.2,-73.9 -141.7,-135.3 c -33.4,130.5 -15.3,297.3 -15.6,432.2 l -0.8,821.9 9.3,3690.2 -0.2,617.9 c -2.7,211.2 16.1,422.6 24.4,633.7 7.3,182.3 3.3,368.5 31,549",
    style: {
      fill: "url(#linearGradient154)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "m 10313.7,13617.7 6.4,2797.4 19,388.3 1.5,962.6 c -0.6,38.8 -16.6,72.3 -17.5,112.4 l -24,1013.5 c -7,113.5 -4.8,220 -29,329.7 -13.8,62.7 8.2,94.5 -31.5,154 l -8,10.8 c 0,39.7 -10.5,71.9 18.2,100.8 1.5,36.1 6.9,76.9 -9,110.4 l -9.2,17.8 c 38.3,38.7 18,155.1 55,210.6 l 24.8,-12 c 0.3,-89.3 -12.1,-201.6 6,-288 13.9,-65.9 17.4,-127.5 19.4,-194.6 4.4,59.3 9.3,71.1 42.4,120.8 5.4,-126.8 -3.4,-278.2 25.6,-401.1 -28.1,-67.1 -19.6,-141.4 -19.3,-212.9 l 3.2,-410.6 0.2,-4736 -74.2,-73.9",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "m 14433,17121.9 c 143,29.3 291.6,65.8 437.3,75.3 366.9,23.9 704.1,-79.4 1009.3,-280.1 97.8,-64.4 178.6,-134.6 260.5,-218.2 196,530.9 507.2,1011.8 1040.4,1255.1 391.1,178.4 905.7,241 1314.4,85.3 494.6,-188.3 891.5,-515.6 1107,-1006.3 112.7,-256.6 164.6,-523.8 167.5,-803.6 146.3,67.8 301.3,141 462.5,163.9 121.2,17.2 251,6.6 373.2,0.8 l -56,-2000.6 c 15.8,-146.6 5.4,-303 4.4,-450.7 l 95.9,-24.8 c -56.9,-27.1 -87.4,-61.7 -127,-108.5 l -46.1,10.6 c -20.6,36.8 -50.9,65.9 -79.6,96.6 -70.2,29.5 -120.9,34.7 -196.5,33.3 l 7.1,-131.3 -42,-31.5 c -49.3,-40.8 -93.2,-72.1 -119.2,-132.5 -115.9,4.7 -226,16.7 -340.2,37.4 -80.6,128 -164.9,184.3 -305.8,231.7 -89.6,-4.4 -170.2,-19.1 -258.3,-32.4 l -29.5,-23.6 c -112.6,-92.5 -181.2,-202.1 -281.7,-303.2 -14.8,23.4 -12.5,39.7 -11.5,66.6 34.2,58.5 53.1,101 62.9,169.2 -34.2,51.2 -60.5,83.6 -115.5,114.3 -99.1,11.9 -187.2,7.7 -286.2,-3.7 -54.9,-81 -117.7,-152.6 -145.6,-247.4 -7.8,-26.7 -21.6,-40.1 -40.7,-59.6 -54.9,31.5 -80.1,111.3 -117.8,162.5 -46.2,62.7 -101.2,118.3 -159.6,169.7 -124.2,109.2 -289.9,151.6 -404.5,261.8 l -426.5,5.2 200.2,346 200.3,353.7 -268,-49.9 -13.3,-1.1 c -115.9,57.6 -249.6,92.2 -374.4,126.4 -347.6,95.1 -667.6,133.6 -1028,132.3 -264.8,-26.2 -591.3,-44.7 -834.3,-157.2 l -472.4,-150.5 -165.3,1067.7 -930.7,-219.8 c -1.4,101.6 -3.4,203.2 13,303.8 80.1,491.2 416.7,811.1 799,1090.6 180.2,-43.9 357.8,-93.6 544.6,-87.3 -124.9,76.4 -284.2,119.6 -423.3,164",
    style: {
      fill: "#acdff3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "m 14430.4,15870.6 c 500.5,68.4 1013.7,128.5 1519.4,89.6 -35.3,-71.8 -23.3,-173.5 -25,-252.4 -4.2,-194.5 9.7,-405.6 -22.4,-597.2 -264.8,-26.2 -591.3,-44.7 -834.3,-157.2 l -472.4,-150.5 -165.3,1067.7",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "m 15949.8,15960.2 c 1639.8,-62.1 3239,-665.3 4599.3,-1566.7 15.8,-146.6 5.4,-303 4.4,-450.7 l 95.9,-24.8 c -56.9,-27.1 -87.4,-61.7 -127,-108.5 l -46.1,10.6 c -20.6,36.8 -50.9,65.9 -79.6,96.6 -70.2,29.5 -120.9,34.7 -196.5,33.3 l 7.1,-131.3 -42,-31.5 c -49.3,-40.8 -93.2,-72.1 -119.2,-132.5 -115.9,4.7 -226,16.7 -340.2,37.4 -80.6,128 -164.9,184.3 -305.8,231.7 -89.6,-4.4 -170.2,-19.1 -258.3,-32.4 l -29.5,-23.6 c -112.6,-92.5 -181.2,-202.1 -281.7,-303.2 -14.8,23.4 -12.5,39.7 -11.5,66.6 34.2,58.5 53.1,101 62.9,169.2 -34.2,51.2 -60.5,83.6 -115.5,114.3 -99.1,11.9 -187.2,7.7 -286.2,-3.7 -54.9,-81 -117.7,-152.6 -145.6,-247.4 -7.8,-26.7 -21.6,-40.1 -40.7,-59.6 -54.9,31.5 -80.1,111.3 -117.8,162.5 -46.2,62.7 -101.2,118.3 -159.6,169.7 -124.2,109.2 -289.9,151.6 -404.5,261.8 l -426.5,5.2 200.2,346 200.3,353.7 -268,-49.9 -13.3,-1.1 c -115.9,57.6 -249.6,92.2 -374.4,126.4 -347.6,95.1 -667.6,133.6 -1028,132.3 32.1,191.6 18.2,402.7 22.4,597.2 1.7,78.9 -10.3,180.6 25,252.4",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "m 20200.2,13950 c 40.4,53 80.4,103.1 153.2,108.3 90.6,6.4 137.4,-60.6 200.1,-115.5 l 95.9,-24.8 c -56.9,-27.1 -87.4,-61.7 -127,-108.5 l -46.1,10.6 c -20.6,36.8 -50.9,65.9 -79.6,96.6 -70.2,29.5 -120.9,34.7 -196.5,33.3",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "m 17385.8,14549.2 c 729.9,-39.6 1415.9,-180.8 2094.8,-454.3 l 445.2,-198 c 82,-38.8 150.2,-87.1 239.5,-109.7 -49.3,-40.8 -93.2,-72.1 -119.2,-132.5 -115.9,4.7 -226,16.7 -340.2,37.4 -80.6,128 -164.9,184.3 -305.8,231.7 -89.6,-4.4 -170.2,-19.1 -258.3,-32.4 l -29.5,-23.6 c -112.6,-92.5 -181.2,-202.1 -281.7,-303.2 -14.8,23.4 -12.5,39.7 -11.5,66.6 34.2,58.5 53.1,101 62.9,169.2 -34.2,51.2 -60.5,83.6 -115.5,114.3 -99.1,11.9 -187.2,7.7 -286.2,-3.7 -54.9,-81 -117.7,-152.6 -145.6,-247.4 -7.8,-26.7 -21.6,-40.1 -40.7,-59.6 -54.9,31.5 -80.1,111.3 -117.8,162.5 -46.2,62.7 -101.2,118.3 -159.6,169.7 -124.2,109.2 -289.9,151.6 -404.5,261.8 l -426.5,5.2 200.2,346",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "m 17612.1,14198 c 400.1,-34.3 786,-92.6 1174,-198.8 114.7,-31.4 248,-57.8 355.7,-107.8 l -29.5,-23.6 c -112.6,-92.5 -181.2,-202.1 -281.7,-303.2 -14.8,23.4 -12.5,39.7 -11.5,66.6 34.2,58.5 53.1,101 62.9,169.2 -34.2,51.2 -60.5,83.6 -115.5,114.3 -99.1,11.9 -187.2,7.7 -286.2,-3.7 -54.9,-81 -117.7,-152.6 -145.6,-247.4 -7.8,-26.7 -21.6,-40.1 -40.7,-59.6 -54.9,31.5 -80.1,111.3 -117.8,162.5 -46.2,62.7 -101.2,118.3 -159.6,169.7 -124.2,109.2 -289.9,151.6 -404.5,261.8",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "m 13499.7,15650.8 930.7,219.8 165.3,-1067.7 c -145.6,-63.4 -295.5,-119.4 -433.8,-197.8 -466,-264.4 -816.7,-611.4 -1148.8,-1026.2 -368.5,-421.7 -579.1,-942.2 -781.1,-1456.3 -68.1,-173.1 -148.5,-347.9 -201.6,-526 -22.2,-51.2 -36.7,-104.8 -87.3,-133.7 l -133.3,2.1 4.8,-201.9 350.9,-2.1 c 19,-0.1 85.8,5.6 98.2,-0.6 14.8,-7.4 23.9,-23 35.8,-34.5 l -13.9,-18 -14.4,-440.6 c -67.4,-0.1 -402.9,16.6 -433.9,-14.7 -21.1,-21.3 -31,-46.7 -42.3,-74 l -12.4,-84.7 c -91,-257.9 -107.5,-536.9 -193.1,-794.2 -98.7,39.6 -311.6,14.1 -423.6,14.1 l -10.5,10.9 c -128.1,185.2 -190.1,421.1 -319,606.4 -23.1,33.2 -53.1,28.7 -91.6,35.9 l -34.3,-25.3 -707.4,-1394.2 -2571.29,6.4 -5.48,33.9 152.09,295.8 -11.51,6.9 c -60.2,42 -87.26,85.6 -102.79,156.3 54.56,73.2 83.6,137.2 110.07,224.3 76.33,251.3 25.75,630.7 8.26,893.6 7.25,80.1 45.45,108.8 95.1,170.7 104.61,88 215.39,165.2 338.03,226.2 98.01,48.8 202.69,84.1 304.31,124.6 34.25,13.6 94.4,30.7 120.46,57.3 71.83,73.1 136.8,205.6 185.55,295.5 l 636.16,933.9 16.8,20.8 c 57.01,30.7 105.83,109.7 147.6,160.1 l 297.72,352.4 447.82,476.2 141.7,135.3 74.2,73.9 c 512.2,480.2 1062.4,915.9 1662.1,1281.9 l 1120.3,553.2 114.8,47 192.9,67.2 21.7,9.9",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "m 11064.1,12565.3 -15.9,1016.7 c 84.5,2.3 169.4,8.2 252.9,-7.6 35,-93 17.6,-220.5 17.4,-320.7 l -2,-687.3 -61.8,-1.2 -190.6,0.1",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "m 11254.7,12565.2 c -52.9,81.5 -32.4,858.7 -20.5,1002.1 l 66.9,7.1 c 35,-93 17.6,-220.5 17.4,-320.7 l -2,-687.3 -61.8,-1.2",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "m 11064.1,12565.3 190.6,-0.1 61.8,1.2 301.8,-22.3 132.5,-0.3 c 65.6,-66.4 73.7,-159.6 97.5,-248.9 60.1,-225.3 95.9,-484.1 182.1,-698.3 -22.2,-51.2 -36.7,-104.8 -87.3,-133.7 l -133.3,2.1 -465.5,-2.7 -483.2,-0.7 c -75.8,-0.2 -166.8,10.1 -240.2,-9.4 -41.6,4.5 -61.6,11.2 -97.4,32.7 -13.4,26.9 -23.2,54.8 -23.2,85.2 -0.1,151.7 151.1,909.5 235.2,994.7 l 328.6,0.5",
    style: {
      fill: "#ccd4d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "m 11064.1,12565.3 190.6,-0.1 61.8,1.2 301.8,-22.3 -207.3,-17.5 -487,0.1 c -5.6,-265.6 -3.3,-689.2 -192.7,-893.2 -63,-2.3 -67.5,2.1 -120.1,38 -21.7,94 6.9,200.7 24.2,293.8 34.3,184.7 90.7,395.4 99.4,581.2 l 0.7,18.3 328.6,0.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "m 11618.3,12544.1 132.5,-0.3 c 65.6,-66.4 73.7,-159.6 97.5,-248.9 60.1,-225.3 95.9,-484.1 182.1,-698.3 -22.2,-51.2 -36.7,-104.8 -87.3,-133.7 l -133.3,2.1 -465.5,-2.7 c 30,139.2 29.2,287.3 36,429.1 l 30.7,635.2 207.3,17.5",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "m 10620.9,11452.2 c 73.4,19.5 164.4,9.2 240.2,9.4 l 483.2,0.7 465.5,2.7 4.8,-201.9 350.9,-2.1 c 19,-0.1 85.8,5.6 98.2,-0.6 14.8,-7.4 23.9,-23 35.8,-34.5 l -13.9,-18 -14.4,-440.6 c -67.4,-0.1 -402.9,16.6 -433.9,-14.7 -21.1,-21.3 -31,-46.7 -42.3,-74 l -12.4,-84.7 c -91,-257.9 -107.5,-536.9 -193.1,-794.2 -98.7,39.6 -311.6,14.1 -423.6,14.1 l -10.5,10.9 c -128.1,185.2 -190.1,421.1 -319,606.4 -23.1,33.2 -53.1,28.7 -91.6,35.9 l -34.3,-25.3 c -48.9,32.6 -119,20.5 -175.9,20.5 l -579.86,-2.1 90.16,453.6 c 19.3,90 50.6,188.4 41.8,280.6 15.3,25 34,46.9 52.1,69.8 l 460.5,4.7 21.6,183.4",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "m 10620.9,11452.2 c 73.4,19.5 164.4,9.2 240.2,9.4 l 483.2,0.7 465.5,2.7 4.8,-201.9 350.9,-2.1 c 19,-0.1 85.8,5.6 98.2,-0.6 14.8,-7.4 23.9,-23 35.8,-34.5 l -13.9,-18 -632.4,-19.5 -1121.8,-12.9 c -140.2,-0.3 -309.8,-18.9 -444.7,18.8 15.3,25 34,46.9 52.1,69.8 l 460.5,4.7 21.6,183.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "m 11344.3,11462.3 465.5,2.7 4.8,-201.9 -495.4,2.1 c -1,69.2 -19.4,142.8 25.1,197.1",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "m 10620.9,11452.2 c 73.4,19.5 164.4,9.2 240.2,9.4 l 483.2,0.7 c -44.5,-54.3 -26.1,-127.9 -25.1,-197.1 l -719.9,3.6 21.6,183.4",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "m 11653.2,11188.4 632.4,19.5 -14.4,-440.6 c -67.4,-0.1 -402.9,16.6 -433.9,-14.7 -21.1,-21.3 -31,-46.7 -42.3,-74 l -12.4,-84.7 c -91,-257.9 -107.5,-536.9 -193.1,-794.2 -98.7,39.6 -311.6,14.1 -423.6,14.1 l -10.5,10.9 c 43.6,138.4 48.8,302.8 68.5,446.8 l 119.3,898.7 310,18.2",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "m 7578.42,9383.6 c 62.03,98.7 109.34,218.8 159.83,324.7 l 352.92,755.5 1863.57,-3.7 579.86,2.1 c 56.9,0 127,12.1 175.9,-20.5 l -707.4,-1394.2 -2571.29,6.4 -5.48,33.9 152.09,295.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 26372.3,14584.8 c 67.9,-0.1 133.9,-0.1 201.3,9.3 l 367.6,-15.7 c 7.5,-68.1 12.4,-117.4 -13,-183.5 l -15.8,-36.9 4.6,-35.1 -12,-53.9 45,-47.4 -10.8,-630.5 c 0.8,-80.5 -8.8,-177.6 9.5,-254.7 l -25.8,-2.6 -732.3,2.9 c -33.7,-91.4 -145.5,-234.6 -220.5,-296.9 -31,-65.8 -86.7,-136.2 -144.4,-181.4 -53.2,-115.9 -198.3,-303.6 -295.5,-386.7 -59.6,-112.3 -160.9,-243.7 -253.7,-330.3 -41.8,-64.8 -87,-119.6 -139.3,-176.1 l -14.4,-21.8 -17.5,-21.5 -318,-451 -267.7,-366.9 -406.2,-562.2 -563.8,-782.5 -1245.8,-13 -637.3,-4.6 -253.5,11.6 -4.8,5 -15.8,40.1 c -24.4,37.5 -400.1,19.7 -481.1,27 l -18.8,1.8 -111.1,16.5 -32.2,62.4 -41.6,2.9 c -202.4,-170.1 -351.3,-149.3 -605.1,-149 l -353.1,1 c -50.7,3 -98.3,4.3 -148.8,-1.6 l -28.1,-55 c -56.6,10 -58,28.4 -91.3,73.2 -3.3,43.8 -15.7,88.9 -24.2,132 l -277.2,-7.2 391.8,506.9 75.7,102 928.6,1252.1 91.2,128.5 c -13.4,65.5 -36,138.1 -32.6,205.1 60.2,23.6 82.3,45.2 115.5,98.1 l 9.4,15.6 28.7,18.9 c 52.2,4.2 102.2,7.6 154.7,4.8 l 286.7,383.5 -47.3,44.6 c -53,67.3 -17.4,153.8 -4.7,232.6 -14.8,13.7 -124.4,109.4 -125.1,116.3 -8,77.9 60.7,170.8 45.3,265.8 -15.2,93.9 -79.9,136.6 -151.4,191.1 l 76.2,94.2 61.2,-51 c 10.8,4.7 24.7,5.2 32.5,14 0.7,0.7 0,43.2 0,45.9 -0.1,96.8 -18.7,241.7 23.6,329.1 l 313.9,-269.3 c 102,-93.8 202.2,-195.3 315.9,-274.9 l 767.5,1075.1 635.9,-2.6 1510.9,0.5 948.2,-0.6 c 133.3,1.3 286.2,-12.1 417.6,8.6 76,47.1 157.8,54 245.2,59.3 l 29.8,-38.1 c 6.1,44.9 28.6,85.5 47.6,126.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "m 21177.5,12895.2 c 82.3,-2.6 164.3,-2.9 245.2,-20.3 l -193.2,-256.9 -47.3,44.6 c -53,67.3 -17.4,153.8 -4.7,232.6",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "m 20788.1,12229.7 c 52.2,4.2 102.2,7.6 154.7,4.8 l -275.7,-342.5 c -13.4,65.5 -36,138.1 -32.6,205.1 60.2,23.6 82.3,45.2 115.5,98.1 l 9.4,15.6 28.7,18.9",
    style: {
      fill: "#acda22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "m 26372.3,14584.8 c 67.9,-0.1 133.9,-0.1 201.3,9.3 14.9,-61.8 17.1,-115.1 0.2,-176.8 l -524.1,20.1 c 76,47.1 157.8,54 245.2,59.3 l 29.8,-38.1 c 6.1,44.9 28.6,85.5 47.6,126.2",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "m 26573.6,14594.1 367.6,-15.7 c 7.5,-68.1 12.4,-117.4 -13,-183.5 -56.9,41.4 -276.7,21.3 -354.4,22.4 16.9,61.7 14.7,115 -0.2,176.8",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "m 19457,9909.7 1250.6,-0.6 c -202.4,-170.1 -351.3,-149.3 -605.1,-149 l -353.1,1 c -50.7,3 -98.3,4.3 -148.8,-1.6 l -28.1,-55 c -56.6,10 -58,28.4 -91.3,73.2 -3.3,43.8 -15.7,88.9 -24.2,132",
    style: {
      fill: "#ac601e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "m 19611.2,10039.7 -14.6,-7.7 c -38.5,-12.7 -136.8,-7.7 -170.1,13.8 83.9,153.9 215.7,296.4 319.6,438.8 120.7,165.3 235.6,362.3 375.7,510.1 19.1,20.1 174.4,12.9 211.7,13.7 -59.8,-58.9 -128.4,-130.2 -165.6,-202.6 l -173.1,-219.7 c -129.9,-178.5 -283.5,-348.5 -383.6,-546.4",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "m 20416.9,11147.9 -11.5,-6.1 c -37.7,-11.2 -120.4,-11.2 -150.3,12.1 l 746.1,1003.8 c 69.5,8.8 131.9,3.9 201.2,-2.9 l -89.6,-123.5 c -50.6,-70.6 -120.9,-118.3 -173.3,-186.7 -29.1,-38.1 -53.3,-62.7 -75.6,-104.8 l -447,-591.9",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "m 23594.1,14301.8 c 52.9,34.8 121.3,21.2 182.3,18 l 8.2,-21.7 -731.8,-953.2 c -52.6,-0.1 -140.3,-12.2 -183.1,19.8 22.8,20.4 58.9,44.8 68.6,73.9 11.7,35.4 54.5,56.8 73.8,91.7 53.9,97.7 165,183 214.6,279.3 46.5,90.3 128.1,154.7 183.2,238.1 25.8,39.1 62.4,100.1 95.7,132.3 41.5,40.2 64.7,68.9 88.5,121.8",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "m 22762.1,13207.5 c 63.5,49.2 164.7,34.4 242,32.9 l -729.5,-950.3 c -62.7,1.8 -133.3,-2.7 -194.4,11.2 82.4,70.4 132.1,158.2 194,244.6 54.7,76.3 126.2,147.9 174,228.8 31.3,53.1 81.2,95.2 109.9,146.5 39.7,71.2 109.9,120 110.2,201.5 l 93.8,84.8",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "m 26378,14305.8 c 73,27.8 133.6,25.6 210,22.4 -10,-74.1 -658.9,-857.8 -748.8,-976.2 -77.2,0.3 -161.5,-5.4 -236.9,9.6 l 59.8,30.7 c 15.9,54.9 97.9,113.6 129.2,160.9 72.8,110.6 180.7,207.3 247.2,320.4 27.3,46.7 79.8,77.2 109.9,128.2 17.8,30.6 65.4,63.9 91.1,90.3 53.2,54.5 116.2,138.2 138.5,213.7",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "m 25000,14303.9 c 66.9,35.2 141.2,24.7 214.4,21.6 l 9.1,-21.5 -748.1,-956.3 -223.4,4.5 165.4,182.7 c 71.9,138.7 214.5,261 302.2,393.7 15.9,24.1 48.1,40 64.2,64.2 36.7,55.5 85,141.9 132.4,187.2 43.2,41.2 63.3,67.5 83.8,123.9",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "m 21129.9,10980.5 c 64.7,39.9 116.8,26.4 191.9,24.7 l 7.2,-20.2 -482.2,-639.6 c -77.6,-102.1 -164.1,-237.2 -266.9,-314.6 -59.4,0.4 -132.2,-7.5 -189.6,6.3 63.5,63.6 115.2,144.3 172.5,213.9 l 567.1,729.5",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "m 24085.4,12310.3 c -46.9,-30.6 -171.7,-18.1 -231.6,-19.7 l 721.2,942.4 227.6,-11.1 c -49,-46.8 -97.9,-86 -128.7,-145.1 l -540.2,-695.8 -48.3,-70.7",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "m 25181.9,13749.9 c -60.3,-131.9 -210,-283 -299.6,-400.9 l -214,-1.1 739.8,974.4 c 64.7,2 140.2,18 197.1,-13.8 -17.1,-61.9 -76,-114.7 -116,-164.8 -100.4,-125.6 -220.8,-259.7 -307.3,-393.8",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path189",
    d: "m 21859.2,11152.5 c -72.5,-19.4 -160.5,-23.1 -233.8,-7.8 60.4,134.5 196.4,271.5 286.2,391.9 l 455.8,630.1 210.2,-5.4 c -36.4,-39.9 -65.5,-72.5 -92.6,-119.4 l -586,-787.3 17.9,-27.5 -57.7,-74.6",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "m 21036.8,10049.6 -3.9,-0.6 c -70.3,-35.9 -161.9,-23.1 -240.5,-21.5 l 377.9,501.3 c 105.1,148 210.1,333 340.5,458.2 35.9,34.5 160.3,17.6 214,16.8 -24.7,-30.6 -50,-60.3 -69.8,-94.3 -55.2,-94.4 -367.9,-428.1 -356.3,-508 -17.9,-44.5 -34.2,-76.4 -66,-112.4 -67.4,-76.4 -120.8,-170.7 -195.9,-239.5",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "m 23251.2,11153.4 c -52.4,-32.2 -178.1,-17.9 -241.9,-17.9 l 766.5,1029.6 211.2,-5.9 2.5,-32.1 c -26.5,-24 -85.7,-64.6 -96.2,-96 -13.9,-41.6 -69.7,-92.7 -98.5,-128.7 -89.6,-112 -186,-224.3 -261.5,-345.6 -12.4,-20 -28.9,-33.7 -45.6,-49.9 -35,-34.2 -49.3,-70.9 -86.7,-105.8 l 36.3,-18.3 -18.1,-18.2 -18.4,18 -36.4,-36.5 34.7,-18.3 -53.2,-54.7 -18.3,17.9 -18.2,-18.1 34.9,-18.3 -53.4,-54.8 -18.3,18 c -16.7,-24.2 -21.4,-34.9 -21.4,-64.4",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "m 21979.1,12158.9 c 73.6,19.3 153,13.1 228.6,12.3 l -557.5,-746.3 c -45,-61.5 -142.3,-228.1 -203.4,-267.9 -6.3,-4.1 -39.7,-6.3 -47.2,-7.1 -43.7,-4.4 -88.9,-1 -132.8,0.8 -6.8,13.9 -13.7,20 -10.7,35.6 22.5,18.5 37.4,30.2 52.6,55.4 24.2,40.3 65.7,73 86.3,113.7 41.5,82 118.3,142.7 164.8,219.8 42.6,70.5 101.6,159.3 161.3,217.8 l 11.4,11 -25.3,27.4 145.9,183.2 c 30.1,58.5 78,97.6 126,144.3",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path193",
    d: "m 23467.1,13354 c -47.8,-26.2 -173,-13.1 -230.9,-13.6 l 740,982.5 242.8,-6.3 c -23,-25.2 -61.2,-58.9 -71.7,-90.5 -16.1,-48.7 -88,-109.2 -114.6,-160.1 l -82.3,-91.6 -27.4,-0.1 -320.5,-421.2 c -45.5,-63.2 -109.1,-124.8 -135.4,-199.1",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "m 23330.2,12108.4 c 21.4,14.4 58.4,49.6 79.8,57.9 40.5,15.8 161.6,1.5 210.5,1.9 l -602.6,-787.8 c -56.5,-71.3 -134.4,-197.8 -212.4,-241.9 l -155.7,0.3 -26.2,36.4 c 32.7,87.4 118,177.1 172.9,253.4 l 366.2,485.1 c 26.2,36.9 75.5,75.6 89.5,117.4 8.5,25.4 56.1,58.1 78,77.3",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path195",
    d: "m 22215.3,13338.3 -115,1.2 -15.7,27.9 -35.8,-27.7 c -52.1,-2 -132.1,-19.9 -172.7,12 196.7,340.4 479.3,647.7 708.9,968.2 l 203.3,-5.9 c 5.4,-22.8 9.1,-41.5 8.1,-64.9 l 18.3,-27.7 -41.2,-27.4 -0.2,-10.4 c -6.9,-90.8 -182.1,-280.7 -239.5,-364.9 -12.7,-18.7 -16.4,-28.9 -21.3,-50.4 -18.3,-81.9 -77.2,-133.1 -126.6,-197 l -170.6,-233",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "m 21295.6,12316.8 -28.8,-25.8 c -55,-3.5 -106.4,-10.6 -159.5,7.5 l 511.1,679.7 c 53.5,69.9 114.2,181.6 179.6,236.2 36.5,30.4 109.5,14.7 155.8,13.1 l 1.4,-35.7 c 23.1,4 41.1,26.5 62.7,32.3 38.4,10.4 108,1.3 149.9,1.8 -66.6,-96.1 -130.7,-201.7 -204.1,-292.6 -41.8,-51.8 -98.7,-90.1 -139.3,-142.9 -67.7,-87.9 -118.5,-227.5 -202.3,-300 l -20.7,32.7 -134.8,-234.2 c -65,-3 -112.9,-7.8 -171,27.9",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path197",
    d: "m 23040.4,9909.6 396.6,-4.9 c 35.1,-77.7 37.6,-99.9 112.6,-145.3 l -1245.8,-13 -637.3,-4.6 -253.5,11.6 -4.8,5 -15.8,40.1 c -24.4,37.5 -400.1,19.7 -481.1,27 l -18.8,1.8 -111.1,16.5 -32.2,62.4 2291.2,3.4",
    style: {
      fill: "#464346",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "m 21022.5,13562.6 61.2,-51 c 10.8,4.7 24.7,5.2 32.5,14 0.7,0.7 0,43.2 0,45.9 -0.1,96.8 -18.7,241.7 23.6,329.1 l 313.9,-269.3 c 102,-93.8 202.2,-195.3 315.9,-274.9 l -346.9,-481.5 c -80.9,17.4 -162.9,17.7 -245.2,20.3 -14.8,13.7 -124.4,109.4 -125.1,116.3 -8,77.9 60.7,170.8 45.3,265.8 -15.2,93.9 -79.9,136.6 -151.4,191.1 l 76.2,94.2",
    style: {
      fill: "#34702f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path199",
    d: "m 22167.8,13225.9 c 102.4,1.3 538.8,35.6 594.3,-18.4 l -93.8,-84.8 c -0.3,-81.5 -70.5,-130.3 -110.2,-201.5 -28.7,-51.3 -78.6,-93.4 -109.9,-146.5 -47.8,-80.9 -119.3,-152.5 -174,-228.8 -61.9,-86.4 -111.6,-174.2 -194,-244.6 -182.4,-40.4 -424.1,-7.3 -613.6,-12.4 l 134.8,234.2 20.7,-32.7 c 83.8,72.5 134.6,212.1 202.3,300 40.6,52.8 97.5,91.1 139.3,142.9 73.4,90.9 137.5,196.5 204.1,292.6",
    style: {
      fill: "url(#linearGradient200)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath200)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    d: "m 22788.3,14314 c 138.8,2.7 711.4,43.2 805.8,-12.2 -23.8,-52.9 -47,-81.6 -88.5,-121.8 -33.3,-32.2 -69.9,-93.2 -95.7,-132.3 -55.1,-83.4 -136.7,-147.8 -183.2,-238.1 -49.6,-96.3 -160.7,-181.6 -214.6,-279.3 -19.3,-34.9 -62.1,-56.3 -73.8,-91.7 -9.7,-29.1 -45.8,-53.5 -68.6,-73.9 l -78.1,-30.4 -39.8,15.6 -536.5,-11.6 170.6,233 c 49.4,63.9 108.3,115.1 126.6,197 4.9,21.5 8.6,31.7 21.3,50.4 57.4,84.2 232.6,274.1 239.5,364.9 l 0.2,10.4 41.2,27.4 -18.3,27.7 c 1,23.4 -2.7,42.1 -8.1,64.9",
    style: {
      fill: "url(#linearGradient202)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path203",
    d: "m 22751.8,13349.9 -10.4,60.9 -24.5,-13.4 c 27.8,52.9 67.4,139.8 118.8,170.8 l 10.5,0.4 c 18.6,2.4 30,11.2 45.3,21.1 l 14.8,27.3 17.5,-27.3 c -42.2,-94.6 -105.5,-149.5 -132.2,-255.4 l -39.8,15.6",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "m 24802.6,13221.9 c 90.4,22.3 186.2,11.4 278.7,10.3 l 389.6,5.1 21.7,-27.2 -43.2,-62.1 1.7,-43.6 c -35.4,-34.5 -58.6,-57.1 -81.3,-100.6 -75.3,-144.4 -243.8,-261.6 -324.4,-407.6 -39.1,-70.6 -113.6,-124.2 -151.7,-196.8 l -79.3,-98.3 c -115.1,-26.7 -257.7,-11 -375.9,-10.6 -110,0.2 -248.3,-15.6 -353.1,19.8 l 48.3,70.7 540.2,695.8 c 30.8,59.1 79.7,98.3 128.7,145.1",
    style: {
      fill: "url(#linearGradient205)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "m 25605.2,14308.5 c 103.8,30.1 219.6,19.7 326.8,19.3 140.9,-0.5 285.7,5.3 425.9,-6.6 l 20.1,-15.4 c -22.3,-75.5 -85.3,-159.2 -138.5,-213.7 -25.7,-26.4 -73.3,-59.7 -91.1,-90.3 -30.1,-51 -82.6,-81.5 -109.9,-128.2 -66.5,-113.1 -174.4,-209.8 -247.2,-320.4 -31.3,-47.3 -113.3,-106 -129.2,-160.9 l -59.8,-30.7 c -88.4,-28.5 -214.2,-10.3 -307.5,-8.4 l -209.1,-0.6 c -49.6,-4.5 -96.7,-1.5 -146.3,2.1 -1.5,37.1 24.7,58.5 46.4,87.5 62.5,83.1 187.8,207.3 196.1,307.7 86.5,134.1 206.9,268.2 307.3,393.8 40,50.1 98.9,102.9 116,164.8",
    style: {
      fill: "url(#linearGradient207)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "m 25085.7,13352.6 10.5,8.6 c 78.9,66.6 127.5,156.7 200.5,228.4 14.4,-10.2 19.6,-18.1 37.9,-18.3 l 4.1,9.8 c 31.5,68.3 77,112.6 116.8,173.4 22,33.7 29.3,75.9 52,110 45.7,68.1 110.9,129.5 160,197.8 32.9,-16.9 45.4,-25.1 65.4,-58.1 -30.5,-74 -95.9,-133.5 -118.4,-206.6 l 24.9,-6.5 -132.1,-192.2 -24.9,12.4 c -47.7,-57.6 -94.1,-113.2 -132.4,-177.2 -16.6,-27.7 -32.5,-57.8 -55.2,-80.9 l -209.1,-0.6",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path209",
    d: "m 23989.5,12127.1 c 94.5,64.8 280.6,37.1 397.9,37.7 l 166.6,2.8 194.2,-5 c -41.8,-40.3 -73.8,-69.7 -101.9,-120.5 -30.5,-54.9 -99.1,-95.8 -128.2,-146.5 -80.1,-139 -200.7,-256.1 -283.9,-393.7 -31.4,-52 -81.4,-90.1 -109.9,-146.5 -20.9,-41.4 -63,-72 -86.1,-113.8 -18.9,-34.2 -48.4,-61.2 -75.3,-89 l -11.3,-6.2 c -104.9,-42.7 -357.8,-3 -477.5,-4 -75.7,-0.7 -151.1,-18 -222.9,11 0,29.5 4.7,40.2 21.4,64.4 l 18.3,-18 53.4,54.8 -34.9,18.3 18.2,18.1 18.3,-17.9 53.2,54.7 -34.7,18.3 36.4,36.5 18.4,-18 18.1,18.2 -36.3,18.3 c 37.4,34.9 51.7,71.6 86.7,105.8 16.7,16.2 33.2,29.9 45.6,49.9 75.5,121.3 171.9,233.6 261.5,345.6 28.8,36 84.6,87.1 98.5,128.7 10.5,31.4 69.7,72 96.2,96",
    style: {
      fill: "url(#linearGradient210)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath210)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path211",
    d: "m 24387.4,12164.8 166.6,2.8 c -27.8,-85.9 -83.3,-138.1 -142.8,-203.5 l -42,21.7 c 27.3,32.5 38.8,40.8 45.1,83.7 l -24.3,9.1 -2.6,86.2",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "m 22577.6,12161.3 750,5.3 13.6,-23.8 -11,-34.4 c -21.9,-19.2 -69.5,-51.9 -78,-77.3 -14,-41.8 -63.3,-80.5 -89.5,-117.4 l -366.2,-485.1 c -54.9,-76.3 -140.2,-166 -172.9,-253.4 -86.1,-56.4 -174.5,-37.1 -276.3,-37.4 l -466.8,-1 -21.3,15.7 57.7,74.6 -17.9,27.5 586,787.3 c 27.1,46.9 56.2,79.5 92.6,119.4",
    style: {
      fill: "url(#linearGradient213)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "m 24219,14316.6 c 128.4,9.4 706.2,39.7 781,-12.7 -20.5,-56.4 -40.6,-82.7 -83.8,-123.9 -47.4,-45.3 -95.7,-131.7 -132.4,-187.2 -16.1,-24.2 -48.3,-40.1 -64.2,-64.2 -87.7,-132.7 -230.3,-255 -302.2,-393.7 l -165.4,-182.7 c -153.1,-14.9 -312,-7.9 -465.8,-8.8 -102.7,-0.6 -218.7,-12.4 -319.1,10.6 26.3,74.3 89.9,135.9 135.4,199.1 l 320.5,421.2 27.4,0.1 82.3,91.6 c 26.6,50.9 98.5,111.4 114.6,160.1 10.5,31.6 48.7,65.3 71.7,90.5",
    style: {
      fill: "url(#linearGradient215)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "m 20333.5,11008.4 554.1,1.6 c 91,0.3 161.8,14.1 242.3,-29.5 l -567.1,-729.5 c -57.3,-69.6 -109,-150.3 -172.5,-213.9 -125.5,-34.6 -660.4,-40.6 -779.1,2.6 100.1,197.9 253.7,367.9 383.6,546.4 l 173.1,219.7 c 37.2,72.4 105.8,143.7 165.6,202.6",
    style: {
      fill: "url(#linearGradient217)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "m 21202.4,12154.8 c 99.3,28.4 228.7,14.2 332.2,14.9 139,0.8 309.4,21.1 444.5,-10.8 -48,-46.7 -95.9,-85.8 -126,-144.3 l -145.9,-183.2 25.3,-27.4 -11.4,-11 c -59.7,-58.5 -118.7,-147.3 -161.3,-217.8 -46.5,-77.1 -123.3,-137.8 -164.8,-219.8 -20.6,-40.7 -62.1,-73.4 -86.3,-113.7 -15.2,-25.2 -30.1,-36.9 -52.6,-55.4 -115.1,-70.1 -243.2,-47 -375.9,-47.3 -153,-0.2 -311.2,-9.1 -463.3,8.9 l 447,591.9 c 22.3,42.1 46.5,66.7 75.6,104.8 52.4,68.4 122.7,116.1 173.3,186.7 l 89.6,123.5",
    style: {
      fill: "url(#linearGradient219)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "m 23545.4,11013.4 c 90.1,1.9 252.5,26.7 327.4,-22.7 -117.2,-178 -263.2,-362.4 -397.8,-527.7 -86,-105.5 -192.1,-222.4 -261.4,-338.8 -15.3,-25.8 -30.8,-38.7 -53.4,-58.1 l -48.2,-9.4 c -34.7,-30.1 -119.3,-18.9 -166.5,-19.2 l -491.7,-2 238.2,326.4 c -98.6,-71.5 -191.4,-225.6 -269.6,-324.2 -66.4,-3.2 -142.2,-15.6 -205.2,8.1 l 716.7,962.5 c 74.5,2.6 154.9,15.9 221.4,-22.4 71.6,55.1 295.7,27.9 390.1,27.5",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path221",
    d: "m 23545.4,11013.4 c 90.1,1.9 252.5,26.7 327.4,-22.7 -117.2,-178 -263.2,-362.4 -397.8,-527.7 -86,-105.5 -192.1,-222.4 -261.4,-338.8 -15.3,-25.8 -30.8,-38.7 -53.4,-58.1 l -48.2,-9.4 -279,7.2 -0.5,36.8 55.3,55 27.6,-14.7 c 51,41.1 80.3,79.1 114.6,133.7 l -15,36.6 68.5,97.8 24.3,-33.5 85.3,100.6 -12.1,27.3 -48.4,-54.8 -9.3,9.2 c 55.3,75.2 120.7,138 177.9,210.6 37.7,47.9 67,114.1 114,152.1 16.6,13.5 19.7,17.3 29.8,35.2 l 100.4,157.6",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "m 21788.5,11006.3 696.5,9.5 18.3,-23.2 c -12,-21.3 -28.8,-44.9 -36.9,-67.8 l 91.8,83.8 c 54.8,3.5 121.5,15.4 174.1,-1.3 l 3.6,-18.6 -496,-660.7 c -69.9,-92.5 -143.8,-218.2 -230.2,-291.4 l -228.2,0.2 c 49,63.7 103.5,127.4 141,198.6 -59.6,-55.9 -115.3,-141.6 -175.1,-189.6 -16.3,-13.1 -101.2,-13.2 -124.6,-14.2 l -123,7.6 -310.9,-8.3 c -56.4,-1.6 -98.6,-3.3 -152.1,18.7 75.1,68.8 128.5,163.1 195.9,239.5 31.8,36 48.1,67.9 66,112.4 -11.6,79.9 301.1,413.6 356.3,508 19.8,34 45.1,63.7 69.8,94.3 l 63.7,2.5",
    style: {
      fill: "url(#linearGradient223)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "m 21724.8,11003.8 63.7,2.5 c 20.2,-26.9 25.8,-47 59.9,-54 -12.9,-25.9 -16.9,-29.5 -41,-45.7 l 18.1,-18.2 18.3,18 15.3,-18.1 c -114.8,-165.7 -254.5,-333.5 -343,-513.3 l -56.9,-80.4 c -17.6,27 -3.5,53.2 2.8,84 l -98.6,-95.6 66,147.4 c -11.4,4.5 -21.7,9.5 -34.3,10 -35.9,1.5 -68,-20 -96.4,-38.9 -11.6,79.9 301.1,413.6 356.3,508 19.8,34 45.1,63.7 69.8,94.3",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path225",
    d: "m 21298.7,10401.5 c 28.4,18.9 60.5,40.4 96.4,38.9 12.6,-0.5 22.9,-5.5 34.3,-10 l -66,-147.4 98.6,95.6 c -6.3,-30.8 -20.4,-57 -2.8,-84 l 56.9,80.4 -15.3,-109.4 c 40.9,19.4 45.8,35.1 69.6,72.5 l 2.6,-72.5 41.9,12.8 c 17.9,-24.9 10.8,-11.3 21.1,-40.9 l 30.6,13.7 c -8.6,-29.9 -19.1,-44.7 -39.5,-68 32.9,-8 32.9,-6 63.6,9.1 l -48.3,-105.8 -142.6,-47.3 -310.9,-8.3 c -56.4,-1.6 -98.6,-3.3 -152.1,18.7 75.1,68.8 128.5,163.1 195.9,239.5 31.8,36 48.1,67.9 66,112.4",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "m 22466.4,10924.8 91.8,83.8 c 54.8,3.5 121.5,15.4 174.1,-1.3 l 3.6,-18.6 -496,-660.7 c -69.9,-92.5 -143.8,-218.2 -230.2,-291.4 l -228.2,0.2 c 49,63.7 103.5,127.4 141,198.6 -59.6,-55.9 -115.3,-141.6 -175.1,-189.6 -16.3,-13.1 -101.2,-13.2 -124.6,-14.2 l -123,7.6 142.6,47.3 48.3,105.8 c -30.7,-15.1 -30.7,-17.1 -63.6,-9.1 20.4,23.3 30.9,38.1 39.5,68 l -30.6,-13.7 c -10.3,29.6 -3.2,16 -21.1,40.9 l -41.9,-12.8 -2.6,72.5 139.5,226.4 c 34.8,63.3 71.2,120.1 115.5,177.2 16.3,4.2 58.9,20.6 73.4,18.6 41.1,-5.9 51.2,-36.8 109.9,-37 l -34.9,-68.6 -1.6,-22.8 45.7,36.4 26.3,-14.5 c -17.1,-71.7 -64.8,-114.3 -91.3,-178.6 l -19,-127.6 c 35.6,-4.4 64.8,17.4 95,33.7 24.8,70.5 222,326.8 287.2,359.6 l 40.5,19.2 c 32.8,58.7 77.9,104.4 109.8,164.7",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path227",
    d: "m 23464.4,12308.3 c -63.6,-24.3 -161.1,-14.6 -228.8,-14.8 l -521.7,-1.6 -23.1,26.4 -41,-27.7 c -52.8,-1.2 -146.6,-19.1 -186,14.2 l 703.5,934.8 186.4,-3.4 7,-42.4 58.5,46.2 c 230.3,0.7 503,31.3 728.1,-7.4 l -5.1,-53.9 c 15,13.5 47.9,51.9 64.6,58.4 36.1,13.9 154.3,-2.2 198.6,-2.8 l -733.2,-941 c -64.2,-0.4 -149,-12.3 -207.8,15",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "m 25514.1,13224.6 c 55,23.4 126.3,30 185.6,18.8 24.9,-4.7 40.8,-9.4 66.9,-5.4 36.4,5.6 109.9,17.6 141,36.9 32.4,20.3 78.4,92 103.8,124.8 l 233.2,290.7 c 23.5,30.9 33.2,48.7 72.1,62.5 -5.9,-87.7 -530.3,-698.1 -610.1,-804.6 L 24199.9,10958 23437,9904.7 l -396.6,4.9 c 76.4,11.2 159.2,19.4 232.2,44.4 0.2,47 -0.1,46.4 -30,82.7 -41.5,3.9 -49.1,1.9 -82.4,29.4 22.6,19.4 38.1,32.3 53.4,58.1 69.3,116.4 175.4,233.3 261.4,338.8 134.6,165.3 280.6,349.7 397.8,527.7 l 32.2,25.6 c 31.8,17 79.4,18.2 115.6,23.2 l 29.5,92.7 -87.2,20.4 c 26.9,27.8 56.4,54.8 75.3,89 23.1,41.8 65.2,72.4 86.1,113.8 28.5,56.4 78.5,94.5 109.9,146.5 83.2,137.6 203.8,254.7 283.9,393.7 29.1,50.7 97.7,91.6 128.2,146.5 28.1,50.8 60.1,80.2 101.9,120.5 l 162.9,-1.9 c 39.1,22.1 60.8,86.4 80.3,125.8 l -177,14.6 79.3,98.3 c 38.1,72.6 112.6,126.2 151.7,196.8 80.6,146 249.1,263.2 324.4,407.6 22.7,43.5 45.9,66.1 81.3,100.6 l -1.7,43.6 c 41,27.1 45.6,31.4 64.7,76.6",
    style: {
      fill: "#ccd4d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path229",
    d: "m 25514.1,13224.6 c 66.2,3.1 139.5,13.9 203.9,-2.7 l 4.2,-17.1 -557.8,-718.5 c -35.5,-45.5 -120.7,-182.1 -173,-199.8 l -177,14.6 79.3,98.3 c 38.1,72.6 112.6,126.2 151.7,196.8 80.6,146 249.1,263.2 324.4,407.6 22.7,43.5 45.9,66.1 81.3,100.6 l -1.7,43.6 c 41,27.1 45.6,31.4 64.7,76.6",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "m 23905,11016.3 155.3,-10.7 c -2.8,-36.9 -635.5,-905.7 -696.8,-952.9 -30.7,-23.6 -83.1,-15.6 -120.9,-16 -41.5,3.9 -49.1,1.9 -82.4,29.4 22.6,19.4 38.1,32.3 53.4,58.1 69.3,116.4 175.4,233.3 261.4,338.8 134.6,165.3 280.6,349.7 397.8,527.7 l 32.2,25.6",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path231",
    d: "m 24748.2,12162.6 162.9,-1.9 c -58.4,-127.6 -169.3,-247.2 -254,-360.6 l -493.8,-651.6 -113.2,-16.3 -87.2,20.4 c 26.9,27.8 56.4,54.8 75.3,89 23.1,41.8 65.2,72.4 86.1,113.8 28.5,56.4 78.5,94.5 109.9,146.5 83.2,137.6 203.8,254.7 283.9,393.7 29.1,50.7 97.7,91.6 128.2,146.5 28.1,50.8 60.1,80.2 101.9,120.5",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "m 26912.4,14358 4.6,-35.1 -12,-53.9 45,-47.4 -10.8,-630.5 c 0.8,-80.5 -8.8,-177.6 9.5,-254.7 l -25.8,-2.6 -732.3,2.9 c -33.7,-91.4 -145.5,-234.6 -220.5,-296.9 -31,-65.8 -86.7,-136.2 -144.4,-181.4 -53.2,-115.9 -198.3,-303.6 -295.5,-386.7 -59.6,-112.3 -160.9,-243.7 -253.7,-330.3 -41.8,-64.8 -87,-119.6 -139.3,-176.1 l -14.4,-21.8 -17.5,-21.5 -318,-451 -267.7,-366.9 -406.2,-562.2 -563.8,-782.5 c -75,45.4 -77.5,67.6 -112.6,145.3 l 762.9,1053.3 1506.7,1990.3 c 79.8,106.5 604.2,716.9 610.1,804.6 77.6,47.6 136.2,148.3 192.2,220.4 l 233.5,297.7 c 14.4,16.7 54.4,66.5 73.7,74.9 20.5,8.9 72.3,9.1 96.3,12.1",
    style: {
      fill: "url(#linearGradient233)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "m 26905,14269 45,-47.4 -10.8,-630.5 c 0.8,-80.5 -8.8,-177.6 9.5,-254.7 l -25.8,-2.6 -732.3,2.9 c 157.1,135.6 290.7,369.8 418.2,537.2 92.3,121.2 230.5,259.3 296.2,395.1",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path235",
    d: "m 29323.2,17435.3 107,-39.7 173.4,3.4 c 2.7,-102.7 73.5,-242.4 57.6,-330 65,-183.7 41.8,-450 54,-646.8 l 85.7,-2832 5.4,-661.2 c 1,-125.7 10.5,-258.9 -3.4,-383.5 108.2,-35.2 206.4,-126.7 293.8,-197.3 238.6,-192.3 465.8,-401.5 673.4,-626.8 53.7,-58.3 147,-142.7 180.2,-213.6 l 6.4,-22.6 c 39.3,-36.3 63.7,-63.1 82.8,-113.5 82.3,-58 268.1,-287.3 295.2,-383.7 l 3.2,-18.7 36.6,-59.1 c 18.4,-19.6 45,-41.4 55,-66.2 l 37.9,-63 c 77.1,-72.7 222.7,-227.6 254.4,-327.6 l 9.6,-41.3 c -166.8,-201.7 -279.9,-419.6 -331.5,-677.4 -15.6,-78.7 -10.2,-159.8 -51,-230.8 48.8,-81.5 30,-204.3 27.8,-296.7 -233.9,-54.2 -444,-151.8 -577.1,-363.7 l -9.8,-16.1 c -14.6,-21.9 -31.2,-30 -54.2,-41.7 -68.4,64.1 -159.7,118.9 -240.1,168.1 l -654.3,438 c -76.4,62.2 -162.4,151 -262,167.6 -42.5,28.8 -137.3,20.2 -190.5,23.1 l -157.3,-5.7 -245.7,9.6 -103.8,-6.6 -474.8,-3.1 -383.5,-0.4 c -122.1,14.1 -258.1,5.7 -381.7,7.4 l -24.4,0.3 -18.4,-6 h -418.8 l -366.9,16.8 -72.7,-16.2 c -88.2,11.8 -185.7,5 -274.8,6.1 l -48.6,-7.8 c -168.3,18.5 -351.5,5.3 -520.7,-0.5 l -96.7,6.4 -230.8,-6.6 -332.9,10.5 c -30.8,0.9 -102.1,12.1 -129.5,3.9 -86.7,-26.2 -218.8,-151.3 -304.3,-202.5 l -237.6,-168.9 -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 406.2,562.2 267.7,366.9 318,451 17.5,21.5 14.4,21.8 c 52.3,56.5 97.5,111.3 139.3,176.1 92.8,86.6 194.1,218 253.7,330.3 97.2,83.1 242.3,270.8 295.5,386.7 153.2,-0.7 1023.4,22.9 1096.2,-16.9 l 750.8,11.5 403.4,0.1 19.8,6.2 c 215.7,-12.1 461.6,-21.3 676.1,0.5 l 367.8,-1.8 14.6,19.2 c 30.6,46 11.3,77.1 -1.7,126 l 5.4,46.3 -32,27 49.3,27.9 79.4,2435 56,1251 21.2,378.7 c 5.6,88.3 21,181 -8.8,266.2",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "m 28828.4,12140.3 c 84.7,1.5 179.7,11.7 263.3,1.4 19.5,-26.4 33.2,-51.1 33.4,-84.5 1.2,-189.1 -23.4,-385.5 -33.2,-575.1 l -51.5,-1115.4 -24.7,-527.9 c -2.2,-61.1 9.8,-137.7 -2.2,-196 -5.1,-23.8 -14.4,-36.6 -27.8,-56.4 l -103.8,-6.6 2.4,16.1 c 5.6,22.5 5.6,27.7 -3.4,49.6 -63,153.1 -29.3,407.3 -29.6,576.1 v 1472.1 c 0.3,112.6 30.6,290.5 8.1,394.5 -2.7,13.4 -23.2,39.2 -31,52.1",
    style: {
      fill: "#286d49",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path237",
    d: "m 28067.1,12145.2 761.3,-4.9 c 7.8,-12.9 28.3,-38.7 31,-52.1 22.5,-104 -7.8,-281.9 -8.1,-394.5 v -1472.1 c 0.3,-168.8 -33.4,-423 29.6,-576.1 9,-21.9 9,-27.1 3.4,-49.6 l -232.5,-2 6.4,732.8 c 0.4,66.2 17.3,179.3 2.2,241.1 -3,12.1 -31.3,41.9 -39.9,53.5 12.7,17.1 24.9,35.5 31.1,56.2 20,67.6 7,120.6 -25.2,181.5 9.3,10.4 38.8,36.2 42.7,47.6 16.4,46.8 0.3,177.2 0.3,231.3 l 0.7,826.1 -584.7,1.6 c 0.5,51.6 2.7,101.7 -8,152.5 l -1101.3,17.1 -20.3,1.8 743.2,3.4 c 118.5,0.6 251.4,-10 368.1,4.8",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "m 28085.4,11965.6 584.7,-1.6 -0.7,-826.1 c 0,-54.1 16.1,-184.5 -0.3,-231.3 -3.9,-11.4 -33.4,-37.2 -42.7,-47.6 l -591.3,5.7 6.6,8.4 c 53,76.7 36.1,953.7 13.2,1086 l 30.5,6.5",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "m 28772,12859.8 367.8,-1.8 c 40.3,-77.9 33.2,-290.9 4.6,-373.3 -6.6,-18.8 -20.5,-36.7 -33.4,-51.6 50.8,-68 31,-147.3 22.4,-226.1 l -41.7,-65.3 c -83.6,10.3 -178.6,0.1 -263.3,-1.4 l -761.3,4.9 c 58.4,98.2 18.6,181.5 43.7,288.9 l -18.8,6.5 c 16.4,93.8 31.3,334 -15.9,412.5 l 19.8,6.2 c 215.7,-12.1 461.6,-21.3 676.1,0.5",
    style: {
      fill: "#d47b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "m 28110.8,12434.1 641.9,-4.1 c 116.5,-0.7 243.2,-11.2 358.3,3.1 50.8,-68 31,-147.3 22.4,-226.1 l -41.7,-65.3 c -83.6,10.3 -178.6,0.1 -263.3,-1.4 l -761.3,4.9 c 58.4,98.2 18.6,181.5 43.7,288.9",
    style: {
      fill: "#ac601e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path241",
    d: "m 27672.7,12853 403.4,0.1 c 47.2,-78.5 32.3,-318.7 15.9,-412.5 l 18.8,-6.5 c -25.1,-107.4 14.7,-190.7 -43.7,-288.9 -116.7,-14.8 -249.6,-4.2 -368.1,-4.8 l -743.2,-3.4 -13.2,6.1 c 36.7,83.2 10.8,200.9 2.7,290.6 l -27.6,5 29.8,43 c 1,113.3 18.1,254 -25.6,359.8 l 750.8,11.5",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "m 28092,12440.6 18.8,-6.5 c -25.1,-107.4 14.7,-190.7 -43.7,-288.9 -116.7,-14.8 -249.6,-4.2 -368.1,-4.8 l -743.2,-3.4 -13.2,6.1 c 36.7,83.2 10.8,200.9 2.7,290.6 l 775.5,-3.8 c 114.3,-0.4 263.3,-18.7 371.2,10.7",
    style: {
      fill: "#c6751c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path243",
    d: "m 28035.1,10864.7 591.3,-5.7 c 32.2,-60.9 45.2,-113.9 25.2,-181.5 -6.2,-20.7 -18.4,-39.1 -31.1,-56.2 8.6,-11.6 36.9,-41.4 39.9,-53.5 15.1,-61.8 -1.8,-174.9 -2.2,-241.1 l -6.4,-732.8 232.5,2 -2.4,-16.1 -474.8,-3.1 -383.5,-0.4 c -122.1,14.1 -258.1,5.7 -381.7,7.4 l -24.4,0.3 c 25.6,193.3 10,407.6 10.5,603.5 0.4,129.8 19,294.3 -16.9,417.7 l 45.2,5.2 -0.7,6.3 c -38.1,49.3 -27.2,160.9 -37.2,226.9 l -2.4,15.3 419.1,5.8",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    d: "m 28035.1,10864.7 591.3,-5.7 c 32.2,-60.9 45.2,-113.9 25.2,-181.5 -6.2,-20.7 -18.4,-39.1 -31.1,-56.2 l -964.9,-4.6 c -38.1,49.3 -27.2,160.9 -37.2,226.9 l -2.4,15.3 419.1,5.8",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path245",
    d: "m 27611.1,10605.2 45.2,5.2 406.9,2.2 2.7,-1022.1 c -134.6,4.5 -292.9,26.3 -424,-6.8 l -24.4,0.3 c 25.6,193.3 10,407.6 10.5,603.5 0.4,129.8 19,294.3 -16.9,417.7",
    style: {
      fill: "#71c395",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "m 29430.2,17395.6 173.4,3.4 c 2.7,-102.7 73.5,-242.4 57.6,-330 65,-183.7 41.8,-450 54,-646.8 l 85.7,-2832 5.4,-661.2 c 1,-125.7 10.5,-258.9 -3.4,-383.5 33.9,-294.8 21.7,-607.4 27.6,-904.5 l 33,-1595.4 7.5,-436.9 c 0.8,-43.2 13,-120.2 2.7,-158.1 -4.4,-17.4 -23.4,-42.3 -32.5,-58.8 -76.4,62.2 -162.4,151 -262,167.6 -42.5,28.8 -137.3,20.2 -190.5,23.1 47.1,81.7 29.8,194.7 30.5,287.4 l 6.6,562.2 66.2,4819.9 -2.2,2119.8 -59.6,23.8",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "m 29802.9,12545.5 c 108.2,-35.2 206.4,-126.7 293.8,-197.3 238.6,-192.3 465.8,-401.5 673.4,-626.8 53.7,-58.3 147,-142.7 180.2,-213.6 l 6.4,-22.6 c 39.3,-36.3 63.7,-63.1 82.8,-113.5 82.3,-58 268.1,-287.3 295.2,-383.7 l 3.2,-18.7 36.6,-59.1 c 18.4,-19.6 45,-41.4 55,-66.2 l 37.9,-63 c 77.1,-72.7 222.7,-227.6 254.4,-327.6 l 9.6,-41.3 c -166.8,-201.7 -279.9,-419.6 -331.5,-677.4 -15.6,-78.7 -10.2,-159.8 -51,-230.8 48.8,-81.5 30,-204.3 27.8,-296.7 -233.9,-54.2 -444,-151.8 -577.1,-363.7 l -9.8,-16.1 c -14.6,-21.9 -31.2,-30 -54.2,-41.7 -68.4,64.1 -159.7,118.9 -240.1,168.1 l -654.3,438 c 9.1,16.5 28.1,41.4 32.5,58.8 10.3,37.9 -1.9,114.9 -2.7,158.1 l -7.5,436.9 -33,1595.4 c -5.9,297.1 6.3,609.7 -27.6,904.5",
    style: {
      fill: "url(#linearGradient248)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path249",
    d: "m 30495.5,8953.8 c 20.1,62.2 -6.1,104.7 -15.1,166.4 -11.5,80.7 -8.1,194.8 17.6,272.5 30.8,94.7 104.3,178 193.9,220.6 133.1,63.3 275.3,46.7 411.5,2.9 86.7,-27.8 164.9,-70.3 245.5,-112.3 48.8,-81.5 30,-204.3 27.8,-296.7 -233.9,-54.2 -444,-151.8 -577.1,-363.7 l -9.8,-16.1 c -14.6,-21.9 -31.2,-30 -54.2,-41.7 -68.4,64.1 -159.7,118.9 -240.1,168.1",
    style: {
      fill: "#44ba3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "m 25825.7,12858.4 c 153.2,-0.7 1023.4,22.9 1096.2,-16.9 43.7,-105.8 26.6,-246.5 25.6,-359.8 l -29.8,-43 27.6,-5 c 8.1,-89.7 34,-207.4 -2.7,-290.6 l 13.2,-6.1 20.3,-1.8 1101.3,-17.1 c 10.7,-50.8 8.5,-100.9 8,-152.5 l -30.5,-6.5 c 22.9,-132.3 39.8,-1009.3 -13.2,-1086 l -6.6,-8.4 -419.1,-5.8 2.4,-15.3 c 10,-66 -0.9,-177.6 37.2,-226.9 l 0.7,-6.3 -45.2,-5.2 c 35.9,-123.4 17.3,-287.9 16.9,-417.7 -0.5,-195.9 15.1,-410.2 -10.5,-603.5 l -18.4,-6 h -418.8 l -366.9,16.8 -72.7,-16.2 c -88.2,11.8 -185.7,5 -274.8,6.1 l -48.6,-7.8 c -168.3,18.5 -351.5,5.3 -520.7,-0.5 l -96.7,6.4 -230.8,-6.6 -332.9,10.5 c -30.8,0.9 -102.1,12.1 -129.5,3.9 -86.7,-26.2 -218.8,-151.3 -304.3,-202.5 l -237.6,-168.9 -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 406.2,562.2 267.7,366.9 318,451 17.5,21.5 14.4,21.8 c 52.3,56.5 97.5,111.3 139.3,176.1 92.8,86.6 194.1,218 253.7,330.3 97.2,83.1 242.3,270.8 295.5,386.7",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path251",
    d: "m 25276.5,12141.4 c 92.8,86.6 194.1,218 253.7,330.3 18.6,-15.4 35.4,-25.9 59.6,-31.4 99.4,-22.8 250.8,0.6 357.3,0.8 l 970.6,-2.4 27.6,-5 c 8.1,-89.7 34,-207.4 -2.7,-290.6 l -1666.1,-1.7",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "m 25825.7,12858.4 c 153.2,-0.7 1023.4,22.9 1096.2,-16.9 43.7,-105.8 26.6,-246.5 25.6,-359.8 l -29.8,-43 -970.6,2.4 c -106.5,-0.2 -257.9,-23.6 -357.3,-0.8 -24.2,5.5 -41,16 -59.6,31.4 97.2,83.1 242.3,270.8 295.5,386.7",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path253",
    d: "m 25795.5,11959.8 723.9,6.9 0.5,-1106.4 h -723.7 c 23.2,34.1 35.2,56.7 34.9,98.4 -1,178.8 43.7,892.5 -35.6,1001.1",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "m 26813.4,9594.8 c 9.1,11.4 34.5,35.8 38.4,48 15.4,47 0,171.8 0,226.4 l 0.2,735.1 759.1,0.9 c 35.9,-123.4 17.3,-287.9 16.9,-417.7 -0.5,-195.9 15.1,-410.2 -10.5,-603.5 l -18.4,-6 h -418.8 l -366.9,16.8",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path255",
    d: "m 25137.2,11965.3 c 210.6,-0.9 451.4,22.6 658.3,-5.5 79.3,-108.6 34.6,-822.3 35.6,-1001.1 0.3,-41.7 -11.7,-64.3 -34.9,-98.4 l -998,-1.9 -10.9,612.6 318,451 17.5,21.5 14.4,21.8",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "m 25122.8,11943.5 c 51.3,-3.6 79.2,-7.8 120.4,-38.7 57.4,-42.9 120.7,-55.1 154.4,-124.9 4.9,-56.3 18.1,-91.1 -24.2,-135.2 -30.8,-31.7 -88.4,-49.9 -131.6,-49.2 -56.4,0.9 -69.4,23.5 -105.8,62 -3.4,73.4 6.6,203.2 -30.7,264.5 l 17.5,21.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path257",
    d: "m 27592.5,11957.6 462.4,1.5 c 22.9,-132.3 39.8,-1009.3 -13.2,-1086 l -6.6,-8.4 -419.1,-5.8 c -252.3,23.5 -542.5,-43.6 -786.9,19.7 26.8,108.9 11.9,249.1 11.7,362.2 l -1.2,719.9 752.9,-3.1",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "m 27247.4,11767.6 c 32.3,4.2 68.7,10.5 100.7,2.2 42.2,-11 76.7,-41.2 95.2,-80.5 19.8,-41.9 13.7,-100.6 -5.6,-141.7 -28.6,-59.8 -65.2,-73.6 -121.1,-98.9 l -17.9,-3.7 c -37.8,-3.7 -64.7,3 -93.3,27.7 -42.5,36.3 -59.6,81 -59.8,136.4 -0.2,80.3 48.4,109.7 101.8,158.5",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path259",
    d: "m 27592.5,11957.6 462.4,1.5 c 22.9,-132.3 39.8,-1009.3 -13.2,-1086 l -6.6,-8.4 -419.1,-5.8 c -252.3,23.5 -542.5,-43.6 -786.9,19.7 l 803.3,-1.6 c -4.2,166.2 31,982.2 -39.9,1080.6",
    style: {
      fill: "#71c395",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    d: "m 24519.6,11104.1 267.7,366.9 10.9,-612.6 998,1.9 c 49.6,-67.5 45.2,-129.8 45.2,-210.1 l -32.7,-42.3 676,-5.3 1,-697.1 c -0.3,-95.5 17.1,-234.7 -19.8,-320.8 l -48.6,-7.8 c -168.3,18.5 -351.5,5.3 -520.7,-0.5 l -96.7,6.4 -230.8,-6.6 -332.9,10.5 c -30.8,0.9 -102.1,12.1 -129.5,3.9 -86.7,-26.2 -218.8,-151.3 -304.3,-202.5 l -237.6,-168.9 -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 406.2,562.2",
    style: {
      fill: "#cfe3d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path261",
    d: "m 25808.7,10607.9 676,-5.3 1,-697.1 c -0.3,-95.5 17.1,-234.7 -19.8,-320.8 l -48.6,-7.8 c -168.3,18.5 -351.5,5.3 -520.7,-0.5 l -96.7,6.4 c 71.5,98.2 33.9,836.3 35.9,1010.3 l -1041.7,7.4 c 113.6,13.8 240.6,3.7 355.6,4.1 l 659,3.3",
    style: {
      fill: "#8ccaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "m 24519.6,11104.1 267.7,366.9 10.9,-612.6 998,1.9 c 49.6,-67.5 45.2,-129.8 45.2,-210.1 l -32.7,-42.3 -659,-3.3 c -115,-0.4 -242,9.7 -355.6,-4.1 l 8.3,-1212.4 -237.6,-168.9 -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 406.2,562.2",
    style: {
      fill: "url(#linearGradient263)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "m 24519.6,11104.1 c 50.3,-96.6 21.2,-286 18.3,-398.2 l -12.7,-928.5 c -0.2,-166 -27.1,-404.9 39.6,-558.2 l -436.4,-295.7 c -38.9,134.2 -12.1,345.1 -11.8,487.2 l -3.2,1131.2 406.2,562.2",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path265",
    d: "m 28361.9,5311 c 251.8,57.8 540.7,60.5 798.4,90.5 l 1367,177.9 c 559.3,70.7 1106.6,201.1 1658.8,311.2 l 1112.8,212.1 c 446.9,106 917.1,242.3 1328.1,449.4 110.7,55.9 218.6,119.9 319.7,191.7 48.9,34.6 122.4,122.6 174.9,126.8 5.9,-73.8 -27.3,-150.6 -51.3,-219.8 -84,-245 -195.6,-477.1 -364.6,-675.3 -484.3,-567.5 -1198.7,-965.6 -1845.5,-1318.1 -353.6,-192.7 -711.4,-387.8 -1091.7,-523.6 -388.8,-138.8 -814.5,-232.5 -1226.8,-261.9 -214.7,-15.3 -436.2,-12.8 -651.4,-6.2 -51.3,1.6 -238.1,28.1 -277.2,9.4 -27.8,-13.2 -70.1,-68.2 -95.5,-92.6 l -250.3,-234 c -448,-391.8 -942.3,-712.3 -1507,-908.4 -576.4,-200.1 -1227,-257.7 -1818.5,-87.9 -91.6,26.3 -181,61.5 -270.2,95 -23.7,8.9 -73.2,33.2 -97.9,30.5 -19.8,-2.2 -90.6,-58.5 -110.6,-71.3 l -340.3,-210.8 c -389.3,-228.5 -801.9,-428.8 -1218.2,-603 -2153.4,-901.202 -4587.5,-1113.498 -6892.3,-831.1 -466.5,57.2 -923.7,148.5 -1384.1,240.7 68.1,38.2 155.8,25 233.7,24.7 l 499.6,1.1 458.3,31.9 c 805.2,78.2 1585.7,289.7 2313.2,643.5 248.3,100.3 500.7,274.1 695.4,457 l 11.6,0.6 c 515.3,486.2 937.1,1008.2 1265,1639.3 107.9,207.8 203.6,423.7 286.6,642.7 24.8,65.5 65.2,132.1 43.9,199.6 l 6926.4,468.4",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "m 29510.5,4844.4 c 70.4,11.8 96.7,17.9 165.9,-6.7 25.1,-51.5 21.7,-63.7 15.4,-121.6 l -67,-44.7 c -20.7,-14.8 -44.2,-13 -69.3,-16 l -53.5,43.9 c -18.8,66.6 -12.7,78.1 8.5,145.1",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path267",
    d: "m 29270.7,4588 35.9,2.4 c 77.4,-0.1 105.8,-36.4 157.5,-85.1 18.1,-59.7 15.4,-98.1 2.7,-158.8 -57.4,-56.3 -73.3,-70.4 -154.8,-89.1 -45.9,2.9 -87.5,15.6 -118.7,51.1 -28.8,32.9 -48.4,75.6 -42.3,119.9 10.8,77.9 62.8,113.3 119.7,159.6",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "m 30338.7,5119.1 c 101.2,13.7 199.3,13.5 288.5,-45.4 75.7,-49.9 147,-138 162.2,-229.4 18.5,-113.3 0.4,-221 -67.7,-314.3 -67.4,-92.7 -144.6,-135.2 -256.7,-152.7 -42.7,-2.1 -84.5,-3.4 -126.5,6.8 -98.7,24 -190,91 -239.4,180.6 -46.1,83.9 -62.7,192.9 -32.2,285.4 45.4,137.6 146.8,209.6 271.8,269",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path269",
    d: "m 21435.5,4842.6 6926.4,468.4 12.2,-27.3 c 92.3,-25.8 194.9,-32.8 289.7,-51.5 -468.7,-735.4 -1213.2,-1349.5 -2075.1,-1539.9 -370.7,-82 -732.7,-82.9 -1107.3,-24.7 -51.1,7.9 -472.9,128.4 -480.4,126.5 -52.6,-13 -202.8,-211.5 -246.5,-256.4 -101.1,-104 -212.7,-200.7 -322.8,-294.7 -914.6,-779 -2203.1,-1178.8 -3397,-1108.1 -410.9,24.3 -800.9,109.7 -1194.7,226.1 515.3,486.2 937.1,1008.2 1265,1639.3 107.9,207.8 203.6,423.7 286.6,642.7 24.8,65.5 65.2,132.1 43.9,199.6",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "m 15902.4,15110.6 c 360.4,1.3 680.4,-37.2 1028,-132.3 124.8,-34.2 258.5,-68.8 374.4,-126.4 l 13.3,1.1 268,49.9 -200.3,-353.7 -200.2,-346 426.5,-5.2 c 114.6,-110.2 280.3,-152.6 404.5,-261.8 58.4,-51.4 113.4,-107 159.6,-169.7 37.7,-51.2 62.9,-131 117.8,-162.5 19.1,19.5 32.9,32.9 40.7,59.6 27.9,94.8 90.7,166.4 145.6,247.4 99,11.4 187.1,15.6 286.2,3.7 55,-30.7 81.3,-63.1 115.5,-114.3 -9.8,-68.2 -28.7,-110.7 -62.9,-169.2 -1,-26.9 -3.3,-43.2 11.5,-66.6 100.5,101.1 169.1,210.7 281.7,303.2 l 29.5,23.6 c 88.1,13.3 168.7,28 258.3,32.4 140.9,-47.4 225.2,-103.7 305.8,-231.7 114.2,-20.7 224.3,-32.7 340.2,-37.4 26,60.4 69.9,91.7 119.2,132.5 l 42,31.5 -7.1,131.3 c 75.6,1.4 126.3,-3.8 196.5,-33.3 28.7,-30.7 59,-59.8 79.6,-96.6 l 46.1,-10.6 c 39.6,46.8 70.1,81.4 127,108.5 110.5,-45.2 202.8,-166.1 285.1,-251 l 88,-104.4 -76.2,-94.2 c 71.5,-54.5 136.2,-97.2 151.4,-191.1 15.4,-95 -53.3,-187.9 -45.3,-265.8 0.7,-6.9 110.3,-102.6 125.1,-116.3 -12.7,-78.8 -48.3,-165.3 4.7,-232.6 l 47.3,-44.6 -286.7,-383.5 c -52.5,2.8 -102.5,-0.6 -154.7,-4.8 l -28.7,-18.9 -9.4,-15.6 c -33.2,-52.9 -55.3,-74.5 -115.5,-98.1 -3.4,-67 19.2,-139.6 32.6,-205.1 l -91.2,-128.5 -928.6,-1252.1 -75.7,-102 -391.8,-506.9 277.2,7.2 c 8.5,-43.1 20.9,-88.2 24.2,-132 33.3,-44.8 34.7,-63.2 91.3,-73.2 l 28.1,55 c 50.5,5.9 98.1,4.6 148.8,1.6 l -1.8,-252.5 -4,-13.1 c -23.2,-182.3 7.6,-382.5 -34.3,-558.5 l -19.4,-596.5 -32.8,-287.2 -57.5,-917.6 -22.5,-323.4 -142,61.2 c -53.4,-29.1 -108.4,-42.8 -166.6,-58.7 l -1943.1,10.4 -178,632.4 c -24.1,51 -33.6,111.2 -46.6,166 -31.3,69 -2.1,74.1 -66.4,130.8 l -15.3,-75.1 -4.2,-60.2 c -47.2,-32 -95.5,-46.7 -153.5,-39 -78.4,10.5 -153.3,32.9 -234,2.5 l -245.5,-735.7 -234.6,-664.9 -624.5,66.2 c -97.8,128.2 -160.5,356.2 -227.8,507.3 l -40.4,93.5 -858,2003 c -84.6,37.7 -193.1,127.7 -283,124.8 l -899.6,-2.2 -540.1,1.6 -676.8,-1.2 -4.2,83.5 -14.8,307.3 c -117,-7.7 -257.2,-17.7 -372.5,2.3 l -25.9,38.5 c -58.2,101.8 -16.7,285.5 9.8,393.1 85.6,257.3 102.1,536.3 193.1,794.2 l 12.4,84.7 c 11.3,27.3 21.2,52.7 42.3,74 31,31.3 366.5,14.6 433.9,14.7 l 14.4,440.6 13.9,18 c -11.9,11.5 -21,27.1 -35.8,34.5 -12.4,6.2 -79.2,0.5 -98.2,0.6 l -350.9,2.1 -4.8,201.9 133.3,-2.1 c 50.6,28.9 65.1,82.5 87.3,133.7 53.1,178.1 133.5,352.9 201.6,526 202,514.1 412.6,1034.6 781.1,1456.3 332.1,414.8 682.8,761.8 1148.8,1026.2 138.3,78.4 288.2,134.4 433.8,197.8 l 472.4,150.5 c 243,112.5 569.5,131 834.3,157.2",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path271",
    d: "m 16721.5,12396.1 12.6,-1.7 c 58.2,-12.1 87.3,-30.5 119,-77.6 l -31.4,-95.3 c -67.1,14.5 -90.4,31 -126.5,86.2 l 26.3,88.4",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "m 19179.8,9902.5 277.2,7.2 c 8.5,-43.1 20.9,-88.2 24.2,-132 -20.6,5.7 -13.6,4.8 -32.3,6.5 l -132.9,15.4 c -62.2,14 -104.7,48 -136.2,102.9",
    style: {
      fill: "#7d6620",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path273",
    d: "m 18636.2,10667.9 16.6,5.6 c 81.2,28.8 153.9,112.2 232.7,111.6 25.1,-39.7 44,-75.9 59,-120.4 l 237.7,-18 -335.1,-16.4 c -76.5,-8.5 -147.4,-13.2 -210.9,37.6",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "m 15711.2,13530.1 12.7,4 c 86.4,25.1 322.9,96.5 404.8,72.6 27,-7.8 65.5,-35.4 91.1,-49.3 l -393.6,-109.8 -299.3,-64.2 -65.5,34.8 249.8,111.9",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path275",
    d: "m 18069.7,13206.1 c 12.7,-10.6 16.2,-12.1 26.1,-28.4 36.7,-60.7 28.9,-127.1 17.7,-192.3 -8.8,-51 -13.8,-72 -52.3,-108.8 -61.6,10.9 -109.4,-16.4 -164.9,-39.9 -40.4,59.8 -71.6,82.4 -64,155.6 72.8,105.3 112,172.7 237.4,213.8",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "m 16289.8,13587.3 c 58.1,51.4 157.6,56.2 232.8,68.9 l 35.6,-20.7 2.8,-40.2 26.2,-21.4 25.2,-0.9 c -1.1,-87.4 1.7,-155 34.1,-236.7 l -96.5,63.1 c -59.5,-23.1 -115.1,-52.4 -158.1,-100.8 -40.1,-45 -73.1,-115.8 -125.8,-145 l -20.3,36.3 c 12.6,16.7 22.8,26.6 39.9,39.5 l 17.1,12.3 c 12.3,68.9 114.3,105.9 137.4,196.9 -20.1,20 -37.1,40.1 -65.4,47.7 -24.1,6.4 -63.7,-21.7 -86,-32.6 l -35.1,17.6 85.7,57 -49.6,59",
    style: {
      fill: "#f4e628",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path277",
    d: "m 15005.6,10900.7 32.5,88.3 c 19.8,54.8 32.5,87.7 78.8,125.5 17.5,14.2 14,26.8 17.9,48.5 -18.8,43.8 -37.4,78.4 -31.9,126.8 72.8,42.1 118.3,81.8 201.5,60.3 40.2,-46.5 44.3,-87.9 50.3,-146.4 l 2.2,-22.4 c 32.9,-6.5 44.9,1.8 75.8,13.3 l 29.7,-40.7 c 0.2,-74.7 -20,-119.7 -52.3,-185.2 -97.4,14 -199.7,43 -289,-7.2 l -115.5,-60.8",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "m 16612.4,13573 7.3,40.6 c 73.5,46.6 366.3,-6.8 452.9,-28.2 83.7,-20.8 180.9,-58.4 244.7,-116.8 13.8,-12.6 26.9,-17 43.9,-24.3 38.2,-16.5 53,-39.8 74.1,-74.3 -12,-66.3 -68.4,-95.6 -123.6,-132.6 -75.2,-50.4 -172.8,-75.9 -257.9,-103.8 -80.2,48 -144.1,78.4 -237.7,93 l -10.4,9.8 c -48.8,44.3 -100.7,70.7 -159.2,99.9 -32.4,81.7 -35.2,149.3 -34.1,236.7",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path279",
    d: "m 16641.7,13071.9 9.2,0.4 c 111.2,2.2 154.3,19 238,-59.5 43.1,-3.1 69.9,-7.2 107.6,-29 13.7,-30.7 26.4,-62 49.6,-86.9 49.1,-53 38.6,-90.9 71.6,-144.4 62.2,-100.8 111.3,-17.9 186.6,-32.7 l 69.7,-132.9 c -89.7,-56 -181.9,-130.1 -286.6,-151.8 -35,9.4 -80.4,25.6 -116.4,17.6 -160.6,-36.2 -281.5,65.8 -421,133.9 -76.6,-7.4 -125.3,-10.1 -191.7,34.6 -32.3,21.6 -28.9,23.8 -37,62 57.1,62.8 96.3,139.4 166.1,188.5 l 11.9,8 c 0.5,23 1.5,46.7 7.7,69 17.9,64.5 80.9,93.5 134.7,123.2",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "m 19657.1,8053.3 -57.5,-917.6 -22.5,-323.4 -142,61.2 c -53.4,-29.1 -108.4,-42.8 -166.6,-58.7 l -1943.1,10.4 -178,632.4 c 289.7,-7.8 597.9,-28.4 884.3,20.4 95.6,-5.9 208.1,23.7 302.9,41.3 480.1,89.3 905.4,286.7 1322.5,534",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path281",
    d: "m 19268.5,6814.8 -31.1,236 c 90.1,60 256.5,105.9 362.2,84.9 l -22.5,-323.4 -142,61.2 c -53.4,-29.1 -108.4,-42.8 -166.6,-58.7",
    style: {
      fill: "#34702f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "m 16763,8783.4 c -54.3,52.3 -120.2,106.5 -150.6,177 l -7.4,18.7 c -27.5,65 -32.2,100.7 -18.8,168.6 l 3.9,19 c -33.1,53.1 -135.1,128.1 -195.8,140.8 -21.7,4.5 -51.8,-7.4 -73.2,-2.4 -31.2,7.2 -86.7,48.2 -114.9,65 -65.2,38.8 -100.6,96.3 -159.6,137.9 -68,48.2 -145,67.5 -212.7,122.6 l -14.8,12.2 c -49,0.7 -79.5,2.3 -123,25.9 -63,114.4 -40.9,172.6 -28.5,291.9 8.5,81.4 22.4,132.7 70.8,199.7 l 133.9,-9.7 c 44.7,26.3 96.8,47.3 118.6,96.6 -36.9,34.2 -65.4,71.8 -72,123.3 -8.6,66.1 5.1,71.2 45,121.4 -0.7,38.3 10.4,60.9 26.8,94.2 66,34.1 177.5,-5.9 258.2,-1.9 35.2,1.8 165.7,-87.9 206.5,-109.3 43.2,65.2 84.5,142.7 149.6,187.1 167.9,32.1 304.6,-110.2 431,-201 67.9,-48.8 155.3,-85.2 229.5,-124.5 l 25.8,-152.7 c 16,-72.9 89.4,-107.9 148,-145.8 l 18.6,0.9 c 46.4,2.7 85.3,6.4 127.5,27.7 19.9,10 94.2,58.4 111,58.7 61.4,1 307.3,-128.3 354.8,-173.2 44.8,-42.3 63.9,-86.9 64.2,-148.3 0.5,-82.8 -16.6,-167.9 -30.6,-249.2 13.2,-27 39.2,-66.7 46.3,-94.9 18.7,-73.4 -27.2,-259.2 -37.1,-340.8 -63,-40.5 -185.1,-120.2 -264.2,-104.1 -32.9,6.7 -67.3,40.9 -92.2,62.2 -43.4,-73.1 -24.1,-344 1.2,-433 l 5.8,-13 c -0.5,-143.6 -14.8,-182.1 -119.5,-285.6 -37.2,-36.7 -68.1,-47.1 -111.4,-72.9 -43,-25.6 -54.9,-86.1 -72,-130.3 -74,-191.5 -158.4,-300.9 -378.8,-269.8 -23.8,-43.2 -28.4,-68.9 -28.5,-118 l -15.3,-75.1 -195.6,-49.5 c -84.5,23 -169.4,44.1 -236,103.8 -89.9,80.8 -183.5,280.1 -183.1,400.6 0.6,134.9 175.4,194.4 260,273.3 -2,41.4 -18.9,98.5 -15.6,136.4 8.2,95.7 114.8,142.9 114.2,239.5",
    style: {
      fill: "#acda22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path283",
    d: "m 17439.3,10038 18.6,0.9 c 46.4,2.7 85.3,6.4 127.5,27.7 19.9,10 94.2,58.4 111,58.7 61.4,1 307.3,-128.3 354.8,-173.2 44.8,-42.3 63.9,-86.9 64.2,-148.3 0.5,-82.8 -16.6,-167.9 -30.6,-249.2 -146.9,-14.5 -200.6,-57.5 -321.9,-135.1 -30.3,-19.4 -104.5,-71.6 -138,-77.5 -61.6,-10.7 -160.9,42.8 -226.5,50 -128.9,14.2 -261.4,-31.5 -390.4,-1 -57.4,13.6 -97.6,34.7 -129.3,85.7 30.3,83.5 168.6,127 213.2,208.1 28.1,51.2 37.5,162.4 55.5,224.1 52.2,27.7 123.4,11.8 181.1,23.1 61.7,12.1 80.1,57.6 110.8,106",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "m 16219.8,13557.4 c 17.7,19.4 45.1,22.3 70,29.9 l 49.6,-59 -85.7,-57 35.1,-17.6 c 22.3,10.9 61.9,39 86,32.6 28.3,-7.6 45.3,-27.7 65.4,-47.7 -23.1,-91 -125.1,-128 -137.4,-196.9 l -17.1,-12.3 c -17.1,-12.9 -27.3,-22.8 -39.9,-39.5 l 20.3,-36.3 c -119.6,1.5 -153,-57.3 -256,-93.2 -94.3,-32.9 -190.3,-144.9 -281.2,-200.8 110.1,-53.7 206.6,-124.7 313.7,-179.9 178,-91.7 419.7,-88.8 495.9,-307.9 -11.6,-108 -64,-207.8 -148.2,-276.7 -29,-23.6 -98.8,-83.6 -133.4,-92.5 -23.9,-6.2 -59.9,3.8 -82.4,-4.4 -49.7,-18.2 -81.2,-130.1 -117.5,-163.8 -28.2,-26.2 -140.2,-23 -163.5,-49.7 -4.6,-5.4 -8.2,-60.9 -9.7,-71.6 -15.9,-115.8 -13.6,-333.3 -174.2,-316.6 -94.5,9.8 -115.5,111 -198.9,140.2 -28.6,10 -54,32.7 -78,50.9 -251.4,6.7 -348.5,-116.3 -549.2,-230.7 -48.8,-95.9 -80,-194.2 -111.9,-296.4 67.9,-56.3 150.5,-129.4 234,-159.8 l 115.5,60.8 c 89.3,50.2 191.6,21.2 289,7.2 40.1,-14.1 71.1,-29 106.4,-53 l -1.9,-45.7 42.9,-45.8 c 16.1,19.4 18.2,21.1 40,30 61.2,-68.3 -35.8,-53.4 -14.8,-105.4 1.8,-4.5 43.5,-33.7 50.1,-39.1 56,-44.9 125.9,-98 136.1,-169.4 -35.6,-43.4 -43.9,-60.7 -98.1,-79.5 l -55,44.3 c -28.8,-0.1 -63.5,-1.4 -91.6,7 -67.4,20.3 -89.1,53 -117.7,113.5 l -20.8,0.9 c -69.9,9.7 -156.6,18.7 -227.8,13.2 -26.7,-2 -50.8,-11.1 -77.9,-4.5 -90.7,22.1 -167.3,142.3 -274.1,128.5 7.4,-26.1 9,-40.7 4,-67.5 l -25.6,-17.3 c -46.2,-30.6 -100.6,-67.1 -158.2,-54.4 -30.9,6.8 -49.2,1 -78.9,-8.7 l -12.1,-4.2 c -146.5,68.2 -171.7,135.9 -249.2,267.5 l -236.3,421.9 c -67.5,35.3 -125.5,77.2 -186,123 20.8,310 134,593.2 318.4,842.4 67.3,90.9 151,167 224.7,252.4 72.9,84.4 134.6,181.3 197.8,273.1 54.2,90.9 124.6,149.8 204.9,217.2 l 652,409.1 65.5,-34.8 299.3,64.2 393.6,109.8",
    style: {
      fill: "#dceb51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path285",
    d: "m 16219.8,13557.4 c 17.7,19.4 45.1,22.3 70,29.9 l 49.6,-59 -85.7,-57 c -139.9,-77.7 -218.4,-38.1 -363.1,-63.5 -65.1,-11.5 -121.4,-54.5 -188.8,-68.5 25.3,52.7 76.6,75.5 124.4,108.3 l 393.6,109.8",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "m 15526.9,13383.4 299.3,64.2 c -47.8,-32.8 -99.1,-55.6 -124.4,-108.3 -71.3,-33.9 -134.9,-79.4 -205,-113.5 -60.2,-29.2 -122.2,-45.8 -178.3,-84.2 -123.5,-84.6 -208.3,-189.8 -316,-287.1 -38.2,-34.6 -84.6,-59.8 -122.1,-95.4 -80,-76 -132.2,-149.3 -226.2,-213.1 l -25.8,18.1 17.8,171.2 -41.7,56.6 c 54.2,90.9 124.6,149.8 204.9,217.2 l 652,409.1 65.5,-34.8",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path287",
    d: "m 14809.4,13009.1 652,409.1 65.5,-34.8 c -219.9,-83.8 -392.7,-193.1 -564.4,-356 -35.8,-34.1 -60.2,-81.8 -97.7,-112.7 -80.9,-66.8 -156.5,-86 -218.6,-179.4 l -41.7,56.6 c 54.2,90.9 124.6,149.8 204.9,217.2",
    style: {
      fill: "#f4e628",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "m 20200.2,13950 c 75.6,1.4 126.3,-3.8 196.5,-33.3 28.7,-30.7 59,-59.8 79.6,-96.6 l 46.1,-10.6 c 39.6,46.8 70.1,81.4 127,108.5 110.5,-45.2 202.8,-166.1 285.1,-251 l 88,-104.4 -76.2,-94.2 c 71.5,-54.5 136.2,-97.2 151.4,-191.1 15.4,-95 -53.3,-187.9 -45.3,-265.8 0.7,-6.9 110.3,-102.6 125.1,-116.3 -12.7,-78.8 -48.3,-165.3 4.7,-232.6 l 47.3,-44.6 -286.7,-383.5 c -52.5,2.8 -102.5,-0.6 -154.7,-4.8 l -28.7,-18.9 -9.4,-15.6 c -33.2,-52.9 -55.3,-74.5 -115.5,-98.1 -3.4,-67 19.2,-139.6 32.6,-205.1 l -91.2,-128.5 -928.6,-1252.1 -75.7,-102 c -146.4,55.7 -242.4,182.7 -389.4,237.3 l -237.7,18 c -15,44.5 -33.9,80.7 -59,120.4 -78.8,0.6 -151.5,-82.8 -232.7,-111.6 l -16.6,-5.6 -11.5,5.6 -18.7,10 c -89.2,45.7 -106.6,99.1 -176.3,160.5 -27,23.7 -64.5,33.5 -93.6,54.2 -71.3,50.8 -62.9,173.9 -104.1,242.5 -10.8,18.1 -56.7,46.7 -74.2,62.4 -54.8,49.2 -68.2,92 -79.8,161.9 l -2.8,17.8 c -63.3,57.7 -137.7,128.5 -141.5,219.8 -4.4,103.4 105,217.5 167.2,289.4 -9.6,33 -11.3,53.1 -6,87.3 8.3,54.7 3.8,114.6 17.9,167.7 17.2,64.9 53.1,117.3 79.5,177.6 11.6,26.4 15.8,64.1 33,87 33.9,44.9 86,86.8 125.8,127.3 l -164.6,53.5 13.5,18.3 c -45.7,52.3 -88.6,85.9 -103.4,154.9 9.8,13.9 20.3,31.2 34.6,41.2 61,42.3 112.9,22.1 179.5,10.9 31.2,52.9 73.7,93.6 102,149.3 l -26.8,50.4 c -30.7,71.7 18.8,147.5 48.6,215.2 -5,35.7 -6.9,135.3 -21.9,164.8 -25.8,50.6 -100.5,73.7 -124.9,126.5 -16.3,35.4 -7.1,46.8 6.3,80.1 19.1,19.5 32.9,32.9 40.7,59.6 27.9,94.8 90.7,166.4 145.6,247.4 99,11.4 187.1,15.6 286.2,3.7 55,-30.7 81.3,-63.1 115.5,-114.3 -9.8,-68.2 -28.7,-110.7 -62.9,-169.2 -1,-26.9 -3.3,-43.2 11.5,-66.6 100.5,101.1 169.1,210.7 281.7,303.2 l 29.5,23.6 c 88.1,13.3 168.7,28 258.3,32.4 140.9,-47.4 225.2,-103.7 305.8,-231.7 114.2,-20.7 224.3,-32.7 340.2,-37.4 26,60.4 69.9,91.7 119.2,132.5 l 42,31.5 -7.1,131.3",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path289",
    d: "m 19155.9,10775.1 c 77.4,27.1 184.9,66.1 264.4,28.3 91,-43.2 183.6,-184.6 216.5,-276.4 -101.1,19.4 -192.7,110.1 -283.1,156.1 -46.3,23.5 -103.6,30.2 -154.8,36 l -11.1,1.2 -31.9,54.8",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    d: "m 19155.9,10775.1 31.9,-54.8 11.1,-1.2 c 51.2,-5.8 108.5,-12.5 154.8,-36 90.4,-46 182,-136.7 283.1,-156.1 l 10.5,-15.6 -75.7,-102 c -146.4,55.7 -242.4,182.7 -389.4,237.3 l -237.7,18 211.4,110.4",
    style: {
      fill: "#282826",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path291",
    d: "m 18200,12610.7 58,-12.2 c 52,-8.3 101.9,-16.6 152.4,-32 16,-22.8 36.1,-38.8 32,-67.6 -10.7,-76 -114.9,-124.7 -140,-189.5 -8,-20.5 -3,-73.1 -4.5,-97.1 -9.9,-165.9 -75.4,-219.9 -197,-320.3 -9.6,33 -11.3,53.1 -6,87.3 8.3,54.7 3.8,114.6 17.9,167.7 17.2,64.9 53.1,117.3 79.5,177.6 11.6,26.4 15.8,64.1 33,87 33.9,44.9 86,86.8 125.8,127.3 l -164.6,53.5 13.5,18.3",
    style: {
      fill: "#234886",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "m 19232,13587.7 40.6,24.5 c 71.9,6.7 119.9,2.8 189.1,-19.5 l 39.6,-69.3 -66.9,-52.7 c 7.7,-58.6 12.5,-62.6 53.9,-107.6 22.8,-24.7 -71.4,-206.8 -85.6,-248.8 13,-5.5 33.3,-19.1 46.9,-14.8 51.1,-32.4 88.4,-53.1 111.8,-111.8 39.9,-100 240.1,-227.6 321.6,-311.2 90.4,-5.9 179.6,-10 267.9,-31.3 l 152.6,-116.3 c -93.5,9.3 -131.6,-6.4 -218.1,-27.3 -83.6,-20.2 -114.6,27 -183.2,65.2 -48.2,26.9 -113.5,-4.3 -164.9,-19.2 l -63.2,56.4 c -65.8,6.1 -106.7,-22.1 -166.2,-48.3 -19.6,99.9 -8.3,203.4 -20.9,304.4 -12.7,102.5 -24.7,136 -108.2,200.5 l -15,5.1 c -33.4,13.9 -52.1,44.5 -66.8,75.7 -37.9,80.7 -127.4,251.7 -92,338.5 14.6,35.8 20.4,69.7 27,107.8",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path293",
    d: "m 19141.8,13891.4 c 88.1,13.3 168.7,28 258.3,32.4 140.9,-47.4 225.2,-103.7 305.8,-231.7 114.2,-20.7 224.3,-32.7 340.2,-37.4 -42.4,-83.8 -104.3,-169.3 -133.7,-257.3 -25.6,-7.4 -47.4,-11.5 -74.1,-12.8 -37.9,-53.9 -61.6,-147.7 -119.9,-170.3 l -75.2,18.3 c -43.5,-27.3 -51.1,-19.6 -94.3,-32.7 -18.8,-5.7 -81.2,-82.1 -99.3,-100.4 -13.6,-4.3 -33.9,9.3 -46.9,14.8 14.2,42 108.4,224.1 85.6,248.8 -41.4,45 -46.2,49 -53.9,107.6 l 66.9,52.7 -39.6,69.3 c -69.2,22.3 -117.2,26.2 -189.1,19.5 l -40.6,-24.5 -89.1,76.1 c -46,47 -31.8,142.4 -30.6,204 l 29.5,23.6",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "m 19141.8,13891.4 c 88.1,13.3 168.7,28 258.3,32.4 53.4,-44.4 108.2,-82.7 131.3,-150.9 1.2,-70.9 -27.9,-124.7 -69.7,-180.2 -69.2,22.3 -117.2,26.2 -189.1,19.5 l -40.6,-24.5 -89.1,76.1 c -46,47 -31.8,142.4 -30.6,204 l 29.5,23.6",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path295",
    d: "m 19507.9,12555.7 c 59.5,26.2 100.4,54.4 166.2,48.3 l 63.2,-56.4 c 51.4,14.9 116.7,46.1 164.9,19.2 68.6,-38.2 99.6,-85.4 183.2,-65.2 86.5,20.9 124.6,36.6 218.1,27.3 l 82.1,-89.3 81.5,-12.9 -3.3,-54.9 c 92.1,-92.1 173.5,-121.7 295.6,-161 l -9.4,-15.6 c -33.2,-52.9 -55.3,-74.5 -115.5,-98.1 -3.4,-67 19.2,-139.6 32.6,-205.1 l -91.2,-128.5 c -19.6,38.3 -19.8,85.5 -34.8,126.5 -36.9,100.9 -106.2,215.7 -193.2,280.3 -26.8,19.9 -186,119.3 -216.8,114.3 -34.9,-5.7 -79.8,-63.9 -119,-68.2 -81.3,-9 -148.6,55.6 -235.2,43.1 l -12.1,-2.1 c -37.5,30.9 -70.6,60.1 -119.7,69.6 l -17.7,3.1 c -37.5,7 -75,17.7 -112.7,6.7 -70.1,-20.4 -224.2,-199.6 -223.7,-276.3 0.4,-54.7 26.1,-54.1 -2.7,-109.9 -43.5,-7.1 -56.7,-13.6 -97.9,4.7 -6.4,76.6 -42.1,246.5 -118.6,284.4 -39.3,19.5 -55.5,2.1 -87.7,40.5 l 57.1,32.9 100.8,-41.8 c 72.2,58 121.8,69 167,155.4 17.9,3.5 30.3,5.5 48.7,2.4 l 13.3,-2.9 136.9,129.5",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "m 20200.2,13950 c 75.6,1.4 126.3,-3.8 196.5,-33.3 28.7,-30.7 59,-59.8 79.6,-96.6 -56.4,-103.8 -191.7,-330.6 -163.7,-444.7 l 5.4,-16.5 105.7,-186.4 c -134.4,-179.8 -221.6,-305.6 -272.8,-527.3 -88.3,21.3 -177.5,25.4 -267.9,31.3 -81.5,83.6 -281.7,211.2 -321.6,311.2 -23.4,58.7 -60.7,79.4 -111.8,111.8 18.1,18.3 80.5,94.7 99.3,100.4 43.2,13.1 50.8,5.4 94.3,32.7 l 75.2,-18.3 c 58.3,22.6 82,116.4 119.9,170.3 26.7,1.3 48.5,5.4 74.1,12.8 29.4,88 91.3,173.5 133.7,257.3 26,60.4 69.9,91.7 119.2,132.5 l 42,31.5 -7.1,131.3",
    style: {
      fill: "#acda22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path297",
    d: "m 20649.4,13918 c 110.5,-45.2 202.8,-166.1 285.1,-251 l 88,-104.4 -76.2,-94.2 c 71.5,-54.5 136.2,-97.2 151.4,-191.1 15.4,-95 -53.3,-187.9 -45.3,-265.8 0.7,-6.9 110.3,-102.6 125.1,-116.3 -12.7,-78.8 -48.3,-165.3 4.7,-232.6 l 47.3,-44.6 -286.7,-383.5 c -52.5,2.8 -102.5,-0.6 -154.7,-4.8 l -28.7,-18.9 c -122.1,39.3 -203.5,68.9 -295.6,161 l 3.3,54.9 -81.5,12.9 -82.1,89.3 -152.6,116.3 c 51.2,221.7 138.4,347.5 272.8,527.3 l -105.7,186.4 -5.4,16.5 c -28,114.1 107.3,340.9 163.7,444.7 l 46.1,-10.6 c 39.6,46.8 70.1,81.4 127,108.5",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    d: "m 20385.6,12439.6 c 79.6,17.7 197.9,65.6 276,47.3 30.4,-32.2 54.5,-59.2 52.4,-105.9 l -10.3,-64.2 31.9,-8.9 36.7,30.3 26.2,-21.4 -10.4,-87.1 -28.7,-18.9 c -122.1,39.3 -203.5,68.9 -295.6,161 l 3.3,54.9 -81.5,12.9",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path299",
    d: "m 15902.4,15110.6 c 360.4,1.3 680.4,-37.2 1028,-132.3 124.8,-34.2 258.5,-68.8 374.4,-126.4 l 13.3,1.1 268,49.9 -200.3,-353.7 -200.2,-346 c -509.5,-59.9 -1107.4,-137.3 -1480,-524.6 0.8,-49.2 -0.7,-99.7 5.6,-148.5 l -249.8,-111.9 -652,-409.1 c -80.3,-67.4 -150.7,-126.3 -204.9,-217.2 -63.2,-91.8 -124.9,-188.7 -197.8,-273.1 -73.7,-85.4 -157.4,-161.5 -224.7,-252.4 -184.4,-249.2 -297.6,-532.4 -318.4,-842.4 -30.8,-105 -20.8,-232.3 -20.1,-341.1 3.6,-507.1 89,-1059 336.6,-1508.8 l 9.5,-17 c 399.8,-871.5 1241.4,-1570.4 2132,-1898.6 101,-37.2 198.8,-63.9 305.8,-75.9 l -245.5,-735.7 -234.6,-664.9 -624.5,66.2 c -97.8,128.2 -160.5,356.2 -227.8,507.3 l -40.4,93.5 -858,2003 c -84.6,37.7 -193.1,127.7 -283,124.8 l -899.6,-2.2 -540.1,1.6 -676.8,-1.2 -4.2,83.5 -14.8,307.3 c -117,-7.7 -257.2,-17.7 -372.5,2.3 l -25.9,38.5 c -58.2,101.8 -16.7,285.5 9.8,393.1 85.6,257.3 102.1,536.3 193.1,794.2 l 12.4,84.7 c 11.3,27.3 21.2,52.7 42.3,74 31,31.3 366.5,14.6 433.9,14.7 l 14.4,440.6 13.9,18 c -11.9,11.5 -21,27.1 -35.8,34.5 -12.4,6.2 -79.2,0.5 -98.2,0.6 l -350.9,2.1 -4.8,201.9 133.3,-2.1 c 50.6,28.9 65.1,82.5 87.3,133.7 53.1,178.1 133.5,352.9 201.6,526 202,514.1 412.6,1034.6 781.1,1456.3 332.1,414.8 682.8,761.8 1148.8,1026.2 138.3,78.4 288.2,134.4 433.8,197.8 l 472.4,150.5 c 243,112.5 569.5,131 834.3,157.2",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "m 15254.6,6849 1127.3,-2.1 -234.6,-664.9 -624.5,66.2 c -97.8,128.2 -160.5,356.2 -227.8,507.3 l -40.4,93.5",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path301",
    d: "m 17304.8,14851.9 13.3,1.1 268,49.9 -200.3,-353.7 -200.2,-346 c -509.5,-59.9 -1107.4,-137.3 -1480,-524.6 0.8,-49.2 -0.7,-99.7 5.6,-148.5 l -249.8,-111.9 -652,-409.1 c 13.2,66.3 124.2,154.2 173.5,203.7 171.9,172.8 349.6,350.7 541.3,501.8 387.2,304.9 812.8,559.8 1207.3,853.5 l 573.3,283.8",
    style: {
      fill: "#34702f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    d: "m 12271.2,10767.3 233.2,-6.2 227.1,5.1 81.2,-1 38.3,-8.2 372.1,4.5 c 53.6,-0.7 126.3,7.9 176.1,-13.3 l 172.2,-840.9 c 16.8,-97.3 52.2,-212.1 40.6,-309.9 -9.4,-80.1 -62.6,-163.2 -86.5,-241.4 l -301.4,3.9 -10.1,-385.3 -540.1,1.6 -676.8,-1.2 -4.2,83.5 -14.8,307.3 c -117,-7.7 -257.2,-17.7 -372.5,2.3 l -25.9,38.5 c -58.2,101.8 -16.7,285.5 9.8,393.1 85.6,257.3 102.1,536.3 193.1,794.2 l 12.4,84.7 c 11.3,27.3 21.2,52.7 42.3,74 31,31.3 366.5,14.6 433.9,14.7",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path303",
    d: "m 11978.1,9365.8 1246,-5.9 -10.1,-385.3 -540.1,1.6 -676.8,-1.2 -4.2,83.5 -14.8,307.3",
    style: {
      fill: "#416da9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "m 11992.9,9058.5 0.9,154 c 38.2,30.7 113.2,18 162.8,17.9 l 502.9,-0.4 c 0.4,-68 -14.5,-195.9 14.4,-253.8 l -676.8,-1.2 -4.2,83.5",
    style: {
      fill: "url(#linearGradient305)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "m 12271.2,10767.3 233.2,-6.2 227.1,5.1 -18,-1394 -492.9,1.9 c -75.8,0.2 -169.4,11.7 -242.5,-8.3 -117,-7.7 -257.2,-17.7 -372.5,2.3 l -25.9,38.5 c -58.2,101.8 -16.7,285.5 9.8,393.1 85.6,257.3 102.1,536.3 193.1,794.2 l 12.4,84.7 c 11.3,27.3 21.2,52.7 42.3,74 31,31.3 366.5,14.6 433.9,14.7",
    style: {
      fill: "#ccd4d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path307",
    d: "m 12271.2,10767.3 233.2,-6.2 253.7,-24.1 c -153.9,-31.2 -303.7,-44.6 -460.2,-51.7 -113.2,-5.1 -234,-0.1 -342.6,-34.1 l -160.3,27.4 c 11.3,27.3 21.2,52.7 42.3,74 31,31.3 366.5,14.6 433.9,14.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "m 11795,10678.6 160.3,-27.4 -13.2,-20.2 c -53.1,-86.2 -68.3,-287.2 -92.9,-393.1 -52.5,-224.8 -103.4,-443.9 -190.3,-658.5 1.1,141.5 10.2,278.8 31.2,418.8 l 59.4,321.5 c 20,87.7 54.2,184.9 33.1,274.2 l 12.4,84.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path309",
    d: "m 15079.3,14925.6 c 374.6,105.8 764.3,114.8 1150.2,79.8 137.6,-12.5 283,-23.3 416.4,-62 -191.6,-106.9 -499.4,-214.2 -641.4,-377.4 -348,-194.8 -663.5,-487.5 -945.2,-766.3 -905.9,-896.6 -1605.9,-1924 -2208.3,-3042.7 l -38.3,8.2 -81.2,1 -227.1,-5.1 -233.2,6.2 14.4,440.6 13.9,18 c -11.9,11.5 -21,27.1 -35.8,34.5 -12.4,6.2 -79.2,0.5 -98.2,0.6 l -350.9,2.1 -4.8,201.9 133.3,-2.1 c 50.6,28.9 65.1,82.5 87.3,133.7 53.1,178.1 133.5,352.9 201.6,526 202,514.1 412.6,1034.6 781.1,1456.3 332.1,414.8 682.8,761.8 1148.8,1026.2 138.3,78.4 288.2,134.4 433.8,197.8 l 472.4,150.5 11.2,-27.8",
    style: {
      fill: "#acda22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "m 12743.7,11924.8 63.1,-29.2 5.9,-1130.4 -81.2,1 -2.8,721.1 c -0.3,143 -12.6,297.1 15,437.5",
    style: {
      fill: "#e3302a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path311",
    d: "m 12510.5,11213.4 -0.3,695.9 233.5,15.5 c -27.6,-140.4 -15.3,-294.5 -15,-437.5 l 2.8,-721.1 -227.1,-5.1 -233.2,6.2 14.4,440.6 13.9,18 c 70.3,-17 139.3,-13.8 211,-12.5",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "m 12299.5,11225.9 c 70.3,-17 139.3,-13.8 211,-12.5 l -6.1,-452.3 -233.2,6.2 14.4,440.6 13.9,18",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path313",
    d: "m 14595.7,14802.9 472.4,150.5 11.2,-27.8 c -61.7,-26.2 -117,-51.1 -172.1,-89.9 61,-10.6 116.9,-15.4 164.5,-59.1 38.5,-65.8 22.2,-171.1 5.1,-243 -29.3,-122.7 -99.4,-224.3 -180.2,-318.9 -121.1,-141.7 -270.3,-265.1 -406.1,-392.8 l -592.9,-592.4 c -195.6,-210.8 -366.1,-450.9 -542.9,-677.7 -103.7,-133.1 -212.5,-295.1 -361.9,-379.8 -89.2,-50.5 -161,-51.8 -259,-41.8 -44.4,23.9 -64.4,42.4 -88.7,86.5 -31.4,440.3 246.6,922.6 455,1295.1 l -21.7,3.4 -8.6,28.7 36.5,27.5 0.2,27.5 c 22.3,16.8 46.1,30.7 57.3,57 10.3,23.9 24.2,35.4 42.9,53.2 l 9.5,8.8 0.2,27.5 c 19.7,14.7 43.2,28.8 54.5,51.3 19.7,39.1 40.5,56.8 73.5,86.1 l 0.2,27.5 c -64.6,-51.4 -169.9,-161.1 -213.6,-232 -23.8,-38.5 -52.5,-72 -95,-90.2 l -22.9,-9.2 c 332.1,414.8 682.8,761.8 1148.8,1026.2 138.3,78.4 288.2,134.4 433.8,197.8",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "m 14595.7,14802.9 472.4,150.5 11.2,-27.8 c -61.7,-26.2 -117,-51.1 -172.1,-89.9 -160.2,-21.9 -297.5,-83.3 -443.2,-149.9 -469.6,-214.8 -902.9,-553.4 -1215.6,-964.9 l -148.3,-209.1 -21.7,3.4 -8.6,28.7 36.5,27.5 0.2,27.5 c 22.3,16.8 46.1,30.7 57.3,57 10.3,23.9 24.2,35.4 42.9,53.2 l 9.5,8.8 0.2,27.5 c 19.7,14.7 43.2,28.8 54.5,51.3 19.7,39.1 40.5,56.8 73.5,86.1 l 0.2,27.5 c -64.6,-51.4 -169.9,-161.1 -213.6,-232 -23.8,-38.5 -52.5,-72 -95,-90.2 l -22.9,-9.2 c 332.1,414.8 682.8,761.8 1148.8,1026.2 138.3,78.4 288.2,134.4 433.8,197.8",
    style: {
      fill: "#f4e628",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path315",
    d: "m 13395.7,13588.5 c 202.1,268.8 473.9,536.5 755.7,722.9 78.7,52 166.5,110.7 261.4,126.1 48.6,7.9 85.9,3.5 131.4,-14.4 43.3,-47.4 68.2,-79.8 64.5,-147.9 -4.4,-79.1 -51.9,-136.2 -110.8,-183 l -409.3,-315.4 c -150,-127.1 -303.2,-295.7 -468.8,-399.1 -46.8,4.1 -87.3,15.7 -127.8,40.3 -65,39.3 -81,101.5 -96.3,170.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "m 32159.3,10681.8 c 115,0.8 234.9,14.1 348.7,6.2 251.1,-17.5 485.3,-134.6 661.9,-312.5 96.5,-97 191.5,-226.7 243.3,-353.7 l -3.7,-34.2 c 66.9,-52.4 89.2,-136.3 116.3,-213.7 83,-237.3 128.7,-483.1 159,-732.2 l 33.2,-310.4 c 192,2.3 369,0.2 518,-140.3 39.8,-37.7 97.7,-91.3 100.4,-149 l -0.3,-19.4 c 93.3,-75 108.2,-213.5 120.2,-325.5 11.5,-106.7 28.8,-215 -27.3,-312.6 l 11.9,-6.4 c 272.6,-143.5 622.8,-223.8 733.7,-555.4 31.5,-94.3 16.1,-226.1 -26.6,-315 -7.6,-15.4 -15.2,-24.4 -26.4,-37.1 -52.5,-4.2 -126,-92.2 -174.9,-126.8 -101.1,-71.8 -209,-135.8 -319.7,-191.7 -411,-207.1 -881.2,-343.4 -1328.1,-449.4 l -1112.8,-212.1 c -552.2,-110.1 -1099.5,-240.5 -1658.8,-311.2 l -1367,-177.9 c -257.7,-30 -546.6,-32.7 -798.4,-90.5 l -6926.4,-468.4 c 21.3,-67.5 -19.1,-134.1 -43.9,-199.6 -83,-219 -178.7,-434.9 -286.6,-642.7 -327.9,-631.1 -749.7,-1153.1 -1265,-1639.3 l -11.6,-0.6 c -194.7,-182.9 -447.1,-356.7 -695.4,-457 -727.5,-353.8 -1508,-565.3 -2313.2,-643.5 l -458.3,-31.9 -499.6,-1.1 c -77.9,0.3 -165.6,13.5 -233.7,-24.7 -834.8,177.7 -1691.4,456 -2457.8,833.7 l -689.6,354.5 c -158.4,85.1 -326.8,194.4 -499,246.9 -210.2,126.5 -470.5,204 -697.5,299.7 -474,199.8 -812.3,572.2 -1146.8,948 -309.94,439.6 -619.63,876.5 -692.66,1425 l -2727.52,354.1 -3017.88,574.2 c -454.64,140.9 -947.93,317.8 -1278.55,676 -35.37,48.8 -62.96,103.4 -92.28,156 34.35,284.8 146.19,419.5 337.13,623.4 -107.54,207.6 -186.48,417.3 -241.78,644.4 l -18.89,70.1 76.98,34.8 c 136.06,62.4 328.74,47.9 478.11,54.3 129.52,5.5 255.57,22.7 383.09,45.6 97.6,28.3 186.76,57 268.24,119.7 292.91,225.3 383.96,629.2 698.05,856 308.52,222.7 662.74,254.9 1002.59,394 168.92,69.1 317.09,171.5 462.51,279.9 107.88,-346.2 122.22,-625.8 63.5,-984.1 127.98,-55.6 265.34,-110.4 376.22,-196.3 50.56,-51.2 93.11,-86.6 161.66,-113.3 l 9.97,1.3 7.01,92.6 c 9.11,6.4 16.73,15.8 27.35,19.3 31.24,10.1 137.21,-12.5 178.81,-14.3 l 604.53,-10.4 c 57.27,-1.8 170.48,-22.7 216.61,5.4 l 0.3,67.8 5.73,27.3 5.48,-33.9 2571.29,-6.4 707.4,1394.2 34.3,25.3 c 38.5,-7.2 68.5,-2.7 91.6,-35.9 128.9,-185.3 190.9,-421.2 319,-606.4 l 10.5,-10.9 c 112,0 324.9,25.5 423.6,-14.1 -26.5,-107.6 -68,-291.3 -9.8,-393.1 l 25.9,-38.5 c 115.3,-20 255.5,-10 372.5,-2.3 l 14.8,-307.3 4.2,-83.5 676.8,1.2 540.1,-1.6 899.6,2.2 c 89.9,2.9 198.4,-87.1 283,-124.8 l 858,-2003 40.4,-93.5 c 67.3,-151.1 130,-379.1 227.8,-507.3 l 624.5,-66.2 234.6,664.9 245.5,735.7 c 80.7,30.4 155.6,8 234,-2.5 58,-7.7 106.3,7 153.5,39 l 4.2,60.2 15.3,75.1 c 64.3,-56.7 35.1,-61.8 66.4,-130.8 13,-54.8 22.5,-115 46.6,-166 l 178,-632.4 1943.1,-10.4 c 58.2,15.9 113.2,29.6 166.6,58.7 l 142,-61.2 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 l 4,13.1 1.8,252.5 353.1,-1 c 253.8,-0.3 402.7,-21.1 605.1,149 l 41.6,-2.9 32.2,-62.4 111.1,-16.5 18.8,-1.8 c 81,-7.3 456.7,10.5 481.1,-27 l 15.8,-40.1 4.8,-5 253.5,-11.6 637.3,4.6 1245.8,13 563.8,782.5 3.2,-1131.2 c -0.3,-142.1 -27.1,-353 11.8,-487.2 l 436.4,295.7 237.6,168.9 c 85.5,51.2 217.6,176.3 304.3,202.5 27.4,8.2 98.7,-3 129.5,-3.9 l 332.9,-10.5 230.8,6.6 96.7,-6.4 c 169.2,5.8 352.4,19 520.7,0.5 l 48.6,7.8 c 89.1,-1.1 186.6,5.7 274.8,-6.1 l 72.7,16.2 366.9,-16.8 h 418.8 l 18.4,6 24.4,-0.3 c 123.6,-1.7 259.6,6.7 381.7,-7.4 l 383.5,0.4 474.8,3.1 103.8,6.6 245.7,-9.6 157.3,5.7 c 53.2,-2.9 148,5.7 190.5,-23.1 99.6,-16.6 185.6,-105.4 262,-167.6 l 654.3,-438 c 80.4,-49.2 171.7,-104 240.1,-168.1 23,11.7 39.6,19.8 54.2,41.7 l 9.8,16.1 c 133.1,211.9 343.2,309.5 577.1,363.7 2.2,92.4 21,215.2 -27.8,296.7 40.8,71 35.4,152.1 51,230.8 51.6,257.8 164.7,475.7 331.5,677.4 l -9.6,41.3 40.8,9.1 c 54.7,18.6 233,133.1 256.7,176.6 l 81.1,22 58.9,20.7",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path317",
    d: "m 34339.8,7603.1 c 200.8,-43.6 400.8,-84 521.2,-267.9 6.6,-49.8 17.6,-83.4 -13.4,-128.2 -106,-152.7 -379.1,-191.2 -548.3,-209.3 -75.7,-8.1 -152.2,-21.8 -222.5,13.6 l 23.4,8.2 c 94.8,37.7 185.1,171.5 223.7,264 35.4,85.5 31.1,160.1 -5.3,244.1 l -8.1,18.2 29.3,57.3",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "m 16843.5,4802 3069.7,18.3 c -276.9,-593.2 -746,-1154.6 -1237.6,-1586.3 -59.4,-52.2 -145.3,-144.2 -215,-175.3 l -12.3,-4.2 c -463.8,345.6 -870.1,787.8 -1227,1242 -125.7,159.9 -232,340.1 -366.2,492.4 l -11.6,13.1",
    style: {
      fill: "#46a6dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path319",
    d: "m 19913.2,4820.3 1522.3,22.3 c 21.3,-67.5 -19.1,-134.1 -43.9,-199.6 -83,-219 -178.7,-434.9 -286.6,-642.7 -327.9,-631.1 -749.7,-1153.1 -1265,-1639.3 l -11.6,-0.6 c -194.7,-182.9 -447.1,-356.7 -695.4,-457 -65.1,44.7 -151,69.1 -224.6,99 l -318.4,142.3 c -273.9,132 -524.4,297 -776.2,466.3 41.7,49.6 134.4,87.2 190.3,122.2 153.4,95.9 310,192.7 448.8,309.1 l -4.6,12.2 12.3,4.2 c 69.7,31.1 155.6,123.1 215,175.3 491.6,431.7 960.7,993.1 1237.6,1586.3",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "m 18452.9,3042.3 c 447,-281.2 869.2,-519.3 1375.5,-681.9 -194.7,-182.9 -447.1,-356.7 -695.4,-457 -65.1,44.7 -151,69.1 -224.6,99 l -318.4,142.3 c -273.9,132 -524.4,297 -776.2,466.3 41.7,49.6 134.4,87.2 190.3,122.2 153.4,95.9 310,192.7 448.8,309.1",
    style: {
      fill: "#2f5da3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path321",
    d: "m 28104.7,8223.8 1908.7,-31.9 420.1,-4.5 c 43.2,-0.5 96.5,9.8 131.6,-16.2 8.3,-36.2 9.8,-58.4 4.9,-95.2 59.6,-162 22.7,-446.3 21.8,-627.8 -0.3,-81.6 9.7,-172.1 -20.1,-249.1 42.1,-121.6 26.4,-290.6 28.1,-420 0.5,-37.7 9.8,-102 -7.1,-134.3 -6.3,-12.1 -15.8,-21.8 -24.6,-31.9 54.4,-80.8 37.6,-159.6 37.6,-255 73.3,0.9 186.8,16.4 254.7,-5.6 33.7,-95.7 35,-191.7 43,-291.8 l -948.4,1.9 c -270.8,-43.8 -572.7,-36.1 -848.4,-42.7 l -1030,-13.1 c 41.3,91.5 22.2,214.7 18.3,313.6 l -7.8,19.7 c 13.2,85.4 6.1,181.4 6.9,268.2 l 27.1,7.1 11,38.1 c 26.3,141.9 5.8,325.1 6.6,470.8 l 1.4,700.2 c 0,104 11,223.2 -1.9,325.9 -3.7,27.4 -17.9,51.4 -33.5,73.6",
    style: {
      fill: "#692816",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "m 28395.4,6611.9 37.6,63.9 0.9,863.8 c 0,132.4 20.3,303.3 -15.1,430.4 l 7.1,-10.9 c 55.2,-94.2 27.8,-311.9 28.1,-422.4 l -1.3,-948.5 1005.3,8.8 c 252.8,3.8 525.1,-3.7 775,32.9 l 1.5,549.6 c 0.2,105.9 8.7,217.8 -8.4,322.2 66.5,-111.7 31.3,-724.6 31.5,-891.2 l 310.5,2.4 c 54.4,-80.8 37.6,-159.6 37.6,-255 73.3,0.9 186.8,16.4 254.7,-5.6 33.7,-95.7 35,-191.7 43,-291.8 l -948.4,1.9 c 27.1,10.9 51.8,20.8 81.4,22 l 22.9,0.7 c 109.5,9.5 245.7,-16.8 349.3,9.1 l 17.1,4.6 c 39.6,-19.4 106.5,-1 153.4,-7.5 18.5,-2.6 23.7,6.5 38.8,16.6 l 36.6,-18.3 45.9,18.3 c 29.4,-13.4 67.7,-23.9 99.7,-14.7 15.9,4.6 46.2,9.6 53.7,24.6 25.7,51.3 13.2,153.5 -6.8,204.3 -76.7,10.3 -175.4,-6.3 -246,15.5 -29.3,9 -40,14.5 -72.2,12 -118,-9.1 -257,17.7 -369.8,-14.1 l -9.8,-3 c -118.9,56.3 -1489.6,37.5 -1688.6,19.5 -60.6,45.1 -6.4,178.5 -65.2,259.9",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323",
    d: "m 29396.7,7857.6 727.4,-0.5 5.8,-772 c 0.7,-111.8 23.5,-279.8 -25.6,-380 l -681,-2.2 3,824.8 c -0.3,93.3 21,252.5 -29.6,329.9",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "m 28541.2,7857.3 745.1,1.4 2,-765.8 c 0,-120.3 19.3,-278.8 -27.1,-389.9 l -490.7,-0.7 c -53.5,0.1 -136,-11.2 -186.1,5.3 -18.3,6.1 -10.3,64.6 -10.3,85.8 l -0.5,707.1 c -0.4,101.7 18.4,254 -25.8,344.9 l -6.6,11.9",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325",
    d: "m 28121.1,6615.2 274.3,-3.3 c 58.8,-81.4 4.6,-214.8 65.2,-259.9 199,18 1569.7,36.8 1688.6,-19.5 l 9.8,3 c 112.8,31.8 251.8,5 369.8,14.1 32.2,2.5 42.9,-3 72.2,-12 70.6,-21.8 169.3,-5.2 246,-15.5 20,-50.8 32.5,-153 6.8,-204.3 -7.5,-15 -37.8,-20 -53.7,-24.6 -32,-9.2 -70.3,1.3 -99.7,14.7 l -45.9,-18.3 -36.6,18.3 c -15.1,-10.1 -20.3,-19.2 -38.8,-16.6 -46.9,6.5 -113.8,-11.9 -153.4,7.5 l -17.1,-4.6 c -103.6,-25.9 -239.8,0.4 -349.3,-9.1 l -22.9,-0.7 c -29.6,-1.2 -54.3,-11.1 -81.4,-22 -270.8,-43.8 -572.7,-36.1 -848.4,-42.7 l -1030,-13.1 c 41.3,91.5 22.2,214.7 18.3,313.6 l -7.8,19.7 c 13.2,85.4 6.1,181.4 6.9,268.2 l 27.1,7.1",
    style: {
      fill: "#992c1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "m 28121.1,6615.2 274.3,-3.3 c 58.8,-81.4 4.6,-214.8 65.2,-259.9 -114.1,-51 -249.4,2.5 -365.7,-31.8 l -7.8,19.7 c 13.2,85.4 6.1,181.4 6.9,268.2 l 27.1,7.1",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path327",
    d: "m 28104.7,8223.8 1908.7,-31.9 420.1,-4.5 c 43.2,-0.5 96.5,9.8 131.6,-16.2 8.3,-36.2 9.8,-58.4 4.9,-95.2 59.6,-162 22.7,-446.3 21.8,-627.8 -0.3,-81.6 9.7,-172.1 -20.1,-249.1 42.1,-121.6 26.4,-290.6 28.1,-420 0.5,-37.7 9.8,-102 -7.1,-134.3 -6.3,-12.1 -15.8,-21.8 -24.6,-31.9 l -310.5,-2.4 c -0.2,166.6 35,779.5 -31.5,891.2 56.5,96.3 24.2,368.1 23,487.6 l -1218.7,1.7 c -180.8,0 -444.1,32.2 -611.6,-21 35.4,-127.1 15.1,-298 15.1,-430.4 l -0.9,-863.8 -37.6,-63.9 -274.3,3.3 11,38.1 c 26.3,141.9 5.8,325.1 6.6,470.8 l 1.4,700.2 c 0,104 11,223.2 -1.9,325.9 -3.7,27.4 -17.9,51.4 -33.5,73.6",
    style: {
      fill: "#c1b67b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "m 27951.8,8202.7 152.9,21.1 c 15.6,-22.2 29.8,-46.2 33.5,-73.6 12.9,-102.7 1.9,-221.9 1.9,-325.9 l -1.4,-700.2 c -0.8,-145.7 19.7,-328.9 -6.6,-470.8 l -11,-38.1 -27.1,-7.1 c -0.8,-86.8 6.3,-182.8 -6.9,-268.2 l 7.8,-19.7 c 3.9,-98.9 23,-222.1 -18.3,-313.6 -35.9,-17.7 -3608.6,-44.7 -3758.4,-4 22.9,126.4 6.4,184.8 -50.9,296.2 l 5.6,16.7 -0.2,293.7 -1.2,1263.4 783.4,4.8 22,34.9 c 438.4,32.7 892.7,5 1332.8,6.5 l 516.1,2.9 c 93,0.6 198.3,11.6 289.2,-9.4 34.4,47.2 31,72.8 35.4,128 107,73.2 369,-29.5 495.3,34.7 33,4.8 66.4,8.5 97.2,22.1 50.3,22 89.6,55.8 108.9,105.6",
    style: {
      fill: "#f3dbb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329",
    d: "m 25054.9,7877.4 22,34.9 c 438.4,32.7 892.7,5 1332.8,6.5 l 516.1,2.9 c 93,0.6 198.3,11.6 289.2,-9.4 l -2.7,-14.9 c -44.5,-275.2 -9.5,-609.8 -8.6,-891.2 l -2129.2,-8.1 3.2,616.8 c 0,84 15.1,186.4 -22.8,262.5",
    style: {
      fill: "#992c1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "m 26513.5,7783.4 560,-0.7 1.8,-405 c -0.3,-85.1 10.7,-173 -29.4,-250.7 l -503.3,0.5 c 4.9,155.4 42.5,508.8 -22.7,644.1 l -6.4,11.8",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331",
    d: "m 25837.2,7786.3 550,-3.2 7.1,-405.2 c 0.8,-85.3 13,-173.1 -26.4,-251.5 l -504.8,0.2 3.2,404 c 0,80.7 10.2,168.1 -23,243.4 l -6.1,12.3",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "m 25166.1,7787.7 558,2 1.7,-409.4 c -0.2,-90 10.3,-178.7 -32.7,-260.8 l -493.1,2.5 1.7,426.8 c -0.2,77.9 8.8,155.6 -28.3,226.6 l -7.3,12.3",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path333",
    d: "m 24272.7,6609.2 3821.3,-1.1 c -0.8,-86.8 6.3,-182.8 -6.9,-268.2 l 7.8,-19.7 c 3.9,-98.9 23,-222.1 -18.3,-313.6 -35.9,-17.7 -3608.6,-44.7 -3758.4,-4 22.9,126.4 6.4,184.8 -50.9,296.2 l 5.6,16.7 -0.2,293.7",
    style: {
      fill: "#f08819",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "m 12617.3,5006.5 3187.8,-170.9 1038.4,-33.6 11.6,-13.1 c 134.2,-152.3 240.5,-332.5 366.2,-492.4 356.9,-454.2 763.2,-896.4 1227,-1242 l 4.6,-12.2 c -138.8,-116.4 -295.4,-213.2 -448.8,-309.1 -55.9,-35 -148.6,-72.6 -190.3,-122.2 l -15.5,7 -325,255.6 c -629.4,-117.8 -1237.9,-147.7 -1868.4,-14.3 -979.7,207.4 -1811.5,689.7 -2474.8,1444.2 -190.9,217.2 -355.6,461 -512.8,703",
    style: {
      fill: "#46a6dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path335",
    d: "m 15805.1,4835.6 1038.4,-33.6 11.6,-13.1 c 134.2,-152.3 240.5,-332.5 366.2,-492.4 356.9,-454.2 763.2,-896.4 1227,-1242 l 4.6,-12.2 c -138.8,-116.4 -295.4,-213.2 -448.8,-309.1 -55.9,-35 -148.6,-72.6 -190.3,-122.2 l -15.5,7 -325,255.6 c -228.1,210.4 -459.5,409.4 -674.5,634.4 -369.7,386.8 -728.8,862.8 -993.7,1327.6",
    style: {
      fill: "#407dac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "m 26813.4,9594.8 366.9,-16.8 h 418.8 l 18.4,6 24.4,-0.3 c 123.6,-1.7 259.6,6.7 381.7,-7.4 l 383.5,0.4 474.8,3.1 103.8,6.6 245.7,-9.6 157.3,5.7 c 53.2,-2.9 148,5.7 190.5,-23.1 99.6,-16.6 185.6,-105.4 262,-167.6 l 654.3,-438 c 80.4,-49.2 171.7,-104 240.1,-168.1 112.9,-69.5 565.9,-323.5 613.1,-415.7 -21.3,-47.6 -53,-76.8 -89.4,-112.6 l -120.9,43.2 c -76.2,-38 -129,-60.2 -215,-60 l -264,42.9 -53.5,-14.3 -40.8,-98 c -35.1,26 -88.4,15.7 -131.6,16.2 l -420.1,4.5 -1908.7,31.9 -152.9,-21.1 c -19.3,-49.8 -58.6,-83.6 -108.9,-105.6 -30.8,-13.6 -64.2,-17.3 -97.2,-22.1 -126.3,-64.2 -388.3,38.5 -495.3,-34.7 -4.4,-55.2 -1,-80.8 -35.4,-128 -90.9,21 -196.2,10 -289.2,9.4 l -516.1,-2.9 c -440.1,-1.5 -894.4,26.2 -1332.8,-6.5 l -22,-34.9 -783.4,-4.8 -1.6,185.7 c -7.5,63 -5.9,123.8 -3.7,187 l -136.1,-0.7 c -187.1,-1.1 -456.5,-37 -632.7,14.9 l -9.9,-0.6 -4.8,88.7 c -33.7,13.5 -48.7,20.2 -71.9,49.8 l 81.8,75.4 635.8,450.7 436.4,295.7 237.6,168.9 c 85.5,51.2 217.6,176.3 304.3,202.5 27.4,8.2 98.7,-3 129.5,-3.9 l 332.9,-10.5 230.8,6.6 96.7,-6.4 c 169.2,5.8 352.4,19 520.7,0.5 l 48.6,7.8 c 89.1,-1.1 186.6,5.7 274.8,-6.1 l 72.7,16.2",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path337",
    d: "m 27180.3,9578 h 418.8 c -37.1,-56.9 -111.3,-94.7 -167.3,-132.3 l -381.9,-253.5 -835.1,-552.4 C 26081.5,8555 25912,8475.9 25796.7,8370 l -34.9,-4.7 20.2,-25.1 c -43.9,-41.6 -84.2,-61.6 -139.2,-85.3 l -217.8,7.1 -19.1,25.6 15.6,82.2 c 202.7,117.1 1715.1,1098.2 1758.8,1208.2",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "m 25421.5,8369.8 340.3,-4.5 20.2,-25.1 c -43.9,-41.6 -84.2,-61.6 -139.2,-85.3 l -217.8,7.1 -19.1,25.6 15.6,82.2",
    style: {
      fill: "#6b451a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path339",
    d: "m 28023.6,9576.3 383.5,0.4 c -39.1,-97.5 -1130.6,-782 -1298.4,-889.3 -141.9,-90.9 -372.9,-204.1 -480.6,-330.9 l -45,-5.7 c -23.2,-54.2 -58.4,-75.6 -104.5,-108.4 l -325.8,1.3 c 32.7,37.3 52,74.4 73.3,119.1 l 26.6,9.2 c 234.2,185.9 1717.9,1062.2 1770.9,1204.3",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "m 26252.7,8372 330.4,-21.2 c -23.2,-54.2 -58.4,-75.6 -104.5,-108.4 l -325.8,1.3 c 32.7,37.3 52,74.4 73.3,119.1 l 26.6,9.2",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path341",
    d: "m 26813.4,9594.8 366.9,-16.8 c -43.7,-110 -1556.1,-1091.1 -1758.8,-1208.2 l -430.6,-0.1 c 170.5,154.7 401.8,278 596.2,404 l 827.5,553.8 c 83,56.5 288.9,166.3 326.1,251.1 l 72.7,16.2",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "m 26465.9,9584.7 c 89.1,-1.1 186.6,5.7 274.8,-6.1 -37.2,-84.8 -243.1,-194.6 -326.1,-251.1 l -827.5,-553.8 c -194.4,-126 -425.7,-249.3 -596.2,-404 l -15.8,-2.6 -342,5.8 -16.8,-8.4 -458.8,6.8 c 54.8,69.6 187,131.2 262.6,182.6 l 1192.9,792.2 c 75.5,52.7 257.4,149.6 283.6,230.3 169.2,5.8 352.4,19 520.7,0.5 l 48.6,7.8",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path343",
    d: "m 26465.9,9584.7 c 89.1,-1.1 186.6,5.7 274.8,-6.1 -37.2,-84.8 -243.1,-194.6 -326.1,-251.1 l -827.5,-553.8 c -194.4,-126 -425.7,-249.3 -596.2,-404 l -15.8,-2.6 -342,5.8 1164.1,783.6 414.7,264.6 c 68.9,44.6 155.8,90.2 205.4,155.8 l 48.6,7.8",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "m 24802.4,9388.1 c 85.5,51.2 217.6,176.3 304.3,202.5 27.4,8.2 98.7,-3 129.5,-3.9 l 332.9,-10.5 230.8,6.6 96.7,-6.4 c -26.2,-80.7 -208.1,-177.6 -283.6,-230.3 l -1192.9,-792.2 c -75.6,-51.4 -207.8,-113 -262.6,-182.6 l -12.6,-2.5 -322.2,4.5 -32.5,-18.2 -70.3,-92.5 -222.5,-3.1 -9.9,-0.6 -4.8,88.7 c -33.7,13.5 -48.7,20.2 -71.9,49.8 l 81.8,75.4 635.8,450.7 436.4,295.7 237.6,168.9",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path345",
    d: "m 23482.7,8347.6 307.5,7.5 -70.3,-92.5 -222.5,-3.1 -9.9,-0.6 -4.8,88.7",
    style: {
      fill: "#7b561c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "m 25799.9,9582.8 96.7,-6.4 c -26.2,-80.7 -208.1,-177.6 -283.6,-230.3 l -1192.9,-792.2 c -75.6,-51.4 -207.8,-113 -262.6,-182.6 l -12.6,-2.5 -322.2,4.5 c 147,140.1 335,251.1 503.5,363.7 l 832.5,550.4 c 99.4,65.3 367.4,188.6 410.4,288.8 l 230.8,6.6",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path347",
    d: "m 23822.7,8373.3 322.2,-4.5 12.6,2.5 458.8,-6.8 16.8,8.4 342,-5.8 15.8,2.6 430.6,0.1 -15.6,-82.2 19.1,-25.6 217.8,-7.1 c 55,23.7 95.3,43.7 139.2,85.3 l -20.2,25.1 34.9,4.7 429.4,-7.2 c -21.3,-44.7 -40.6,-81.8 -73.3,-119.1 l 325.8,-1.3 c 46.1,32.8 81.3,54.2 104.5,108.4 l 45,5.7 371.4,-5.8 53.8,17.8 c 110.9,-19.2 223.4,-17.7 335.6,-19.3 l 48.1,6.3 289.9,-2.1 c 14.6,-44.1 31.7,-80.3 20.2,-126.7 42.1,-1.2 87,-5.9 128.8,0 l 75.9,-24 c -19.3,-49.8 -58.6,-83.6 -108.9,-105.6 -30.8,-13.6 -64.2,-17.3 -97.2,-22.1 -126.3,-64.2 -388.3,38.5 -495.3,-34.7 -4.4,-55.2 -1,-80.8 -35.4,-128 -90.9,21 -196.2,10 -289.2,9.4 l -516.1,-2.9 c -440.1,-1.5 -894.4,26.2 -1332.8,-6.5 l -22,-34.9 -783.4,-4.8 -1.6,185.7 c -7.5,63 -5.9,123.8 -3.7,187 l -136.1,-0.7 c -187.1,-1.1 -456.5,-37 -632.7,14.9 l 222.5,3.1 70.3,92.5 32.5,18.2",
    style: {
      fill: "#9a8832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "m 26628.1,8356.5 371.4,-5.8 -8.7,-20.6 c -9.3,-21.2 -20.1,-36.7 -35.2,-54.3 l 6.1,-35.2 1.7,-11.4 c -161.2,-2.2 -324.8,-11.2 -484.8,13.2 46.1,32.8 81.3,54.2 104.5,108.4 l 45,5.7",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path349",
    d: "m 25796.7,8370 429.4,-7.2 c -21.3,-44.7 -40.6,-81.8 -73.3,-119.1 -164.6,-24.9 -345.1,-7.6 -510.7,0.1 l 0.7,11.1 c 55,23.7 95.3,43.7 139.2,85.3 l -20.2,25.1 34.9,4.7",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "m 27053.3,8368.5 c 110.9,-19.2 223.4,-17.7 335.6,-19.3 l 48.1,6.3 289.9,-2.1 c 14.6,-44.1 31.7,-80.3 20.2,-126.7 l -783.7,2.5 -1.7,11.4 -6.1,35.2 c 15.1,17.6 25.9,33.1 35.2,54.3 l 8.7,20.6 53.8,17.8",
    style: {
      fill: "#7b561c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path351",
    d: "m 27053.3,8368.5 c 110.9,-19.2 223.4,-17.7 335.6,-19.3 -23.7,-52.8 -69.4,-77 -115.6,-108.6 h -311.6 l -6.1,35.2 c 15.1,17.6 25.9,33.1 35.2,54.3 l 8.7,20.6 53.8,17.8",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "m 23822.7,8373.3 322.2,-4.5 12.6,2.5 458.8,-6.8 16.8,8.4 342,-5.8 15.8,2.6 430.6,0.1 -15.6,-82.2 19.1,-25.6 217.8,-7.1 -0.7,-11.1 -843.6,1.7 -532.3,-0.2 -136.1,-0.7 c -187.1,-1.1 -456.5,-37 -632.7,14.9 l 222.5,3.1 70.3,92.5 32.5,18.2",
    style: {
      fill: "#7d6620",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path353",
    d: "m 24633.1,8372.9 342,-5.8 c -54.7,-36.7 -113.1,-82.8 -172,-111.4 l -211.5,10.1 c -12.2,43.8 5.1,58.9 24.7,98.7 l 16.8,8.4",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "m 23822.7,8373.3 322.2,-4.5 -48,-99.8 c -122.5,-17.7 -253.2,-7.7 -377,-6.4 l 70.3,92.5 32.5,18.2",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path355",
    d: "m 24269.9,8058.3 3475.8,16.7 c -126.3,-64.2 -388.3,38.5 -495.3,-34.7 -4.4,-55.2 -1,-80.8 -35.4,-128 -90.9,21 -196.2,10 -289.2,9.4 l -516.1,-2.9 c -440.1,-1.5 -894.4,26.2 -1332.8,-6.5 l -22,-34.9 -783.4,-4.8 -1.6,185.7",
    style: {
      fill: "#c1b67b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "m 28881.9,9579.8 103.8,6.6 245.7,-9.6 157.3,5.7 c 53.2,-2.9 148,5.7 190.5,-23.1 -10,-19.2 -18.6,-38 -32.3,-55 l 81.8,-12.1 c 4.4,-49.8 12.3,-101.5 4.9,-151.2 -49.1,-96.7 -181.4,-157.6 -270.1,-217.1 l -806.2,-496 c -149,-93.1 -300.4,-202.2 -460.2,-275.2 -69.3,-52.3 -143.6,-88.3 -221.2,-126.1 -41.8,-5.9 -86.7,-1.2 -128.8,0 11.5,46.4 -5.6,82.6 -20.2,126.7 l -289.9,2.1 -48.1,-6.3 c -112.2,1.6 -224.7,0.1 -335.6,19.3 l -53.8,-17.8 -371.4,5.8 c 107.7,126.8 338.7,240 480.6,330.9 167.8,107.3 1259.3,791.8 1298.4,889.3 l 474.8,3.1",
    style: {
      fill: "#ec5a1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path357",
    d: "m 29388.7,9582.5 c 53.2,-2.9 148,5.7 190.5,-23.1 -10,-19.2 -18.6,-38 -32.3,-55 -96.5,-101.5 -276,-182.6 -397.3,-257 l -776,-483.7 -412.7,-268 c -74.3,-48.5 -151.5,-109.5 -234,-142.3 l -289.9,2.1 c 450.3,345.7 968.6,621.9 1440.7,939.2 83.6,56.2 328.3,197 353.7,282.1 l 157.3,5.7",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "m 29546.9,9504.4 81.8,-12.1 c 4.4,-49.8 12.3,-101.5 4.9,-151.2 -49.1,-96.7 -181.4,-157.6 -270.1,-217.1 l -806.2,-496 c -149,-93.1 -300.4,-202.2 -460.2,-275.2 -69.3,-52.3 -143.6,-88.3 -221.2,-126.1 -41.8,-5.9 -86.7,-1.2 -128.8,0 11.5,46.4 -5.6,82.6 -20.2,126.7 82.5,32.8 159.7,93.8 234,142.3 l 412.7,268 776,483.7 c 121.3,74.4 300.8,155.5 397.3,257",
    style: {
      fill: "#81371a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path359",
    d: "m 28407.1,9576.7 474.8,3.1 c -61.3,-89.4 -183,-156.7 -274.3,-216.9 l -580.1,-370.8 -974.2,-623.6 -53.8,-17.8 -371.4,5.8 c 107.7,126.8 338.7,240 480.6,330.9 167.8,107.3 1259.3,791.8 1298.4,889.3",
    style: {
      fill: "#f1b015",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "m 29579.2,9559.4 c 99.6,-16.6 185.6,-105.4 262,-167.6 l 654.3,-438 c 80.4,-49.2 171.7,-104 240.1,-168.1 112.9,-69.5 565.9,-323.5 613.1,-415.7 -21.3,-47.6 -53,-76.8 -89.4,-112.6 l -120.9,43.2 c -76.2,-38 -129,-60.2 -215,-60 l -264,42.9 -53.5,-14.3 -40.8,-98 c -35.1,26 -88.4,15.7 -131.6,16.2 l -420.1,4.5 -1908.7,31.9 -152.9,-21.1 -75.9,24 c 77.6,37.8 151.9,73.8 221.2,126.1 159.8,73 311.2,182.1 460.2,275.2 l 806.2,496 c 88.7,59.5 221,120.4 270.1,217.1 7.4,49.7 -0.5,101.4 -4.9,151.2 l -81.8,12.1 c 13.7,17 22.3,35.8 32.3,55",
    style: {
      fill: "#9a8832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path361",
    d: "m 29579.2,9559.4 c 99.6,-16.6 185.6,-105.4 262,-167.6 l 654.3,-438 c 80.4,-49.2 171.7,-104 240.1,-168.1 112.9,-69.5 565.9,-323.5 613.1,-415.7 -21.3,-47.6 -53,-76.8 -89.4,-112.6 l -120.9,43.2 c -76.2,-38 -129,-60.2 -215,-60 l -264,42.9 c -45.2,73.5 -279.6,189 -361,242.1 l -599.6,399.3 c -106.9,70.1 -215.4,152.7 -335.3,199.1 88.7,59.5 221,120.4 270.1,217.1 7.4,49.7 -0.5,101.4 -4.9,151.2 l -81.8,12.1 c 13.7,17 22.3,35.8 32.3,55",
    style: {
      fill: "#692816",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "m 29579.2,9559.4 c 99.6,-16.6 185.6,-105.4 262,-167.6 l 654.3,-438 c 80.4,-49.2 171.7,-104 240.1,-168.1 112.9,-69.5 565.9,-323.5 613.1,-415.7 -21.3,-47.6 -53,-76.8 -89.4,-112.6 l -120.9,43.2 11,42.3 L 30029,9091 c -131.4,83.2 -257.4,178.5 -395.4,250.1 7.4,49.7 -0.5,101.4 -4.9,151.2 l -81.8,12.1 c 13.7,17 22.3,35.8 32.3,55",
    style: {
      fill: "#a1461e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path363",
    d: "m 24113.4,10541.9 3.2,-1131.2 c -0.3,-142.1 -27.1,-353 11.8,-487.2 l -635.8,-450.7 -81.8,-75.4 c 23.2,-29.6 38.2,-36.3 71.9,-49.8 l 4.8,-88.7 9.9,0.6 c 176.2,-51.9 445.6,-16 632.7,-14.9 l 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c 57.3,-111.4 73.8,-169.8 50.9,-296.2 l -38.1,-51.6 c -80.6,1 -172.4,-6.3 -251.3,7.1 l -2566.8,15 -529.5,4.3 2.7,226.7 3.8,206.2 26.4,18.4 13.2,5.3 c 91.8,34.3 304.3,70 393.3,28.9 l -1.6,3274.1 42.7,16.4 253.5,-11.6 637.3,4.6 1245.8,13 563.8,782.5",
    style: {
      fill: "url(#linearGradient364)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path365",
    d: "m 22022,7317.6 c 11.8,148.4 4.4,300.9 3.7,449.8 -0.3,67 -12.7,141.4 19.6,200.3 l 86.4,3.2 c 52.1,-177.1 16.3,-447.6 15.4,-635.7 l -28.5,-26.1 c -30.7,2.4 -66.8,1.9 -96.6,8.5",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "m 22736,7998.3 97,-5.1 c 10.8,-11.8 24.4,-21.5 32.4,-35.3 8.9,-15.3 0.4,-121.9 0.4,-144.5 l 1.5,-515.9 c -53.5,5 -95.6,-1.9 -134.7,37.7 l 3.4,663.1",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path367",
    d: "m 22186.5,7973.9 c 63.6,-2 109,10.6 156.5,-34.3 l 2,-631.2 -134.8,0.8 c -8.4,8.6 -21.4,14.5 -25.3,26 -11.3,33.4 0.3,122.9 0.4,161 l 1.2,477.7",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "m 22582.6,7987.4 35,-24.1 c 14,-103.1 36.4,-556.8 1.7,-633.2 -9.8,-21.7 -90.1,-33.5 -115.7,-39.9 l -35.1,45 -3.9,451.9 c -0.6,62.2 -14,133.3 20.4,185.3 l 97.6,15",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path369",
    d: "m 23139.6,7981.1 c 8.1,-13.6 16.2,-25.4 18,-41.5 16,-142 1,-303.1 0.4,-446.8 -0.3,-61.2 11.8,-130 -22.8,-180.8 -60.4,-1.5 -120.7,-19.3 -165.5,23.2 v 465.6 c 0,68 -15,138.4 28.2,192.1 l 116,-1.8 25.7,-10",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "m 22732.1,9002.3 c 43.9,0.8 96.7,9.1 133,-18.8 l -1.4,-994.4 -104,7.5 c -8.5,11.5 -20.4,21.2 -25.7,34.5 -14.4,36.3 -0.3,166.7 -0.4,212.5 l -1.5,758.7",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path371",
    d: "m 22184,8996.7 c 57.7,0 102.3,10.6 151,-22.3 l 8,-974.8 c -58.1,-0.9 -107.6,-14.6 -154,22.4 l -5,974.7",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "m 22462.5,8998.8 c 58.4,-1.8 107.9,10 152.5,-29.9 l 8.9,-975 c -59.4,2.6 -113.9,-8.9 -158.5,32.2 l -2.9,972.7",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path373",
    d: "m 23113.9,7991.1 -116,4.6 c -9.5,11.8 -22.1,21.7 -28.5,35.4 -14.2,30.5 -1.3,155 -1.7,198.6 l -4.9,772.3 188.2,-0.3 c 16,-77.3 7.6,-168.3 7.8,-247.8 l 0.5,-486.9 c -0.2,-83.2 16.3,-213 -19.7,-285.9 l -25.7,10",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "m 22021,8982.8 c 47.3,11.6 73,17 119.5,0.7 l 5.1,-697.1 c 0.2,-94.4 17,-219.7 -14.2,-306.7 l 0.3,-8.8 -86.4,-3.2 c -32.3,-58.9 -19.9,-133.3 -19.6,-200.3 0.7,-148.9 8.1,-301.4 -3.7,-449.8 l -38.7,-9.1 -143.1,0.4 4.5,635.3 103.9,28.8 c 8,10.7 34,37.8 36.8,49 16.1,63.8 0.4,178.5 0.6,246.9 l 8.3,713.3 26.7,0.6",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path375",
    d: "m 21994.3,8982.2 26.7,0.6 11.4,-979.1 c 37.5,-24.5 55,-21.7 99,-24 l 0.3,-8.8 -86.4,-3.2 c -32.3,-58.9 -19.9,-133.3 -19.6,-200.3 0.7,-148.9 8.1,-301.4 -3.7,-449.8 l -38.7,-9.1 0.6,631.1 -35.3,33.4 c 8,10.7 34,37.8 36.8,49 16.1,63.8 0.4,178.5 0.6,246.9 l 8.3,713.3",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "m 21948.6,7973 35.3,-33.4 -0.6,-631.1 -143.1,0.4 4.5,635.3 103.9,28.8",
    style: {
      fill: "#282826",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path377",
    d: "m 22303.2,6411.3 -15,3.7 c -141.9,32.1 -316.6,15.6 -462.7,14.9 l 2.4,181.8 c 123.9,-0.6 464.8,-38.6 556.3,27.3 139.6,-2.4 275.8,-33.7 412.2,-36.2 l 414.6,0.7 c 49.7,0 122.5,9.1 168,-9.8 29.6,-12.3 45.3,-10.6 77,-9.5 l -0.2,-146.6 c -82.7,-16.8 -168,1.2 -252.4,-7.1 -24.8,-2.4 -43.7,0.8 -68.2,2.6 -26.3,1.9 -51.7,-0.1 -78.4,2.5 -24.5,2.4 -43.8,-0.1 -68.1,-2.5 l -33.7,-2.4 -15.4,-17 -636.4,-2.4",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "m 24113.4,10541.9 3.2,-1131.2 c -0.3,-142.1 -27.1,-353 11.8,-487.2 l -635.8,-450.7 14.5,1276.5 -1203.3,-2.9 1245.8,13 563.8,782.5",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path379",
    d: "m 21413,9753.4 253.5,-11.6 c 101.6,-11.3 164,-11.7 232.3,-95.4 127.7,-156.5 150.6,-398.4 160.5,-592.5 -94.5,-0.8 -210.2,9.1 -300.6,-18.8 58.7,-10.2 173.6,-9.6 220.2,-38.4 l 15.4,-14.5 -8.3,-713.3 c -0.2,-68.4 15.5,-183.1 -0.6,-246.9 -2.8,-11.2 -28.8,-38.3 -36.8,-49 l -103.9,-28.8 -4.5,-635.3 -72.8,-21.7 c 33.9,-138 18,-305.5 19.1,-447.8 l 17.3,-433.6 -400.2,-3 c -14.2,16.4 -22.4,40.4 -31.7,60.1 l -1.6,3274.1 42.7,16.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "m 21758.7,9035.1 c 58.7,-10.2 173.6,-9.6 220.2,-38.4 l -125.9,-4.9 c -41.5,-62.2 -24.9,-924.6 -8.3,-1047.6 l -4.5,-635.3 -72.8,-21.7 c -32.6,51.7 -7.7,1544.9 -8.7,1747.9",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path381",
    d: "m 21844.7,7944.2 c -16.6,123 -33.2,985.4 8.3,1047.6 l 125.9,4.9 15.4,-14.5 -8.3,-713.3 c -0.2,-68.4 15.5,-183.1 -0.6,-246.9 -2.8,-11.2 -28.8,-38.3 -36.8,-49 l -103.9,-28.8",
    style: {
      fill: "#213241",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "m 23487.5,8258.9 9.9,0.6 c 176.2,-51.9 445.6,-16 632.7,-14.9 l 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c 57.3,-111.4 73.8,-169.8 50.9,-296.2 l -38.1,-51.6 c -80.6,1 -172.4,-6.3 -251.3,7.1 l -2566.8,15 -529.5,4.3 2.7,226.7 3.8,206.2 26.4,18.4 13.2,5.3 c 91.8,34.3 304.3,70 393.3,28.9 9.3,-19.7 17.5,-43.7 31.7,-60.1 l 400.2,3 499.4,5.5 636.4,2.4 558.7,-2.7 -10.8,1847.9",
    style: {
      fill: "url(#linearGradient383)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "m 24062.3,6393.8 c 88.4,-1.1 140.5,-37.1 205,-95 57.3,-111.4 73.8,-169.8 50.9,-296.2 l -38.1,-51.6 c -80.6,1 -172.4,-6.3 -251.3,7.1 l 42.8,42.8 c 53.2,56.8 79.6,129.5 70.2,207.9 -8.6,71.4 -58.6,100.6 -107.8,145.1 l 28.3,39.9",
    style: {
      fill: "#243a71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path385",
    d: "m 20965.4,6428.7 13.2,5.3 c 91.8,34.3 304.3,70 393.3,28.9 9.3,-19.7 17.5,-43.7 31.7,-60.1 301.8,-40.2 638,-9.7 943.2,-8.2 l 1715.5,-0.8 -28.3,-39.9 -2661.7,21.2 c -132.1,-5.9 -280.4,17.6 -406.9,53.6",
    style: {
      fill: "#482823",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "m 20935.2,6204.1 3.8,206.2 26.4,18.4 c 126.5,-36 274.8,-59.5 406.9,-53.6 l 74.1,-29 c 25.7,-111.5 22.1,-258.6 15.6,-373 l -529.5,4.3 2.7,226.7",
    style: {
      fill: "#b5cac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path387",
    d: "m 24136.3,7757.1 c 1.7,108.1 -8.8,234.1 20.3,338.1 45,4.6 73.7,-17.4 113.3,-36.9 l 1.6,-185.7 1.2,-1263.4 0.2,-293.7 -5.6,-16.7 c -64.5,57.9 -116.6,93.9 -205,95 l -1715.5,0.8 c -305.2,-1.5 -641.4,-32 -943.2,8.2 l 400.2,3 499.4,5.5 636.4,2.4 558.7,-2.7 634.1,0.6 3.9,1345.5",
    style: {
      fill: "url(#linearGradient388)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path389",
    d: "m 23487.5,8258.9 9.9,0.6 c 176.2,-51.9 445.6,-16 632.7,-14.9 l 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 -39.6,19.5 -68.3,41.5 -113.3,36.9 -29.1,-104 -18.6,-230 -20.3,-338.1 l -3.9,-1345.5 -634.1,-0.6 -10.8,1847.9",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "m 24130.1,8244.6 136.1,0.7 c -2.2,-63.2 -3.8,-124 3.7,-187 -39.6,19.5 -68.3,41.5 -113.3,36.9 -29.1,-104 -18.6,-230 -20.3,-338.1 l -6.2,487.5",
    style: {
      fill: "#7e8962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path391",
    d: "m 32159.3,10681.8 c 115,0.8 234.9,14.1 348.7,6.2 251.1,-17.5 485.3,-134.6 661.9,-312.5 96.5,-97 191.5,-226.7 243.3,-353.7 l -3.7,-34.2 c 66.9,-52.4 89.2,-136.3 116.3,-213.7 83,-237.3 128.7,-483.1 159,-732.2 l 33.2,-310.4 c 192,2.3 369,0.2 518,-140.3 39.8,-37.7 97.7,-91.3 100.4,-149 l -0.3,-19.4 c 93.3,-75 108.2,-213.5 120.2,-325.5 11.5,-106.7 28.8,-215 -27.3,-312.6 -8.1,-74.1 -32.5,-131.8 -89.2,-181.4 l -29.3,-57.3 8.1,-18.2 c 36.4,-84 40.7,-158.6 5.3,-244.1 -38.6,-92.5 -128.9,-226.3 -223.7,-264 l -23.4,-8.2 -37.4,-0.8 c -41.3,-70.9 -189,-129.7 -268.4,-150.4 l -34,-7.9 c -69.8,-61.2 -169,-89.8 -253,-127.8 -773,-349.4 -1718.4,-493.4 -2563.7,-520.8 -39.9,53.1 -16.4,95 -59.9,148.7 -67.9,22 -181.4,6.5 -254.7,5.6 0,95.4 16.8,174.2 -37.6,255 8.8,10.1 18.3,19.8 24.6,31.9 16.9,32.3 7.6,96.6 7.1,134.3 -1.7,129.4 14,298.4 -28.1,420 29.8,77 19.8,167.5 20.1,249.1 0.9,181.5 37.8,465.8 -21.8,627.8 4.9,36.8 3.4,59 -4.9,95.2 l 40.8,98 53.5,14.3 264,-42.9 c 86,-0.2 138.8,22 215,60 l 120.9,-43.2 c 36.4,35.8 68.1,65 89.4,112.6 -47.2,92.2 -500.2,346.2 -613.1,415.7 23,11.7 39.6,19.8 54.2,41.7 l 9.8,16.1 c 133.1,211.9 343.2,309.5 577.1,363.7 2.2,92.4 21,215.2 -27.8,296.7 40.8,71 35.4,152.1 51,230.8 51.6,257.8 164.7,475.7 331.5,677.4 l -9.6,41.3 40.8,9.1 c 54.7,18.6 233,133.1 256.7,176.6 l 81.1,22 58.9,20.7",
    style: {
      fill: "#44ba3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "m 32779.9,8562.3 c 70.3,0.9 133.3,2.6 193.2,-41.4 47.1,-34.6 83.2,-77.2 91.8,-136.4 10.5,-73 7.3,-136.5 -42,-195 -54.2,-64.3 -102.6,-69.1 -180.8,-76.1 -15.8,-0.9 -28.8,-1.5 -44.2,2.1 -63.9,14.5 -124.3,50.8 -158.5,107.7 -34.6,57.7 -39.8,110.8 -21.5,174.9 24.5,84.5 88.9,126.1 162,164.2",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path393",
    d: "m 32760.6,8507.4 c 69.8,-0.1 81.1,2.6 137.5,-36.7 29.5,-59.4 25.1,-70.7 15.9,-137.4 -45,-59.2 -55.7,-71.7 -123.4,-100.7 l -65.9,-6.3 -63.8,61.3 -4.1,82.4 c 4.4,61.6 60.3,100.8 103.8,137.4",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "m 32554.9,7559.5 c 173.9,63.8 328.5,186.3 504.1,256.3 268.9,107.1 551.3,133.2 810.7,272.6 104.2,55.9 201.9,121.6 294.3,195.4 50.5,40.4 97.2,96.5 153.1,128.4 l 19,10.4 c 93.3,-75 108.2,-213.5 120.2,-325.5 11.5,-106.7 28.8,-215 -27.3,-312.6 -8.1,-74.1 -32.5,-131.8 -89.2,-181.4 l -29.3,-57.3 8.1,-18.2 c 36.4,-84 40.7,-158.6 5.3,-244.1 -38.6,-92.5 -128.9,-226.3 -223.7,-264 l -23.4,-8.2 -37.4,-0.8 -1363.8,-7.1 c -34.4,-35.8 -82.3,-42.8 -130.7,-43.8 l -98.4,2.4 -20.8,-2.4 c -78.1,-7.2 -119.4,23.5 -174.1,71.6 l -16.6,2.8 -25.4,38.4 -48.9,178.6 -1.4,56.9 c 16.3,16.6 27.6,28 36.4,50 18,45.1 36.4,89.3 68.8,126 54,60.7 103.6,87.7 184.9,92.2 l 73.8,-14.1 31.7,-2.5",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path395",
    d: "m 32159.3,7307.9 c 16.3,16.6 27.6,28 36.4,50 18,45.1 36.4,89.3 68.8,126 54,60.7 103.6,87.7 184.9,92.2 l 73.8,-14.1 31.7,-2.5 c 97.7,-62.6 149,-155.1 173,-267.8 15.6,-74.4 19.2,-188.3 -21.3,-255.1 -8.5,-14.1 -18.6,-22.7 -31,-33.2 -34.4,-35.8 -82.3,-42.8 -130.7,-43.8 l -98.4,2.4 -20.8,-2.4 c -78.1,-7.2 -119.4,23.5 -174.1,71.6 l -16.6,2.8 -25.4,38.4 -48.9,178.6 -1.4,56.9",
    style: {
      fill: "#9a8832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "m 32529.3,7379.5 c 46.4,-74.2 24.7,-112.6 11.7,-197.4 l -30.8,-39.3 15.4,-67.9 -79.1,-112.9 -20.8,-2.4 c -78.1,-7.2 -119.4,23.5 -174.1,71.6 l -16.6,2.8 -25.4,38.4 36.4,17.2 12.2,37.2 39.3,5.9 33.2,-25.5 c 61.8,17.1 107.7,80.9 146.3,129.8 42.8,54.1 60.8,73.2 52.3,142.5",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path397",
    d: "m 32510.2,7142.8 15.4,-67.9 -79.1,-112.9 -20.8,-2.4 c -78.1,-7.2 -119.4,23.5 -174.1,71.6 l 33.4,32 c 76.3,0 166.4,30.1 225.2,79.6",
    style: {
      fill: "#7d6620",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    d: "m 32523.2,7562 31.7,-2.5 c 97.7,-62.6 149,-155.1 173,-267.8 15.6,-74.4 19.2,-188.3 -21.3,-255.1 -8.5,-14.1 -18.6,-22.7 -31,-33.2 -34.4,-35.8 -82.3,-42.8 -130.7,-43.8 l -98.4,2.4 79.1,112.9 -15.4,67.9 30.8,39.3 c 13,84.8 34.7,123.2 -11.7,197.4 21.2,81.6 16.1,104.4 -6.1,182.5",
    style: {
      fill: "#7b561c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path399",
    d: "m 30565.1,8171.2 40.8,98 53.5,14.3 264,-42.9 c 27.6,-70.1 24.2,-73.4 0.5,-145.8 l -19,-38.5 c 17.6,-196.1 95.2,-365 249.3,-492.2 252.6,-208.5 605.3,-306.5 929.6,-270.4 l 75.5,14.2 1.4,-56.9 48.9,-178.6 25.4,-38.4 16.6,-2.8 c 54.7,-48.1 96,-78.8 174.1,-71.6 l 20.8,2.4 98.4,-2.4 c 48.4,1 96.3,8 130.7,43.8 l 1363.8,7.1 c -41.3,-70.9 -189,-129.7 -268.4,-150.4 l -34,-7.9 c -69.8,-61.2 -169,-89.8 -253,-127.8 -773,-349.4 -1718.4,-493.4 -2563.7,-520.8 -39.9,53.1 -16.4,95 -59.9,148.7 -67.9,22 -181.4,6.5 -254.7,5.6 0,95.4 16.8,174.2 -37.6,255 8.8,10.1 18.3,19.8 24.6,31.9 16.9,32.3 7.6,96.6 7.1,134.3 -1.7,129.4 14,298.4 -28.1,420 29.8,77 19.8,167.5 20.1,249.1 0.9,181.5 37.8,465.8 -21.8,627.8 4.9,36.8 3.4,59 -4.9,95.2",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "m 31062.4,7048 c 267.4,-22.6 541.2,-16.6 809.9,-20.3 106.2,-1.5 262.5,-22.7 362.7,6.3 l 16.6,-2.8 c 54.7,-48.1 96,-78.8 174.1,-71.6 l 20.8,2.4 98.4,-2.4 c 48.4,1 96.3,8 130.7,43.8 l 1363.8,7.1 c -41.3,-70.9 -189,-129.7 -268.4,-150.4 l -34,-7.9 c -38.6,24.6 -1228,-13.1 -1397.2,-11.8 -266.3,2 -543,-1.7 -806,43.3 -167.8,28.7 -321.2,85.5 -471.4,164.3",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path401",
    d: "m 30565.1,8171.2 40.8,98 53.5,14.3 264,-42.9 c 27.6,-70.1 24.2,-73.4 0.5,-145.8 l -19,-38.5 c 17.6,-196.1 95.2,-365 249.3,-492.2 252.6,-208.5 605.3,-306.5 929.6,-270.4 l 75.5,14.2 1.4,-56.9 48.9,-178.6 25.4,-38.4 c -100.2,-29 -256.5,-7.8 -362.7,-6.3 -268.7,3.7 -542.5,-2.3 -809.9,20.3 l -490.7,151.1 c 29.8,77 19.8,167.5 20.1,249.1 0.9,181.5 37.8,465.8 -21.8,627.8 4.9,36.8 3.4,59 -4.9,95.2",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "m 30565.1,8171.2 40.8,98 53.5,14.3 264,-42.9 c 27.6,-70.1 24.2,-73.4 0.5,-145.8 l -19,-38.5 c -74,-31.4 -258.7,-2 -334.9,19.7 4.9,36.8 3.4,59 -4.9,95.2",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path403",
    d: "m 32159.3,10681.8 c 115,0.8 234.9,14.1 348.7,6.2 251.1,-17.5 485.3,-134.6 661.9,-312.5 96.5,-97 191.5,-226.7 243.3,-353.7 l -3.7,-34.2 c -144.8,-86.8 -270.8,-202.3 -417.4,-289.9 -474.8,-283.8 -1040.9,-496.3 -1188.9,-1092.8 -52.8,-212 -18.6,-458 -234.2,-587.1 -117.3,-70.3 -337.1,-52.5 -462.9,-14.7 -64.4,19.3 -124.5,57.7 -182.2,91.7 23.7,72.4 27.1,75.7 -0.5,145.8 86,-0.2 138.8,22 215,60 l 120.9,-43.2 c 36.4,35.8 68.1,65 89.4,112.6 -47.2,92.2 -500.2,346.2 -613.1,415.7 23,11.7 39.6,19.8 54.2,41.7 l 9.8,16.1 c 133.1,211.9 343.2,309.5 577.1,363.7 2.2,92.4 21,215.2 -27.8,296.7 40.8,71 35.4,152.1 51,230.8 51.6,257.8 164.7,475.7 331.5,677.4 l -9.6,41.3 40.8,9.1 c 54.7,18.6 233,133.1 256.7,176.6 l 81.1,22 58.9,20.7",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "m 31350.4,9056.8 c 53,8.7 117.7,25.6 169.2,5.8 36.4,-14 64.7,-49.4 77.9,-85.7 22.3,-61.2 17.4,-126.6 -15.4,-183.3 -35.6,-61.8 -96.4,-85.8 -161.6,-104.3 -41.1,-14.6 -82.3,-6.6 -124.6,-2.6 -52,43 -70.8,58.1 -96.5,122.8 14.9,126 58.6,168.7 151,247.3",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path405",
    d: "m 32137.5,10522 c 55.7,4.2 121.2,12.6 174.2,-8.1 53.2,-20.9 112.6,-68.9 131.6,-124.5 24.4,-70 10.8,-150.5 -22.9,-215.4 -45.2,-86.7 -120,-139.5 -212.3,-166.2 -35.6,-9.8 -80.3,-15.7 -117,-10.6 -52.7,7.5 -103.3,37.7 -133.1,82.2 -39.1,58.6 -41.3,142.5 -26.6,209.6 24.7,114.7 112.4,175.3 206.1,233",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "m 9444.84,5310 743.26,-84 2429.2,-219.5 c 157.2,-242 321.9,-485.8 512.8,-703 663.3,-754.5 1495.1,-1236.8 2474.8,-1444.2 630.5,-133.4 1239,-103.5 1868.4,14.3 l 325,-255.6 15.5,-7 c 251.8,-169.3 502.3,-334.3 776.2,-466.3 l 318.4,-142.3 c 73.6,-29.9 159.5,-54.3 224.6,-99 -727.5,-353.8 -1508,-565.3 -2313.2,-643.5 l -458.3,-31.9 -499.6,-1.1 c -77.9,0.3 -165.6,13.5 -233.7,-24.7 -834.8,177.7 -1691.4,456 -2457.8,833.7 l -689.6,354.5 c -158.4,85.1 -326.8,194.4 -499,246.9 -210.2,126.5 -470.5,204 -697.5,299.7 -474,199.8 -812.3,572.2 -1146.8,948 -309.94,439.6 -619.63,876.5 -692.66,1425",
    style: {
      fill: "#59c2ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path407",
    d: "m 9444.84,5310 743.26,-84 c 129.6,-323.1 315.2,-617.5 521.6,-896.5 625.4,-845.1 1497.8,-1488 2462,-1899.8 1319.5,-563.5 2772.8,-582.7 4105,-48 l 521.6,236.3 15.5,-7 c 251.8,-169.3 502.3,-334.3 776.2,-466.3 l 318.4,-142.3 c 73.6,-29.9 159.5,-54.3 224.6,-99 -727.5,-353.8 -1508,-565.3 -2313.2,-643.5 l -458.3,-31.9 -499.6,-1.1 c -77.9,0.3 -165.6,13.5 -233.7,-24.7 -834.8,177.7 -1691.4,456 -2457.8,833.7 l -689.6,354.5 c -158.4,85.1 -326.8,194.4 -499,246.9 -210.2,126.5 -470.5,204 -697.5,299.7 -474,199.8 -812.3,572.2 -1146.8,948 -309.94,439.6 -619.63,876.5 -692.66,1425",
    style: {
      fill: "#4190d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "m 10710.5,10441.7 34.3,25.3 c 38.5,-7.2 68.5,-2.7 91.6,-35.9 128.9,-185.3 190.9,-421.2 319,-606.4 l 10.5,-10.9 c 112,0 324.9,25.5 423.6,-14.1 -26.5,-107.6 -68,-291.3 -9.8,-393.1 l 25.9,-38.5 c 115.3,-20 255.5,-10 372.5,-2.3 l 14.8,-307.3 4.2,-83.5 676.8,1.2 540.1,-1.6 899.6,2.2 c 89.9,2.9 198.4,-87.1 283,-124.8 l 858,-2003 40.4,-93.5 c 67.3,-151.1 130,-379.1 227.8,-507.3 l 624.5,-66.2 234.6,664.9 245.5,735.7 c 80.7,30.4 155.6,8 234,-2.5 58,-7.7 106.3,7 153.5,39 l 4.2,60.2 15.3,75.1 c 64.3,-56.7 35.1,-61.8 66.4,-130.8 13,-54.8 22.5,-115 46.6,-166 l 178,-632.4 1943.1,-10.4 c 58.2,15.9 113.2,29.6 166.6,58.7 l 142,-61.2 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 l 4,13.1 1.8,252.5 353.1,-1 c 253.8,-0.3 402.7,-21.1 605.1,149 l 41.6,-2.9 32.2,-62.4 111.1,-16.5 18.8,-1.8 c 81,-7.3 456.7,10.5 481.1,-27 l 15.8,-40.1 4.8,-5 -42.7,-16.4 1.6,-3274.1 c -89,41.1 -301.5,5.4 -393.3,-28.9 l -13.2,-5.3 -26.4,-18.4 -3.8,-206.2 c -108.2,-19.3 -323.1,-66.5 -396.6,-145.5 -9.9,-55.1 -13.5,-56.3 16.3,-102.8 159.7,-100.7 424.7,-117.6 611.2,-139.8 560.7,-66.9 1126.3,-76 1689.7,-106.5 l 2276.6,-119.9 1245.1,-112.2 c -414.2,-75.9 -843.9,-85 -1263.5,-115.5 l -2335,-126.9 -953.6,-18.4 -4632.6,-89.8 -1705,65.5 -1731.2,77.3 -4099.73,379.6 -4632.89,722 -1287.17,241.5 -892.17,187.8 c -143.54,23.3 -283.02,76.7 -423.75,113.8 -35.37,48.8 -62.96,103.4 -92.28,156 34.35,284.8 146.19,419.5 337.13,623.4 -107.54,207.6 -186.48,417.3 -241.78,644.4 l -18.89,70.1 76.98,34.8 c 136.06,62.4 328.74,47.9 478.11,54.3 129.52,5.5 255.57,22.7 383.09,45.6 97.6,28.3 186.76,57 268.24,119.7 292.91,225.3 383.96,629.2 698.05,856 308.52,222.7 662.74,254.9 1002.59,394 168.92,69.1 317.09,171.5 462.51,279.9 107.88,-346.2 122.22,-625.8 63.5,-984.1 127.98,-55.6 265.34,-110.4 376.22,-196.3 50.56,-51.2 93.11,-86.6 161.66,-113.3 l 9.97,1.3 7.01,92.6 c 9.11,6.4 16.73,15.8 27.35,19.3 31.24,10.1 137.21,-12.5 178.81,-14.3 l 604.53,-10.4 c 57.27,-1.8 170.48,-22.7 216.61,5.4 l 0.3,67.8 5.73,27.3 5.48,-33.9 2571.29,-6.4 707.4,1394.2",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path409",
    d: "m 20599.7,5618.1 57,-22.9 10.4,-109.8 -83.3,-70.6 c -19.2,-0.7 -41.9,22.5 -57.7,33.9 0.8,61.2 43.7,117.5 73.6,169.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "m 20914.5,5598 c 23.4,-10.5 16.3,-6.2 35.6,-18.7 55.1,-35.7 48.6,-48.8 63,-112.3 22.9,-11.8 30.4,-15.5 46.6,-36.6 l -59.7,-20.7 c -41.8,-18.2 -60.5,-20.1 -105.3,-10.8 -19.9,4.1 -20.5,15.1 -31,31.5 7.6,65.4 18.7,108.8 50.8,167.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path411",
    d: "m 5622.82,6952 83.14,-12.6 c 45.84,-39.2 52.44,-40.3 63.04,-98.8 l -76.32,-92.2 c -74.42,12.3 -81.53,16.1 -135.73,68.6 1.2,57.6 32.92,90.9 65.87,135",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "m 18153.5,6026.5 c -28.4,35.2 -53.9,67.9 -93.1,91.9 -19.7,12.1 -23.8,11.6 -35.8,32.4 l 87.5,24.2 c -5.9,45.8 -59,65.6 -87.5,102.1 l 103.6,6.7 -28.7,80.7 25.9,26.7 91.5,-35.8 v 53.2 l 64.2,-21.8 c 23.1,15.3 36.6,16.3 64.1,17 2.7,-43.5 24,-63.2 51.3,-94.3 l 21.9,8.9 c -1.1,37.9 1.6,76.6 -21.7,108.5 -15.9,21.9 -19.5,30.5 -24.3,56.6 42.5,10.3 70.8,-43.3 119.3,-49.2 4.5,47.2 3.5,93.2 34.4,131.6 l 89.2,-147.2 71.1,128.9 h 20.2 c 12.2,-36.9 18.3,-71.2 23.2,-109.7 l 119.1,55.3 13.5,-18.8 -77.6,-88.9 9.4,-25.4 125.5,-14 c -27.7,-28.9 -67.7,-63.1 -77.2,-103.2 l -3.9,-20.8 c -51.9,-18.7 -94.3,-26.1 -149.4,-27.3 -21,27.8 -26.1,45 -33,78.1 -22,4.9 -38.3,15.5 -58.6,3.3 -19.4,-11.6 -53,-52.6 -69.3,-58.1 -6.7,-2.2 -52.9,11.2 -54.9,9.2 -11.8,-11.6 -12.3,-30.6 -18.5,-46 l -63.6,27.5 c -42.1,18.8 -80.9,26.5 -126.9,18.2 1,-23.5 3.1,-45.2 7.5,-68.3 l 82.3,-7.3 3.6,-19.4 c 5.2,-23.6 12.6,-39.6 23.8,-60.6 l -94.6,-11.5 c -18.7,-2.2 -33.1,-6 -50.5,-12.9 -26.8,-10.5 -54.8,-15 -83,-20.5",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path413",
    d: "m 18153.5,6026.5 c 28.2,5.5 56.2,10 83,20.5 17.4,6.9 31.8,10.7 50.5,12.9 l 94.6,11.5 c -11.2,21 -18.6,37 -23.8,60.6 l -3.6,19.4 -82.3,7.3 c -4.4,23.1 -6.5,44.8 -7.5,68.3 46,8.3 84.8,0.6 126.9,-18.2 l 63.6,-27.5 c 6.2,15.4 6.7,34.4 18.5,46 2,2 48.2,-11.4 54.9,-9.2 16.3,5.5 49.9,46.5 69.3,58.1 20.3,12.2 36.6,1.6 58.6,-3.3 6.9,-33.1 12,-50.3 33,-78.1 55.1,1.2 97.5,8.6 149.4,27.3 l 92.7,-24 5.5,-21.8 -112.3,-104.9 12,-16.9 c 16.9,-24.4 11.1,-14.2 21.6,-42 l -115.8,-44.1 c -13.7,-55.9 -40.1,-85.8 -93.6,-112.4 -44.6,-22.2 -125.4,-12.3 -175.3,-11.1 l -36.6,31.7 c -80.6,-28 -125.1,-35.6 -206.9,-1 l -24.3,12.7 11.3,27.4 26.6,11 c -43.3,20.8 -87.8,38.6 -123.4,71.5 l 33.4,28.3",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "m 20705.8,6950.4 9.7,-10.4 c 58.2,-64.6 60.1,-69.3 144.8,-85.8 -59.2,-99.9 -129.8,-130.9 -241.1,-159.2 -326.5,-83 -674.9,-74.8 -1005.7,-26.8 -90.4,13.2 -208.7,26.2 -289.5,71.8 -34.7,19.7 -39.5,40.9 -55.5,74.8 58.2,15.9 113.2,29.6 166.6,58.7 l 142,-61.2 52,-27.9 192.6,-13.9 93.1,-5.2 56.6,1.7 c 250.4,8.1 551.6,-11.5 734.4,183.4",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path415",
    d: "m 7763.23,6764.1 c -61.45,-14.4 -144.34,4.1 -207.18,10.1 -182.64,17.3 -414.79,28.8 -580.48,109.3 -48.89,23.7 -89.9,52 -108.12,103.7 l 23.93,36.6 c 155.68,94 323.84,126.6 499.81,159.4 l 33.61,-37.5 6.54,-66.9 c 112.79,-22.9 245.07,-11.6 360.52,-12.2 72.61,-0.4 161.24,-10 231.49,6.8 l 39.46,-23 86.1,10.4 4.51,-19.2 c -114.69,-109.9 -253.66,-197.2 -390.19,-277.5",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "m 8716.51,7067.7 38.56,-13.8 833.66,0.7 415.27,-2.2 21.5,-43.2 -127.3,-262.8 -39.96,-62.1 -1694.58,47.8 c -110.93,-6.6 -300.66,-16.4 -400.43,32 136.53,80.3 275.5,167.6 390.19,277.5 127.54,41.7 364.84,38.3 495.27,7.6 l 67.82,18.5",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path417",
    d: "m 8153.42,7041.6 c 127.54,41.7 364.84,38.3 495.27,7.6 l -485.03,-317.1 c -110.93,-6.6 -300.66,-16.4 -400.43,32 136.53,80.3 275.5,167.6 390.19,277.5",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "m 6626.53,7914.2 797.48,32.2 1.62,-399.1 -2578.92,-244 c -243.3,-49.7 -506.98,-66.4 -753.93,-98.4 -340.68,-44.1 -708.89,-116.2 -1052.04,-115.9 -67.78,0.1 -129.67,9.6 -192.34,36.4 -36.61,51.2 -30.87,54.7 -22.83,118.2 43.08,56.3 87.09,83 147.44,116.5 191.68,-98.6 853.31,130.4 1106.39,79.4 30.45,-19.2 58.12,-40.9 94.91,-44.5 l 176.14,11.3 0.49,32.5 c 157.02,74.1 359.15,11.8 498.78,139.6 l 23.86,-38.6 379.3,19.3 c 196.75,-4.7 396.73,12.9 593.81,16.6 137.87,2.6 323.83,-15.9 455.84,17.4 161.95,41 241.33,190.6 324,321.1",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path419",
    d: "m 4849.72,7578.4 23.86,-38.6 83.24,-109.7 c -7.04,-36.5 -16.81,-52 -38.52,-80.7 l -83.16,-18.5 -22.94,11.5 33,29.4 c -109.54,-1.4 -216.95,12.4 -325.08,12.2 -116.57,-0.2 -230.55,-12.6 -345.81,11 l 176.14,11.3 0.49,32.5 c 157.02,74.1 359.15,11.8 498.78,139.6",
    style: {
      fill: "#6b451a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "m 2423.96,8338.1 25.95,26.9 16.48,-13.2 c 437.89,-348.1 1233.37,-443.5 1774.16,-394.7 14.43,1.3 26.94,4.9 40.78,8.8 11.43,41.2 33.03,80.7 51.15,119.4 119.7,-11.7 264.55,-31.1 383.74,-13.9 l 41.84,-218 91.66,-275 c -139.63,-127.8 -341.76,-65.5 -498.78,-139.6 l -0.49,-32.5 -176.14,-11.3 c -36.79,3.6 -64.46,25.3 -94.91,44.5 -253.08,51 -914.71,-178 -1106.39,-79.4 -131.91,101.7 -211.46,197.7 -307.27,333.6 -107.54,207.6 -186.48,417.3 -241.78,644.4",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path421",
    d: "m 4273.35,7932.5 -7.26,-201.8 c -1.46,-81.2 -16.61,-174.3 38.71,-239.9 l 12.63,-15.2 33.51,-36.8 -0.49,-32.5 -176.14,-11.3 c -36.79,3.6 -64.46,25.3 -94.91,44.5 l 193.95,493",
    style: {
      fill: "#692816",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "m 4332.48,8085.3 c 119.7,-11.7 264.55,-31.1 383.74,-13.9 l 41.84,-218 91.66,-275 c -139.63,-127.8 -341.76,-65.5 -498.78,-139.6 l -33.51,36.8 -12.63,15.2 c -55.32,65.6 -40.17,158.7 -38.71,239.9 l 7.26,201.8 7.98,33.4 c 11.43,41.2 33.03,80.7 51.15,119.4",
    style: {
      fill: "#ac601e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path423",
    d: "m 4758.06,7853.4 91.66,-275 c -139.63,-127.8 -341.76,-65.5 -498.78,-139.6 l -33.51,36.8 -12.63,15.2 c -55.32,65.6 -40.17,158.7 -38.71,239.9 117.16,-4.6 271.79,-14.3 382.62,26.1 65.55,23.9 82.41,35.9 109.35,96.6",
    style: {
      fill: "#7b561c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "m 15930.5,5375.8 58.9,68 816.8,294.8 c 48.6,17.8 163.2,77.1 210.7,76.9 5.9,0 33.8,-11.7 35,-12.2 119.8,-54.4 240.5,-141.6 355.7,-207.4 38.1,-21.8 114.6,-51.7 142.5,-80 22.9,-23.2 42.4,-90.6 54.5,-122.1 l 44.5,-9.3 34.5,27.6 -94.3,360.5 c 645.8,-30.1 1295.2,-45.1 1934.3,-146.4 194.9,-30.9 410.2,-56.1 589.7,-140.8 l 19,-27.5 c -68.6,-84.1 -277.3,-97.3 -383.8,-107.8 -975.4,-96.7 -1979.7,-66.7 -2958.7,-44.7 -182,4.1 -729.1,-14.1 -859.3,70.4",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path425",
    d: "m 17034.4,7754.4 c 64.3,-56.7 35.1,-61.8 66.4,-130.8 13,-54.8 22.5,-115 46.6,-166 l 178,-632.4 263.9,-1052.6 94.3,-360.5 -34.5,-27.6 -44.5,9.3 c -12.1,31.5 -31.6,98.9 -54.5,122.1 -27.9,28.3 -104.4,58.2 -142.5,80 -115.2,65.8 -235.9,153 -355.7,207.4 -1.2,0.5 -29.1,12.2 -35,12.2 -47.5,0.2 -162.1,-59.1 -210.7,-76.9 l -816.8,-294.8 -58.9,-68 c -33.6,-8 -35.8,-5.1 -67.9,8.8 l -10.3,63.2 c 60.1,56.1 78.3,150.4 106.4,226.3 l 188.6,507.9 234.6,664.9 245.5,735.7 c 80.7,30.4 155.6,8 234,-2.5 58,-7.7 106.3,7 153.5,39 l 4.2,60.2 15.3,75.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "m 17227,5830.1 15.3,-3 c 76.5,-14.8 171.6,-6.8 241.9,-34.5 l 62.3,-201.5 -348.3,215.9 28.8,23.1",
    style: {
      fill: "#34702f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path427",
    d: "m 17198.2,5807 c -25.5,18.2 -53.5,33.4 -66.7,63 89.4,63.4 196.4,110.2 293.8,160.9 l 57.9,-196.6 -264.6,19.7 8.4,-23.9 -28.8,-23.1",
    style: {
      fill: "#acda22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "m 16540.4,6997.7 605.9,-37.5 -279.7,-148.5 c -113.3,39.5 -223.7,122.9 -326.2,186",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path429",
    d: "m 17186.4,6885.3 c 52.1,-32.8 101.3,-297.8 121.5,-374.6 l -156.1,98.2 -218.6,144.6 253.2,131.8",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "m 16509.1,6916.5 288.1,-162.9 -259.7,-143.5 -183.2,-113.5 154.8,419.9",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path431",
    d: "m 16996.1,7492.9 50.5,-8.7 117.8,-379.3 -164.8,89.3 -274.9,159.9 271.4,138.8",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "m 16463.1,6257.4 c 27.6,6.5 58.4,13.5 86.9,10.3 71.6,-7.8 154.3,-45.6 226.6,-62.2 135.2,-31 362.3,-43.4 479.6,-115.8 21.6,-13.3 39,-34.9 54.3,-54.8 l -286.3,-124.3 -561.1,346.8",
    style: {
      fill: "#74c82c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path433",
    d: "m 16277.8,6271 c 180.9,-93.6 426.4,-209.5 572.9,-346.1 l -69.1,-13.1 -611.3,43.3 107.5,315.9",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "m 16540.4,6997.7 c 28.3,108.1 61.5,208.9 105.2,311.8 l 519.2,-293.3 4.9,-29 -23.4,-27 -605.9,37.5",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path435",
    d: "m 16144.9,5897.5 763.2,-28.3 -43.2,-21.3 -273.6,-107.4 -591.6,-232.3 145.2,389.3",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "m 16463.1,6257.4 -175.4,95.2 c 166,148.3 382.2,252.4 574.6,362.6 l 345.8,-233.6 c 32.8,-23.3 94.5,-55.9 119.5,-85.6 33.8,-40 64.3,-227.8 81.3,-287.9 -22.7,-41.9 -57.5,-51.6 -98.4,-73.2 -15.3,19.9 -32.7,41.5 -54.3,54.8 -117.3,72.4 -344.4,84.8 -479.6,115.8 -72.3,16.6 -155,54.4 -226.6,62.2 -28.5,3.2 -59.3,-3.8 -86.9,-10.3",
    style: {
      fill: "#99d424",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path437",
    d: "m 20707.6,9909.1 41.6,-2.9 32.2,-62.4 111.1,-16.5 18.8,-1.8 c 81,-7.3 456.7,10.5 481.1,-27 l 15.8,-40.1 4.8,-5 -42.7,-16.4 -1.9,-18.1 -3,-2878.4 c -133.7,10.8 -383.1,61 -505.1,13.7 -84.7,16.5 -86.6,21.2 -144.8,85.8 l -9.7,10.4 c -182.8,-194.9 -484,-175.3 -734.4,-183.4 l -56.6,-1.7 -93.1,5.2 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 l 4,13.1 1.8,252.5 353.1,-1 c 253.8,-0.3 402.7,-21.1 605.1,149",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "m 20707.6,9909.1 41.6,-2.9 32.2,-62.4 111.1,-16.5 c -58.5,-210.8 -114.5,-423.6 -202.2,-624.6 -121.7,-278.9 -293.6,-528.3 -480.8,-766.4 l -107,1323.8 c 253.8,-0.3 402.7,-21.1 605.1,149",
    style: {
      fill: "url(#linearGradient439)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "m 19749.4,9761.1 353.1,-1 107,-1323.8 c 39.1,-430.6 39.5,-932.6 177.6,-1340.1 l 20,-1.4 c 87.2,-6.7 218.7,-24.1 276.4,-97.4 11.5,-14.5 16.4,-29.6 22.3,-47 -182.8,-194.9 -484,-175.3 -734.4,-183.4 l -56.6,-1.7 -93.1,5.2 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 l 4,13.1 1.8,252.5",
    style: {
      fill: "url(#linearGradient441)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "m 19822.8,7023.4 22.5,226.7 66.2,23.8 3.3,-508.6 -93.1,5.2 1.1,252.9",
    style: {
      fill: "#a99b9a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path443",
    d: "m 19860.1,9564.5 c 7.5,57.9 14.7,113.7 31.6,169.9 l 19.8,-2460.5 -66.2,-23.8 -22.5,-226.7 -1.1,-252.9 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2 19.4,596.5 c 41.9,176 11.1,376.2 34.3,558.5 3.9,-71.5 -1,-175.5 23.4,-241.7 25.7,-70.1 15.7,-167.4 16.1,-242.8 l 18.3,-9.2 4.6,311.5 c 27.9,-108.3 17.6,-244.7 21.6,-357.2 l 32.5,608.4",
    style: {
      fill: "url(#linearGradient444)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)",
    clipPath: "url(#clipPath444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "m 19689.9,8340.5 c 48.2,49.3 19.5,100.5 39.5,162.9 32.4,100.8 -6.9,221.4 22.3,327 9.9,36 7.5,79.3 8.5,116.6 -0.8,-87 30.2,-272.5 4.6,-348.1 -28.1,-82.8 -25.6,-212 -9.6,-302.8 l 36.5,86.8 31.1,-1359.5 -1.1,-252.9 -192.6,13.9 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path446",
    d: "m 19689.9,8340.5 c 48.2,49.3 19.5,100.5 39.5,162.9 32.4,100.8 -6.9,221.4 22.3,327 9.9,36 7.5,79.3 8.5,116.6 -0.8,-87 30.2,-272.5 4.6,-348.1 -28.1,-82.8 -25.6,-212 -9.6,-302.8 28.1,-83.1 1.7,-176.6 -4.6,-262.7 l -97.6,-872.2 -23.9,-376.8 -52,27.9 22.5,323.4 57.5,917.6 32.8,287.2",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path447",
    d: "m 7431.81,9053.9 2571.29,-6.4 2.7,-157 -1.8,-1838.1 -415.27,2.2 -833.66,-0.7 -38.56,13.8 -67.82,-18.5 c -130.43,30.7 -367.73,34.1 -495.27,-7.6 l -4.51,19.2 -86.1,-10.4 -39.46,23 c -70.25,-16.8 -158.88,-7.2 -231.49,-6.8 -115.45,0.6 -247.73,-10.7 -360.52,12.2 l -6.54,66.9 c 21.17,201.5 7.18,417.3 6.91,620.5 l 0.46,1132.2 -0.36,155.5",
    style: {
      fill: "#a9aba7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "m 7431.81,9053.9 2571.29,-6.4 2.7,-157 -2573.63,7.9 -0.36,155.5",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path449",
    d: "m 9141.77,8552.6 7.5,-1489.2 c 143.42,-1.2 297.63,8.3 439.46,-8.8 l -833.66,-0.7 6.06,1487.4 364.16,9.2 16.48,2.1",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path450",
    d: "m 8039.24,8570 833.8,-4.4 c 87.32,-4.5 183.35,3.5 268.73,-13 l -16.48,-2.1 -364.16,-9.2 -6.06,-1487.4 -38.56,13.8 -67.82,-18.5 c -130.43,30.7 -367.73,34.1 -495.27,-7.6 l -4.51,19.2 -86.1,-10.4 -39.46,23 c -24.84,250.3 -4.67,520.5 -4.25,772.7 0.36,224.7 -31.22,506.3 20.14,723.9",
    style: {
      fill: "#464346",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path451",
    d: "m 8039.24,8570 c 40.23,-38.2 37.27,-36 38.76,-93.6 l 1.66,-959.3 c -0.44,-142.3 22.4,-332.7 -16.85,-466.7 l -39.46,23 c -24.84,250.3 -4.67,520.5 -4.25,772.7 0.36,224.7 -31.22,506.3 20.14,723.9",
    style: {
      fill: "#282826",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path452",
    d: "m 8149.66,8479.5 569.34,-0.3 -0.68,-589.2 -570.46,-0.2 1.8,589.7",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path453",
    d: "m 8148.91,7060.8 -7.65,798.8 576.23,-0.6 -0.98,-791.3 -67.82,-18.5 c -130.43,30.7 -367.73,34.1 -495.27,-7.6 l -4.51,19.2",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path454",
    d: "m 5774.64,10192.5 c 107.88,-346.2 122.22,-625.8 63.5,-984.1 127.98,-55.6 265.34,-110.4 376.22,-196.3 50.56,-51.2 93.11,-86.6 161.66,-113.3 l 9.97,1.3 7.57,-10 c 49.95,-64.5 111.96,-120.1 158.87,-186.5 116.46,-164.7 155.75,-349.4 131.97,-548.6 l -5.11,-37.5 -52.76,-203.3 c -82.67,-130.5 -162.05,-280.1 -324,-321.1 -132.01,-33.3 -317.97,-14.8 -455.84,-17.4 -197.08,-3.7 -397.06,-21.3 -593.81,-16.6 l -379.3,-19.3 -23.86,38.6 -91.66,275 -41.84,218 c -119.19,-17.2 -264.04,2.2 -383.74,13.9 -18.12,-38.7 -39.72,-78.2 -51.15,-119.4 -13.84,-3.9 -26.35,-7.5 -40.78,-8.8 -540.79,-48.8 -1336.27,46.6 -1774.16,394.7 l -16.48,13.2 -25.95,-26.9 -18.89,70.1 76.98,34.8 c 136.06,62.4 328.74,47.9 478.11,54.3 129.52,5.5 255.57,22.7 383.09,45.6 97.6,28.3 186.76,57 268.24,119.7 292.91,225.3 383.96,629.2 698.05,856 308.52,222.7 662.74,254.9 1002.59,394 168.92,69.1 317.09,171.5 462.51,279.9",
    style: {
      fill: "#44ba3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path455",
    d: "m 4332.48,8085.3 -4.25,23.9 c -11.19,56.4 -43.84,105.4 -60.94,160 -44.26,141.4 -6.52,288.1 71.41,409.5 113.84,177.2 306.76,301.5 511.24,344.3 219.2,45.8 453.38,9.1 642.51,-114 154.38,-100.5 256.69,-279.7 288.96,-458.9 28.77,-159.9 -24.5,-296.2 -71.05,-445.4 322.66,-7 634.62,22.3 938.96,138 l 29.97,-25.2 -52.76,-203.3 c -82.67,-130.5 -162.05,-280.1 -324,-321.1 -132.01,-33.3 -317.97,-14.8 -455.84,-17.4 -197.08,-3.7 -397.06,-21.3 -593.81,-16.6 l -379.3,-19.3 -23.86,38.6 -91.66,275 -41.84,218 c -119.19,-17.2 -264.04,2.2 -383.74,13.9",
    style: {
      fill: "#57a634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    d: "m 4759.4,8098.5 c 149.33,-70.8 267.7,-76 429.98,-76 168.35,-24.5 339.24,-21.7 508.98,-23.6 C 5634.99,7773 5419.6,7690 5252.88,7559.1 l -379.3,-19.3 -23.86,38.6 -91.66,275 -41.84,218 43.18,27.1",
    style: {
      fill: "#3b9138",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path457",
    d: "m 4759.4,8098.5 -49.63,66.8 c -40.88,57.8 -56.88,112.1 -80.42,177.2 -29.24,80.8 -20.25,203 17.02,280.7 50.68,105.6 132.91,191.3 246.6,228.9 88.54,29.2 212.71,27.7 294.33,-18.9 122.17,-69.8 207.51,-195.1 241.87,-330.3 27.87,-109.6 3.27,-224.7 -54.69,-320.6 -42.83,-70.8 -113.71,-120.4 -185.1,-159.8 -162.28,0 -280.65,5.2 -429.98,76",
    style: {
      fill: "#63b531",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "m 4966.78,8811.9 c 37.98,-0.6 74.45,-7.6 111.74,-14 48.5,-52.6 48.45,-54.1 51.31,-125.7 -30.43,-61.9 -78.45,-80.1 -137.16,-108.5 l -74.37,13.2 c -37.15,40.2 -77.64,67.4 -84.04,122.7 33.36,52.7 81.45,79.1 132.52,112.3",
    style: {
      fill: "#cce766",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path459",
    d: "m 9898.2,6746.4 2923.5,9.2 3,-11.8 2470.3,11.7 c 67.3,-151.1 130,-379.1 227.8,-507.3 l 624.5,-66.2 -188.6,-507.9 c -28.1,-75.9 -46.3,-170.2 -106.4,-226.3 -77.4,48.2 -1116.1,43.4 -1267.8,48.1 l -942.6,44.2 -2043.2,152.1 c -588,53.4 -1179.3,103.7 -1761.22,206.3 -83.85,14.8 -279.31,27.3 -338.05,81.4 l 43.92,67.6 314.89,636.8 39.96,62.1",
    style: {
      fill: "#59892e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "m 15550.5,6189.7 134.7,-268.6 -2276.3,-20.1 c -170.9,2.2 -427.2,-21.4 -589.1,25 l 22,43.9 c 287.7,35.6 592.5,16.5 882.9,20.3 349,4.5 707,37 1054,74.3 259.4,27.9 520.5,52.5 771.8,125.2",
    style: {
      fill: "#473f4f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path461",
    d: "m 12824.7,6743.8 2470.3,11.7 c 67.3,-151.1 130,-379.1 227.8,-507.3 l 27.7,-58.5 c -251.3,-72.7 -512.4,-97.3 -771.8,-125.2 -347,-37.3 -705,-69.8 -1054,-74.3 -290.4,-3.8 -595.2,15.3 -882.9,-20.3 -29.9,249.3 -19.3,523.1 -17.1,773.9",
    style: {
      fill: "#666770",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "m 9898.2,6746.4 2923.5,9.2 3,-11.8 c -2.2,-250.8 -12.8,-524.6 17.1,-773.9 l -22,-43.9 c -137.5,20.7 -291,12 -430.5,14.9 l -800.8,17.1 -2045.15,89.5 314.89,636.8 39.96,62.1",
    style: {
      fill: "#868e94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path463",
    d: "m 10710.5,10441.7 34.3,25.3 c 38.5,-7.2 68.5,-2.7 91.6,-35.9 128.9,-185.3 190.9,-421.2 319,-606.4 l 10.5,-10.9 c 112,0 324.9,25.5 423.6,-14.1 -26.5,-107.6 -68,-291.3 -9.8,-393.1 l 25.9,-38.5 c 115.3,-20 255.5,-10 372.5,-2.3 l 14.8,-307.3 4.2,-83.5 676.8,1.2 540.1,-1.6 899.6,2.2 c 89.9,2.9 198.4,-87.1 283,-124.8 l 858,-2003 40.4,-93.5 -2470.3,-11.7 -3,11.8 -2923.5,-9.2 127.3,262.8 -21.5,43.2 1.8,1838.1 -2.7,157 707.4,1394.2",
    style: {
      fill: "#ccd4d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "m 10847,8828 c 16.7,42.6 34.4,109.1 66.7,141.4 33.7,33.6 587.6,6.2 679.2,5.3 l 404.2,0.3 676.8,1.2 540.1,-1.6 899.6,2.2 c 89.9,2.9 198.4,-87.1 283,-124.8 -98.4,-65.8 -1366.8,-27 -1600.6,-25.2 l -776.1,-2.8 -802.4,-12.7 c -109.6,-1 -268.6,-23.4 -370.5,16.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path465",
    d: "m 10710.5,10441.7 34.3,25.3 c 38.5,-7.2 68.5,-2.7 91.6,-35.9 128.9,-185.3 190.9,-421.2 319,-606.4 l 10.5,-10.9 c 112,0 324.9,25.5 423.6,-14.1 -26.5,-107.6 -68,-291.3 -9.8,-393.1 l 25.9,-38.5 c 115.3,-20 255.5,-10 372.5,-2.3 l 14.8,-307.3 4.2,-83.5 -404.2,-0.3 c -91.6,0.9 -645.5,28.3 -679.2,-5.3 -32.3,-32.3 -50,-98.8 -66.7,-141.4 l -581.1,-1288.3 c -74.2,-168.2 -139.4,-378.9 -240.4,-530.5 l -21.5,43.2 1.8,1838.1 -2.7,157 707.4,1394.2",
    style: {
      fill: "#666770",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "m 11165.9,9813.8 c 112,0 324.9,25.5 423.6,-14.1 -26.5,-107.6 -68,-291.3 -9.8,-393.1 l 25.9,-38.5 c 115.3,-20 255.5,-10 372.5,-2.3 l 14.8,-307.3 4.2,-83.5 -404.2,-0.3 -326.2,595.9 c -38.6,73.8 -97.6,158.9 -100.8,243.2",
    style: {
      fill: "#697324",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path467",
    d: "m 14396.6,8852 858,-2003 40.4,-93.5 -2470.3,-11.7 -3,11.8 -25.7,2071.2 c 233.8,-1.8 1502.2,-40.6 1600.6,25.2",
    style: {
      fill: "#7d9ea9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,3333.3333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCer2);
export default __webpack_public_path__ + "static/media/cer2.94290d9ac8eda9b9d4539de48b0eb666.svg";
export { ForwardRef as ReactComponent };